import {
    AppButtonPopup,
    FlexColumn,
    FlexRow,
    FlexRowBetween,
    LoaderBar,
    AppRemoveButtonPopup,
    NumericStepper,
} from 'components'
import { useAuth, useResponses } from 'context'
import { useForm, Controller } from 'react-hook-form'
import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react'
import { Accordion, AccordionContent, AccordionTitle, Button, Card, CardContent, Checkbox, Divider, Form, Input, Label, Modal, Popup, Radio, Table, TextArea } from 'semantic-ui-react'
import { AppDropdown as Dropdown } from 'components/AppDropdown'
import styled, { createGlobalStyle } from 'styled-components'
import {
    AcceptFileType,
    ControlType,
    InspectionService,
    TemplateQuestionResponseType,
    TemplateResponseType,
    CommonUtility,
    cacheMediaUploadFiles,
    getQuestionMediaList,
    linkUploadedMediaCache,
    mapInspectionQuestionMediaFiles,
    clampManualScoreValue,
    hasParentChildAnswerSelection,
    getRemainingManualScore,
    applyParentChildResponseScores,
    getPressResetTarget,
    isPressDownEligible,
    isPressSelectionResetEnabled,
    getQuestionDisplayScore,
    isSectionNAAvailable,
    isSectionNASelected,
    ReasonPresetService,
    UNIFORM_RADIO_ANSWER_FIELD,
    getSectionUniformRadio,
    getUniformSelectedDisplayText,
    isFormulaQuestion,
} from 'utility'
import { FormulaResult } from './inspection/FormulaResult'
import {
    buildRotatedMediaItem,
    mergeLocalMediaState,
    replaceMediaItemInList,
} from 'utility/media-utility'
import {
    DateTimeFormFieldWithoutControl,
    SignatureFormField,
    Slider,
    TextAreaFormField,
    AppPrimaryButton,
    AppSecondaryButton,
} from 'elements'
import { useDebounce } from 'hooks'
import { useNotification } from 'hooks/toast'
import {
    ReasonPresetInspectionContext,
    ReasonPresetNotesPanel,
    activeReasonPresets,
    getReasonPresetErrorMessage,
    reasonPresetTransition,
    responseOptionKey,
    shouldOpenReasonPopup,
    useReasonPresetInspection,
} from 'page-components/reason-presets'
import {
    ArrowsIn,
    ArrowsOut,
    ArrowCounterClockwise,
    CaretDown,
    CaretUp,
    Copy,
    Plus,
    Trash,
    Eye,
    X,
} from 'phosphor-react'
import { FileUploadPicker } from 'components/FileUploadPicker'
import { DesktopMode, MobileMode, useTabletAndBelowMediaQuery } from 'layout'
import { CustomePreview, MediaTypeFilesBox } from './inspection/Elements'
import { useLocation, useNavigate } from 'react-router-dom'
import RaiseTicketModal from './inspection/RaiseTicketModal'
import { CreateMaintenanceFromFinding } from './maintenance/CreateMaintenanceFromFinding'
import { QuestionThreadSlot } from './question-threads/QuestionThread'
import { useQuestionThreads } from './question-threads/QuestionThreadsContext'
import { TitleText } from 'components/Text'
import { AutoNumberInspectionDisplay } from './inspection/AutoNumberInspectionDisplay'
import {
    isPortalCardSection,
} from './finish-mat/finish-mat-inspection-utils'

const InspectionListContainer = styled.div`
    .w-100 {
        width: 100% !important;
    }
    .sign-border {
        border: solid 1px;
    }
    .section-name {
        color: ${({ theme }) => theme.colors.white} !important;
        background-color: ${({ theme }) => theme.colors.primary} !important;
        overflow: visible !important;
        position: relative;
    }
    .section-name-imported {
        color: #FFFFFF !important;
        background-color: #808080 !important;
    }
    .accordion {
        overflow: visible;
        box-shadow: none !important;
        .outer-box {
            border: solid 0.5px;
            border-top: 0px;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }
    .section-option-item {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .section-option-details {
        display: flex;
        flex-direction: column;
        line-height: 1.2;
    }
    .section-option-title {
        font-weight: 600;
        color: ${({ theme }) => theme.colors.black};
    }
    .section-option-meta {
        font-size: 12px;
        color: #6d6d6d;
    }
    .section-dropdown-label {
        background: #f4f6fb;
        border-radius: 18px;
        padding: 4px 10px;
        font-size: 13px;
        font-weight: 600;
        color: #333;
        margin: 2px;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        .label-text {
            white-space: nowrap;
        }
    }
    .inspection-table-header {
        display: flex;
        width: 100%;
        padding: 10px 12px;
        margin-bottom: 0;
        background: #f4f6fb;
        border: 1px solid #e2e8f0;
        border-radius: 6px 6px 0 0;
        font-weight: 600;
        font-size: 13px;
        color: #334155;
    }
    .inspection-table-header-question {
        flex: 0 0 41.666%;
        max-width: 41.666%;
        padding-right: 12px;
    }
    .inspection-table-header-actions {
        flex: 0 0 58.334%;
        max-width: 58.334%;
        display: flex;
    }
    .inspection-table-header-media,
    .inspection-table-header-notes {
        flex: 1;
        padding: 0 8px;
    }
    .inspection-horizontal-row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        width: 100%;
        margin: 0;
    }
    .inspection-horizontal-question {
        flex: 0 0 41.666%;
        max-width: 41.666%;
        padding-right: 12px;
        border-right: 1px solid #e2e8f0;
    }
    .inspection-horizontal-actions {
        flex: 0 0 58.334%;
        max-width: 58.334%;
    }
    .inspection-table-row-card {
        margin-bottom: 0 !important;
        border-radius: 0 !important;
        border: 1px solid #e2e8f0 !important;
        border-top: 0 !important;
        box-shadow: none !important;
    }
    .inspection-table-row-card .card-content {
        padding: 12px !important;
    }
    .inspection-table-row-card:last-of-type {
        border-radius: 0 0 6px 6px !important;
    }
    .inspection-response-options-horizontal {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    .inspection-response-options-horizontal .response-option-item {
        margin-bottom: 0 !important;
    }
    .inspection-horizontal-grid {
        border: 1px solid #d7e0ea;
        border-radius: 8px;
        overflow: visible;
        background: #fff;
        position: relative;
        z-index: 1;
        width: max-content;
        min-width: 100%;
        table-layout: auto;
    }
    .inspection-horizontal-scroll {
        width: 100%;
        overflow-x: auto;
        overflow-y: visible;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 72px;
        margin-bottom: 12px;
    }
    .inspection-horizontal-grid thead th {
        background-color: ${({ theme }) => theme.colors.primary} !important;
        color: ${({ theme }) => theme.colors.white} !important;
        border-bottom: 2px solid ${({ theme }) => theme.colors.primary} !important;
        border-right-color: rgba(255, 255, 255, 0.12) !important;
        text-transform: uppercase;
        font-size: 12px !important;
        letter-spacing: 0.4px;
        white-space: nowrap;
        padding: 10px 8px !important;
    }
    .inspection-horizontal-grid td {
        vertical-align: top !important;
        overflow: visible !important;
        padding: 10px 8px !important;
        white-space: nowrap;
    }
    .inspection-horizontal-grid .row-label-cell {
        font-weight: 700;
        text-align: center;
        width: 48px;
    }
    .inspection-horizontal-grid .cell-question {
        min-width: 170px;
    }
    .inspection-horizontal-grid .cell-question .col-7,
    .inspection-horizontal-grid .cell-question .col-12,
    .inspection-horizontal-grid .cell-question .d-flex.flex-column {
        width: 100% !important;
        max-width: 100% !important;
        flex: 0 0 100% !important;
    }
    .inspection-horizontal-grid .cell-content-inline {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 6px;
        justify-content: flex-start;
    }
    .inspection-horizontal-grid .cell-answer-wrap {
        flex: 1 1 auto;
        min-width: 0;
    }
    .inspection-horizontal-grid .cell-media-wrap {
        flex: 0 0 auto;
        padding-top: 2px;
    }
    .inspection-horizontal-grid .cell-question .ui.input,
    .inspection-horizontal-grid .cell-question .ui.selection.dropdown,
    .inspection-horizontal-grid .cell-question .ui.form textarea {
        width: 100% !important;
    }
    .inspection-horizontal-grid .cell-question .react-datepicker-wrapper,
    .inspection-horizontal-grid .cell-question .react-datepicker__input-container,
    .inspection-horizontal-grid .cell-question .react-datepicker__input-container input,
    .inspection-horizontal-grid .cell-question input[type='number'],
    .inspection-horizontal-grid .cell-question input[type='text'] {
        width: 100% !important;
        max-width: 100% !important;
    }
    .inspection-horizontal-grid .cell-question .ui.dropdown .menu {
        min-width: 100% !important;
    }
    .inspection-horizontal-grid .ui.dropdown {
        z-index: 2;
    }
    .inspection-horizontal-grid .ui.selection.dropdown.active.visible {
        z-index: 10060 !important;
    }
    .inspection-horizontal-grid .ui.dropdown .menu {
        z-index: 12000 !important;
    }
    .inspection-horizontal-scroll .react-datepicker-popper {
        z-index: 12050 !important;
    }
`

const PressResetDropdownWrap = styled.div`
    flex: 1 1 auto;
    min-width: 0;

    .ui.dropdown {
        width: 100%;
    }
`

const PressResetIconButton = styled.button`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    padding: 0;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #fff;
    color: #374151;
    cursor: pointer;

    &:hover:not(:disabled) {
        background: #f9fafb;
    }

    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
`

const QuestionBox = styled.div`
    .notes {
        border-left: solid 1px;
        height: 100%;
        .form {
            width: 100%;
            height: 100%;
            textarea {
                height: 80%;
            }
        }
    }
    .error {
        color: #9f3a38 !important;
        input {
            background-color: #fff6f6 !important;
            border-color: #e0b4b4 !important;
            color: #9f3a38 !important;
        }
    }
    .question-tooltip-container {
        cursor: help;
        display: inline-block;
        width: 100%;
    }
    .additional-info-image {
        max-width: 300px;
        max-height: 300px;
        object-fit: contain;
    }
    .additional-info-container {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 8px;
    }
    .display-only-header {
        width: 100%;
        font-size: 1.08rem;
        font-weight: 700;
        color: #0b1f4a;
        padding: 10px 12px;
        border: 1px solid #bfdbfe;
        border-left: 5px solid #1d4ed8;
        background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%);
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(29, 78, 216, 0.1);
    }
    .display-only-label {
        font-size: 0.88rem;
        font-weight: 600;
        color: #0f766e;
        padding: 6px 12px;
        background: #f0fdfa;
        border: 1px solid #99f6e4;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        width: fit-content;
        max-width: 100%;
        box-shadow: 0 1px 2px rgba(15, 118, 110, 0.08);
        letter-spacing: 0.12px;
    }
    .display-only-label::before {
        content: '';
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #14b8a6;
        flex-shrink: 0;
    }

    /* Custom tooltip styling */
    .ui.popup {
        padding: 8px 12px;
        border-radius: 4px;
        font-size: 13px;
        border: 1px solid #ccc;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        background: white;
        color: #333;
        max-width: 250px;
        word-wrap: break-word;
        z-index: 1000;
    }
`
const NotesTextArea = styled(TextArea)`
    ${({ minHeight }) => minHeight && `min-height: ${minHeight}`}
`

const PortalSectionCard = styled.section`
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(26, 43, 75, 0.08);
    margin-bottom: 1rem;
    overflow: visible;
    position: relative;

    &:focus-within {
        z-index: 200;
    }
`

const PortalSectionCardHeader = styled.div`
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    padding: 0.55rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 700;
    font-size: 0.95rem;
    border-radius: 8px 8px 0 0;
`

const PortalSectionCardBody = styled.div`
    padding: 0;
    overflow: visible;
`

const PortalSectionFieldGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0;
    width: 100%;
    border: 1px solid #d8e0ea;
    border-radius: 0 0 6px 6px;
    overflow: visible;
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`

const PortalSectionFieldCell = styled.div`
    width: 100%;
    min-width: 0;
    padding: 1rem 1.25rem;
    border-right: 1px solid #d8e0ea;
    border-bottom: 1px solid #d8e0ea;
    box-sizing: border-box;
    overflow: visible;
    position: relative;

    &:has(.ui.dropdown.active),
    &:has(.ui.dropdown.visible) {
        z-index: 120;
    }

    &:nth-child(2n) {
        border-right: none;
    }

    /* Last row: drop bottom border on final cell(s) */
    &:last-child:nth-child(odd) {
        border-bottom: none;
    }

    &:nth-last-child(2):nth-child(odd),
    &:last-child:nth-child(even) {
        border-bottom: none;
    }

    @media (max-width: 768px) {
        border-right: none;

        &:nth-child(2n) {
            border-right: none;
        }

        &:last-child {
            border-bottom: none;
        }

        &:nth-last-child(2):nth-child(odd),
        &:last-child:nth-child(even) {
            border-bottom: 1px solid #d8e0ea;
        }

        &:nth-last-child(2) {
            border-bottom: none;
        }
    }
`

const PortalSectionCopyButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    padding: 0.15rem 0.35rem;
    border-radius: 4px;
    opacity: 0.92;

    &:hover:not(:disabled) {
        opacity: 1;
        background: rgba(255, 255, 255, 0.12);
    }

    &:disabled {
        opacity: 0.45;
        cursor: not-allowed;
    }
`

/** Claim-portal style: full-width inputs, no per-question card chrome. */
const PortalInspectionForm = styled(Form)`
    &&& {
        width: 100%;
    }

    .field {
        width: 100%;
        margin-bottom: 0 !important;
    }

    .ui.input,
    .ui.dropdown,
    .ui.selection.dropdown,
    textarea,
    .ui.selection.dropdown > .text {
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box;
    }

    .ui.selection.dropdown {
        min-width: 0 !important;
    }

    .ui.dropdown {
        width: 100%;
    }

    .ui.dropdown.active.visible {
        z-index: 130;
    }

    .ui.dropdown.active.visible .menu,
    .ui.dropdown.visible .menu {
        z-index: 1300 !important;
        max-height: 320px;
        overflow-y: auto;
        box-shadow: 0 4px 16px rgba(15, 23, 42, 0.14);
    }

    .portal-response-wrap,
    .portal-response-wrap .ui.form,
    .portal-response-wrap .flex-row,
    .portal-response-wrap > div {
        width: 100% !important;
        max-width: 100% !important;
    }

    .portal-response-wrap .col-7,
    .portal-response-wrap .col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        width: 100% !important;
        padding-left: 0;
        padding-right: 0;
    }

    .portal-response-wrap .ui.input,
    .portal-response-wrap .ui.input input {
        width: 100% !important;
    }

    label {
        color: #1f2937;
    }
`

const PortalQuestionLabel = styled.label`
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0.2rem 0.35rem;
    margin-bottom: 0.35rem;
    font-weight: 600;
    color: #1f2937;
    line-height: 1.35;

    .portal-question-number {
        flex-shrink: 0;
        white-space: nowrap;
    }

    .portal-question-text {
        flex: 1 1 auto;
        min-width: 0;
        font-weight: 600;

        p,
        div,
        span,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            display: inline;
            margin: 0;
            padding: 0;
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
        }

        br {
            display: none;
        }
    }
`

const PortalQuestionResponseRow = styled.div`
    width: 100%;
    min-width: 0;

    .portal-response-wrap,
    .portal-response-wrap .ui.form,
    .portal-response-wrap .ui.input,
    .portal-response-wrap .ui.input input {
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box;
    }
`

const PortalQuestionMediaNotesRow = styled.div`
    width: 100%;
    margin-top: 0.75rem;

    .portal-media-notes-row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 1rem;
        width: 100%;
    }

    .portal-media-slot,
    .portal-notes-slot {
        flex: 1 1 280px;
        min-width: 0;
        max-width: 100%;
    }

    .portal-media-slot > .px-2,
    .portal-notes-slot > .px-2,
    .portal-media-slot .col-6,
    .portal-notes-slot .col-6 {
        width: 100% !important;
        max-width: 100% !important;
        flex: 0 0 100% !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
`

const MenuBox = ({
    item,
    open,
    copy,
    remove,
    onToggle,
    copyDisabled,
    copyButtonLabel = 'Copy',
}) => {
    // Hide Copy button for imported sections
    const isImportedSection = item?.IsImported || item?.SectionName === 'Imported section'

    return (
        <FlexRow className="gap-2">
            {item?.CanDelete && (
                <span
                    onClick={event => {
                        event.stopPropagation()
                        event.preventDefault()
                    }}
                    role="presentation"
                >
                    <AppRemoveButtonPopup
                        on="click"
                        onConfirm={remove}
                        position="bottom right"
                    />
                </span>
            )}
            {!isImportedSection && copyButtonLabel && (
                <AppPrimaryButton
                    className="d-flex align-items-center"
                    onClick={copy}
                    disabled={copyDisabled}
                >
                    {copyButtonLabel === 'Add New' ? (
                        <Plus size={20} className="me-2" weight="bold" />
                    ) : (
                        <Copy size={20} className="me-2" />
                    )}
                    {copyButtonLabel}
                </AppPrimaryButton>
            )}
            {item?.IsCopiedSection && item?.CanDelete && (
                <AppPrimaryButton
                    className="d-flex align-items-center"
                    onClick={remove}
                >
                    <Trash size={20} className="me-2" />
                    Remove
                </AppPrimaryButton>
            )}
            <span
                className="d-flex align-items-center"
                role="button"
                tabIndex={0}
                onClick={event => {
                    event.stopPropagation()
                    event.preventDefault()
                    onToggle?.()
                }}
                onKeyDown={event => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.stopPropagation()
                        event.preventDefault()
                        onToggle?.()
                    }
                }}
                style={{ cursor: 'pointer' }}
            >
                {open ? <CaretDown size={20} /> : <CaretUp size={20} />}
            </span>
        </FlexRow>
    )
}

/** Show N/A only when the section API flag IsNAAvailable / isNAAvailable is true. */
const canShowSectionNA = section => isSectionNAAvailable(section)

const SectionNACheckboxWrap = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-left: 4px;
    white-space: nowrap;
    color: #fff;

    && .ui.checkbox label,
    && .ui.checkbox + label,
    && label {
        color: #fff !important;
    }

    && .ui.checkbox .box:before,
    && .ui.checkbox label:before {
        border-color: #fff !important;
    }
`

const SectionNACheckbox = ({
    section,
    disabled,
    onSectionNAChange,
}) => {
    if (
        !canShowSectionNA(section) ||
        typeof onSectionNAChange !== 'function'
    ) {
        return null
    }
    const checked = isSectionNASelected(section)
    return (
        <SectionNACheckboxWrap
            onClick={event => {
                event.stopPropagation()
                event.preventDefault()
            }}
            onKeyDown={event => event.stopPropagation()}
            role="presentation"
        >
            <Checkbox
                checked={checked}
                disabled={disabled}
                label="N/A"
                onChange={(_, { checked: next }) => {
                    onSectionNAChange(section.SectionId, !!next)
                }}
            />
        </SectionNACheckboxWrap>
    )
}

const SectionUniformAnswerWrap = styled.span`
    position: relative;
    z-index: 5;
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
    max-width: 100%;

    .section-uniform-trigger {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        user-select: none;
    }

    .section-uniform-trigger .ui.checkbox {
        pointer-events: none;
    }

    .section-uniform-caret {
        display: inline-flex;
        opacity: 0.9;
    }

    .section-uniform-menu {
        position: absolute;
        top: calc(100% + 6px);
        right: 0;
        z-index: 30;
        min-width: 160px;
        max-width: 240px;
        max-height: 240px;
        overflow-y: auto;
        margin: 0;
        padding: 4px;
        list-style: none;
        background: #fff;
        color: #1f2937;
        border: 1px solid #d8e0ea;
        border-radius: 8px;
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);
    }

    .section-uniform-option {
        display: flex;
        align-items: center;
        width: 100%;
        margin: 0;
        padding: 8px 10px;
        border: 0;
        border-radius: 6px;
        background: transparent;
        color: #1f2937;
        text-align: left;
        font-size: 0.9rem;
        cursor: pointer;
    }

    .section-uniform-option:hover,
    .section-uniform-option.active {
        background: #e8eefc;
        font-weight: 600;
    }

    ${({ $onDark }) =>
        $onDark
            ? `
        color: #fff;
        && .ui.checkbox label,
        && .ui.checkbox + label,
        && label {
            color: #fff !important;
        }
        && .ui.checkbox .box:before,
        && .ui.checkbox label:before {
            border-color: #fff !important;
        }
    `
            : `
        color: #1f2937;
    `}
`

const HIDE_SECTION_UNIFORM_ANSWERS_COMPANY_ID = 34930

const SectionUniformAnswers = ({
    section,
    disabled,
    onApply,
    tone = 'dark',
}) => {
    const { user } = useAuth()
    const reasonPreset = useReasonPresetInspection()
    const { errorToast } = useNotification()
    const wrapRef = useRef(null)
    const [menuOpen, setMenuOpen] = useState(false)
    const uniform = useMemo(() => getSectionUniformRadio(section), [section])
    const selectedText = uniform
        ? getUniformSelectedDisplayText(uniform.questions)
        : null

    useEffect(() => {
        if (!menuOpen) return undefined
        const closeMenu = event => {
            if (wrapRef.current && !wrapRef.current.contains(event.target)) {
                setMenuOpen(false)
            }
        }
        document.addEventListener('mousedown', closeMenu)
        return () => document.removeEventListener('mousedown', closeMenu)
    }, [menuOpen])

    if (
        user?.CompanyId === HIDE_SECTION_UNIFORM_ANSWERS_COMPANY_ID ||
        !uniform
    ) {
        return null
    }

    const handleApply = displayText => {
        if (disabled || typeof onApply !== 'function') return
        if (selectedText === displayText && section?.IsAllAllow === true) {
            setMenuOpen(false)
            return
        }
        const auditId = reasonPreset?.auditId
        if (auditId != null) {
            uniform.questions.forEach(question => {
                const previousSelected =
                    question?.IsOtherAnswerSelected ||
                    question?.Answers?.IsOtherAnswerSelected
                        ? []
                        : (question?.Answers?.MultipleResponse || []).filter(
                            option => option?.IsSelected,
                        )
                const nextSelected = (
                    question?.Answers?.MultipleResponse || []
                ).filter(
                    option =>
                        String(option?.DisplayText ?? '').trim() === displayText,
                )
                const result = reasonPresetTransition(
                    reasonPreset?.setting,
                    previousSelected,
                    nextSelected,
                )
                if (result.action !== 'clear' || question?.Id == null) return
                ReasonPresetService.saveSelection({
                    AuditId: Number(auditId),
                    AuditQuestionId: Number(question.Id),
                    Selections: [],
                }).catch(error => {
                    errorToast(getReasonPresetErrorMessage(error))
                })
            })
        }
        onApply(displayText)
        setMenuOpen(false)
    }

    const toggleMenu = event => {
        event.stopPropagation()
        event.preventDefault()
        if (disabled) return
        setMenuOpen(open => !open)
    }

    return (
        <SectionUniformAnswerWrap
            ref={wrapRef}
            $onDark={tone === 'dark'}
            onClick={event => event.stopPropagation()}
            onKeyDown={event => event.stopPropagation()}
            role="presentation"
        >
            <span
                className="section-uniform-trigger"
                role="button"
                tabIndex={disabled ? -1 : 0}
                aria-expanded={menuOpen}
                aria-haspopup="listbox"
                onClick={toggleMenu}
                onKeyDown={event => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        toggleMenu(event)
                    }
                    if (event.key === 'Escape') setMenuOpen(false)
                }}
            >
                <Checkbox
                    checked={!!selectedText}
                    label={selectedText ? `All: ${selectedText}` : 'All'}
                    readOnly
                    disabled={disabled}
                />
                <span className="section-uniform-caret">
                    <CaretDown size={14} weight="bold" />
                </span>
            </span>
            {menuOpen && (
                <ul className="section-uniform-menu" role="listbox">
                    {uniform.optionTexts.map(text => (
                        <li key={text}>
                            <button
                                type="button"
                                className={`section-uniform-option${
                                    text === selectedText ? ' active' : ''
                                }`}
                                onClick={event => {
                                    event.stopPropagation()
                                    handleApply(text)
                                }}
                            >
                                {text}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </SectionUniformAnswerWrap>
    )
}

const parseInspectionDateResponse = response => {
    if (response === undefined || response === null || response === '') {
        return null
    }
    const date =
        response instanceof Date ? response : new Date(response)
    return Number.isNaN(date.getTime()) ? null : date
}

/** Keep digits and a single decimal; strips letters including "e" from paste. */
const sanitizeInspectionNumberInput = raw => {
    const rawValue = String(raw ?? '')
    const parts = rawValue.replace(/[^0-9.]/g, '').split('.')
    return parts.length > 1
        ? `${parts[0]}.${parts.slice(1).join('')}`
        : parts[0]
}

const GetSingleResponseBox = ({
    reponseType,
    onAnswer,
    error,
    item,
    addMedia,
    removeMedia,
    fluid = false,
}) => {
    const [value, setValue] = useState()

    useEffect(() => {
        if (
            [
                ControlType.DateAndTime,
                ControlType.Date,
                ControlType.Time,
            ].includes(reponseType?.Id)
        ) {
            setValue(
                parseInspectionDateResponse(
                    item?.Answers?.SingleResponse?.Response,
                ),
            )
        } else if (reponseType?.Id === ControlType.Slider) {
            const raw = item?.Answers?.SingleResponse?.Response
            const num =
                raw === '' || raw === null || raw === undefined
                    ? 0
                    : Number(raw)
            setValue(Number.isNaN(num) ? 0 : num)
        } else {
            setValue(item?.Answers?.SingleResponse?.Response)
        }
    }, [item, reponseType?.Id])

    const onChange = (e, data) => {
        if (reponseType?.Id === ControlType.Number) {
            const sanitizedValue = sanitizeInspectionNumberInput(data.value)
            setValue(sanitizedValue)
            onAnswer(sanitizedValue)
            return
        }
        setValue(data.value)
    }

    const otherDataChange = data => {
        const isDateValue = data instanceof Date
        const normalizedValue =
            isDateValue && !Number.isNaN(data.getTime())
                ? data.toISOString()
                : data
        const comparableNext = isDateValue ? data : normalizedValue
        const comparableCurrent = value instanceof Date ? value : value

        if (
            !comparableNext ||
            !comparableCurrent ||
            comparableNext.toString() !== comparableCurrent.toString()
        ) {
            if (isDateValue && !Number.isNaN(data.getTime())) {
                setValue(data)
            } else {
                setValue(normalizedValue)
            }
            onAnswer(normalizedValue)
        }
    }

    const handleBlur = () => {
        onAnswer(value)
    }

    const handleNumberKeyDown = event => {
        if (['e', 'E', '+', '-'].includes(event.key)) {
            event.preventDefault()
        }
    }

    const handleNumberPaste = event => {
        event.preventDefault()
        const pastedText = event.clipboardData?.getData('text') ?? ''
        const sanitizedValue = sanitizeInspectionNumberInput(pastedText)
        setValue(sanitizedValue)
        onAnswer(sanitizedValue)
        if (event.target) {
            event.target.value = sanitizedValue
        }
    }

    const handleNumberWheel = event => {
        if (event?.target?.blur) {
            event.target.blur()
        }
    }

    switch (reponseType?.Id) {
        case ControlType.TextAnswer:
            return (
                <Input
                    fluid={fluid}
                    error={error}
                    type="text"
                    value={value}
                    onBlur={handleBlur}
                    onChange={onChange}
                    placeholder="Enter text here"
                />
            )
        case ControlType.Number:
            return (
                <Input
                    fluid={fluid}
                    error={error}
                    type="number"
                    value={value}
                    onBlur={handleBlur}
                    onChange={onChange}
                    onKeyDown={handleNumberKeyDown}
                    onPaste={handleNumberPaste}
                    onWheel={handleNumberWheel}
                    inputMode="decimal"
                    step="any"
                    placeholder="Enter Numbers"
                />
            )
        case ControlType.Checkbox:
            return (
                <Checkbox
                    checked={value === 'true'}
                    onChange={(e, data) => {
                        const newValue = data.checked ? 'true' : 'false'
                        setValue(newValue)
                        const responseObj = {
                            Response: newValue,
                            IsSelected: data.checked,
                        }
                        onAnswer(responseObj)
                    }}
                />
            )
        case ControlType.DateAndTime:
            return (
                <DateTimeFormFieldWithoutControl
                    dateFormat="MM/dd/yyyy h:mm aa"
                    error={error}
                    showTimeInput
                    selected={value}
                    onChange={otherDataChange}
                    placeholder="Select date and time"
                />
            )
        // case ControlType.Media: return (<Input value={value} onChange={onChange} />);
        case ControlType.Slider:
            return (
                <Slider
                    error={error}
                    value={value}
                    onChange={otherDataChange}
                    placeholder="Select a value"
                />
            )
        case ControlType.Signature:
            return (
                <SignatureFormField
                    error={error}
                    value={value}
                    onChange={otherDataChange}
                />
            )
        case ControlType.Date:
            return (
                <DateTimeFormFieldWithoutControl
                    error={error}
                    selected={value}
                    onChange={otherDataChange}
                    placeholder="Select date and time"
                />
            )
        case ControlType.Time:
            return (
                <DateTimeFormFieldWithoutControl
                    error={error}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    selected={value}
                    dateFormat="h:mm aa"
                    onChange={otherDataChange}
                    placeholder="Select date and time"
                />
            )
        case ControlType.TextArea:
            return (
                <TextAreaFormField
                    error={error}
                    value={value}
                    onBlur={handleBlur}
                    onChange={onChange}
                    placeholder="Enter text here"
                />
            )
        case ControlType.Media:
            return (
                <MediaTypeFilesBox
                    item={item}
                    addMedia={addMedia}
                    removeMedia={removeMedia}
                />
            )
        default:
            return null
    }
}
const SingleResponseBox = ({
    item,
    responses = [],
    onAnswer,
    error,
    addMedia,
    removeMedia,
    mediaType,
    disabled,
    portalFieldLayout = false,
}) => {
    const reponseType = useMemo(() => {
        return responses?.find(ele => ele.Id === item?.QuestionResponseId)
    }, [item, responses])
    const isMobile = useTabletAndBelowMediaQuery()
    const isReadOnly = disabled || item?.IsReadOnly || item?.IsImported
    const useFullWidth =
        portalFieldLayout || isMobile || mediaType
    const columnClass = useFullWidth ? 'col-12 w-100' : 'col-7'

    return (
        <Form className={portalFieldLayout ? 'w-100' : undefined}>
            {portalFieldLayout ? (
                <div className={`d-flex flex-column ${columnClass}`}>
                    <GetSingleResponseBox
                        error={error}
                        reponseType={reponseType}
                        item={item}
                        onAnswer={isReadOnly ? () => { } : onAnswer}
                        addMedia={isReadOnly ? () => { } : addMedia}
                        removeMedia={isReadOnly ? undefined : removeMedia}
                        fluid
                    />
                </div>
            ) : (
                <FlexRowBetween>
                    <div className={`d-flex flex-column ${columnClass}`}>
                        <GetSingleResponseBox
                            error={error}
                            reponseType={reponseType}
                            item={item}
                            onAnswer={isReadOnly ? () => { } : onAnswer}
                            addMedia={isReadOnly ? () => { } : addMedia}
                            removeMedia={isReadOnly ? undefined : removeMedia}
                        />
                    </div>
                </FlexRowBetween>
            )}
        </Form>
    )
}

const MultipleResponseBox = ({
    item,
    answers,
    onAnswer,
    disabled,
    selectedPressResponseIds,
    isPressDependencyEnabled,
    isShowHorizontal = false,
    portalFieldLayout = false,
    showPressResetButton = false,
    onPressReset,
    onPressDown,
    choiceButtonLayout = false,
}) => {
    const hasFilterAnswers =
        isPressDependencyEnabled &&
        Array.isArray(item?.Answers?.FilterAnswers) &&
        item.Answers.FilterAnswers.length > 0
    const hasSelectedPressResponses =
        Array.isArray(selectedPressResponseIds) &&
        selectedPressResponseIds.length > 0
    const isDependentOnPressWithoutSelection =
        hasFilterAnswers && !hasSelectedPressResponses
    const isReadOnly =
        disabled ||
        item?.IsReadOnly ||
        item?.IsImported ||
        isDependentOnPressWithoutSelection
    const hasPressSelected =
        Array.isArray(answers?.MultipleResponse) &&
        answers.MultipleResponse.some(response => response?.IsSelected)
    const isMobile = useTabletAndBelowMediaQuery()
    const dropdownRef = useRef(null)
    const [showMaxPopup, setShowMaxPopup] = useState(false)
    const [otherValue, setOtherValue] = useState(
        answers?.OtherAnswerResponse?.[0]?.OtherAnswer || '',
    )
    const [otherSelected, setOtherSelected] = useState(
        answers?.IsOtherAnswerSelected || false,
    )
    // Hint modal state
    const [showHintModal, setShowHintModal] = useState(false)
    const [selectedHint, setSelectedHint] = useState(null)
    const reasonPreset = useReasonPresetInspection()
    const { errorToast } = useNotification()

    const responseType = useMemo(() => {
        const allResponses = answers?.MultipleResponse?.length
            ? answers.MultipleResponse
            : []
        const filterAnswers =
            isPressDependencyEnabled &&
                Array.isArray(item?.Answers?.FilterAnswers)
                ? item.Answers.FilterAnswers
                : []
        if (!filterAnswers.length) return allResponses

        const selectedSourceIds = Array.isArray(selectedPressResponseIds)
            ? selectedPressResponseIds.map(value => String(value))
            : []
        if (!selectedSourceIds.length) return []

        const allowedTargetIds = new Set(
            filterAnswers
                .filter(filter => {
                    if (filter?.IsActive === false) return false
                    const sourceResponseId =
                        filter?.SourceResponseUId ??
                        filter?.SourceResponseUid ??
                        filter?.sourceResponseUId ??
                        filter?.sourceResponseUid ??
                        filter?.SourceResponseId
                    if (sourceResponseId == null) {
                        return false
                    }
                    return selectedSourceIds.includes(String(sourceResponseId))
                })
                .map(
                    filter =>
                        filter?.TargetResponseUId ??
                        filter?.TargetResponseUid ??
                        filter?.targetResponseUId ??
                        filter?.targetResponseUid ??
                        filter?.TargetResponseId,
                )
                .filter(value => value != null)
                .map(value => String(value)),
        )

        if (!allowedTargetIds.size) return []

        return allResponses.filter(response => {
            const responseId =
                response?.ResponseId ??
                response?.responseId ??
                response?.ResponseUId ??
                response?.ResponseUid ??
                response?.UId ??
                response?.Uid ??
                response?.Id
            return allowedTargetIds.has(String(responseId))
        })
    }, [answers, item, selectedPressResponseIds, isPressDependencyEnabled])

    const selectedManualResponse = useMemo(() => {
        if (!Array.isArray(answers.MultipleResponse)) return null
        return (
            answers.MultipleResponse.find(
                r => r.IsSelected && r.AllowManualScore,
            ) || null
        )
    }, [answers.MultipleResponse])

    // Handle hint icon click
    const handleHintClick = (e, hints) => {
        e.stopPropagation() // Prevent dropdown from opening/closing
        if (hints && hints.length > 0) {
            setSelectedHint(hints)
            setShowHintModal(true)
        }
    }

    // Build dropdown options from responseType with hint information
    const baseOptions = useMemo(
        () =>
            responseType?.map(ele => {
                const hasHints = ele.Hints && ele.Hints.length > 0
                return {
                    value: String(ele.Id),
                    text: ele.DisplayText,
                    key: String(ele.Id),
                    hints: ele.Hints || [], // Include hints data
                    // Add hint icon to text if hints exist
                    content: hasHints ? (
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <span>{ele.DisplayText}</span>
                            <Eye
                                size={16}
                                className="ms-2 cursor-pointer"
                                onClick={e => handleHintClick(e, ele.Hints)}
                                style={{ cursor: 'pointer', color: '#2185d0' }}
                            />
                        </div>
                    ) : (
                        ele.DisplayText
                    ),
                }
            }),
        [responseType],
    )

    // State for dropdown value (always strings)
    const [dropdownValue, setDropdownValue] = useState(
        responseType
            ?.filter(ele => ele.IsSelected)
            ?.map(ele => String(ele.Id)) || [],
    )

    // State for dropdown options
    const [dropdownOptions, setDropdownOptions] = useState(baseOptions)

    // On mount or when answers change, ensure 'Other' is included if present
    useEffect(() => {
        let base = baseOptions
        let otherValue = ''
        let otherSelected = false
        const otherResponses = Array.isArray(answers.OtherAnswerResponse)
            ? answers.OtherAnswerResponse
            : []
        // Include "Other" responses even if the text is currently empty,
        // so that selecting the Other option without text still shows as selected.
        const matchingOthers = otherResponses.filter(
            o => o && o.QuestionId === item.Id,
        )

        // Handle multiple "Other" responses
        if (matchingOthers.length > 0) {
            // Set the last "Other" value for the input field
            otherValue = String(
                matchingOthers[matchingOthers.length - 1].OtherAnswer,
            )
            otherSelected = answers.IsOtherAnswerSelected

            // Add all "Other" values to the dropdown options
            matchingOthers.forEach(other => {
                const otherVal = String(other.OtherAnswer)
                if (
                    otherVal &&
                    !base.some(opt => String(opt.value) === otherVal)
                ) {
                    base = [
                        ...base,
                        {
                            value: otherVal,
                            text: otherVal,
                            key: otherVal,
                            content: otherVal, // Use content for consistency
                        },
                    ]
                }
            })
        }

        // Set options first
        setDropdownOptions(base)
        setOtherValue(otherValue)
        setOtherSelected(!!otherSelected)

        // Build the complete value array including both existing selections and "Other" values
        let value =
            responseType
                ?.filter(ele => ele.IsSelected)
                ?.map(ele => String(ele.Id)) || []

        // Add all "Other" values to the selection
        matchingOthers.forEach(other => {
            const otherVal = String(other.OtherAnswer)
            if (otherVal && base.some(opt => String(opt.value) === otherVal)) {
                // Only add if not already in the array
                if (!value.includes(otherVal)) {
                    value = [...value, otherVal]
                }
            }
        })

        console.log('Dropdown options:', base)
        console.log('Dropdown value to set:', value)
        setDropdownValue(value)
    }, [baseOptions, responseType, answers, item.Id])

    // Restore onAnswerSelect for multi-select
    const applyReasonPresetTransition = (previousOptions, nextOptions) => {
        if (isReadOnly) return
        const result = reasonPresetTransition(
            reasonPreset?.setting,
            previousOptions,
            nextOptions,
        )
        if (result.action === 'clear') {
            const auditId = reasonPreset?.auditId
            const questionId = item?.Id
            if (auditId != null && questionId != null) {
                ReasonPresetService.saveSelection({
                    AuditId: Number(auditId),
                    AuditQuestionId: Number(questionId),
                    Selections: [],
                }).catch(error => {
                    errorToast(getReasonPresetErrorMessage(error))
                })
            }
        }
    }

    const onAnswerSelect = (_, data) => {
        if (isReadOnly) return // Prevent changes if read-only
        // Only enforce max selection when the question is required
        if (item.IsRequired && item.MultiResponseType === 2) {
            const max = item.MaxAnswer || 1
            if (data.value.length > max) {
                setShowMaxPopup(true)
                // Prevent selection
                return
            }
            // Auto-close dropdown if max is reached
            if (data.value.length === max && dropdownRef.current) {
                // Semantic UI Dropdown: close via ref
                if (dropdownRef.current.close) {
                    dropdownRef.current.close()
                } else if (dropdownRef.current.setOpen) {
                    dropdownRef.current.setOpen(false)
                }
            }
        }
        // Ensure all values are strings for consistency
        const newValues = (
            Array.isArray(data.value) ? data.value : [data.value]
        ).map(String)
        setDropdownValue(newValues)

        // Separate existing responses from "Other" responses
        const existingResponses = newValues.filter(v =>
            baseOptions.some(opt => String(opt.value) === v),
        )
        const otherResponses = newValues.filter(
            v => !baseOptions.some(opt => String(opt.value) === v),
        )

        const previousSelected = otherSelected
            ? []
            : (responseType || []).filter(option => option.IsSelected)
        const nextSelected = (responseType || []).filter(option =>
            existingResponses.includes(String(option.Id)),
        )
        onAnswer({
            MultipleResponse: responseType.map(ele => ({
                ...ele,
                IsSelected: existingResponses.includes(String(ele.Id)),
                // Ensure Score is preserved
                Score: typeof ele.Score === 'number' ? ele.Score : ele.Score,
            })),
            OtherAnswerResponse:
                otherResponses.length > 0
                    ? otherResponses.map(otherAnswer => ({
                        OtherAnswer: otherAnswer,
                        QuestionId: item.Id,
                    }))
                    : null,
            IsOtherAnswerSelected: otherResponses.length > 0,
        })
        applyReasonPresetTransition(previousSelected, nextSelected)
    }

    // --- NEW: Handle additions to the dropdown ---
    const handleDropdownAddition = (e, { value }) => {
        const stringValue = String(value)
        const newOption = {
            text: stringValue,
            value: stringValue,
            key: stringValue,
            content: stringValue, // Use content for consistency
        }

        // Add the new option to dropdown options
        setDropdownOptions(prev => {
            // Only add if not already present
            if (!prev.some(opt => String(opt.value) === stringValue)) {
                return [...prev, newOption]
            }
            return prev
        })

        // Build new value array
        let newValue = [...dropdownValue]

        // Check if we can add this value (respect max limit when required)
        if (item.IsRequired && item.MultiResponseType === 2) {
            const max = item.MaxAnswer || 1
            if (newValue.length >= max && !newValue.includes(stringValue)) {
                setShowMaxPopup(true)
                return
            }
        }

        // Add the new value if not already present
        if (!newValue.includes(stringValue)) {
            newValue = [...newValue, stringValue]
        }

        setDropdownValue(newValue)
        onAnswerSelect(e, { value: newValue })
    }

    // Restore handleRadioClick for normal radio options
    const handleRadioClick = ele => {
        if (isReadOnly) return // Prevent changes if read-only
        setOtherSelected(false)
        setOtherValue('')
        const previousSelected = otherSelected
            ? []
            : (responseType || []).filter(option => option.IsSelected)
        onAnswer({
            MultipleResponse: responseType.map(opt => {
                // Ensure Score is preserved from the original option
                let score = opt.Score
                if (typeof score !== 'number' && opt.Id === ele.Id) {
                    score = ele.Score
                }
                return {
                    ...opt,
                    IsSelected: opt.Id === ele.Id,
                    Score: score,
                }
            }),
            IsOtherAnswerSelected: false,
            OtherAnswerResponse: null,
        })
        applyReasonPresetTransition(previousSelected, [ele])
    }

    const handleManualScoreChange = newScore => {
        if (!selectedManualResponse) return
        const max = Number(selectedManualResponse.MaxManualScore) || 0
        const clamped =
            max > 0 ? Math.min(Math.max(0, newScore), max) : Math.max(0, newScore)

        const updated = (answers.MultipleResponse || []).map(resp =>
            resp.Id === selectedManualResponse.Id
                ? {
                    ...resp,
                    Score: clamped,
                    IsScore: true,
                }
                : resp,
        )

        onAnswer({
            ...answers,
            MultipleResponse: updated,
            IsAnswered: true,
        })
    }

    const handleOtherSelect = () => {
        if (isReadOnly) return
        const previousSelected = otherSelected
            ? []
            : (responseType || []).filter(option => option.IsSelected)
        applyReasonPresetTransition(previousSelected, [])
        // Selecting "Other" should immediately mark it as chosen,
        // even if there is no text yet.
        setOtherSelected(true)
        const trimmed = (otherValue || '').trim()
        onAnswer({
            // Mark as "Other" mode even if empty; validation will still fail
            // if there is no actual Other text.
            OtherAnswerResponse: [
                {
                    OtherAnswer: trimmed,
                    QuestionId: item.Id,
                },
            ],
            IsOtherAnswerSelected: true,
            MultipleResponse: responseType.map(ele => ({
                ...ele,
                IsSelected: false,
                // Ensure Score is preserved
                Score: typeof ele.Score === 'number' ? ele.Score : ele.Score,
            })),
        })
    }

    const showChoiceButtons =
        choiceButtonLayout &&
        Number(item.MultiResponseType) !== TemplateQuestionResponseType.Multiple
    const showSingleChoices =
        !showChoiceButtons &&
        item.MultiResponseType === TemplateQuestionResponseType.Single
    const showDropdownChoices = !showChoiceButtons && !showSingleChoices

    return (
        <div>
            {isDependentOnPressWithoutSelection && (
                <div
                    style={{
                        fontSize: '0.85rem',
                        color: '#a5673f',
                        marginBottom: 8,
                    }}
                >
                    Select Press first to view available responses.
                </div>
            )}
            {showChoiceButtons && (
                <div>
                    <NestedChoiceButtons>
                        {responseType?.map(ele => {
                            const selected = ele.IsSelected && !otherSelected
                            const background = ele.BackColorCode || '#1e293b'
                            const choiceOpacity = isReadOnly ? 0.55 : 1
                            return (
                                <button
                                    key={ele.Id}
                                    type="button"
                                    disabled={isReadOnly}
                                    onClick={() => handleRadioClick(ele)}
                                    style={{
                                        flex: '0 0 auto',
                                        minHeight: 36,
                                        padding: '8px 16px',
                                        border: selected
                                            ? '1px solid transparent'
                                            : '1px solid #334155',
                                        borderRadius: 8,
                                        background: selected
                                            ? background
                                            : '#1e293b',
                                        color: '#fff',
                                        fontWeight: 700,
                                        fontSize: 14,
                                        lineHeight: 1.2,
                                        cursor: isReadOnly ? 'not-allowed' : 'pointer',
                                        opacity: choiceOpacity,
                                        boxShadow: selected
                                            ? '0 0 0 2px #fff, 0 0 0 3px #0f172a'
                                            : 'none',
                                    }}
                                >
                                    {ele.DisplayText}
                                </button>
                            )
                        })}
                    </NestedChoiceButtons>
                    {(() => {
                        const scoredValues = (responseType || [])
                            .filter(option => option.IsScore !== false)
                            .map(option => Number(option.Score))
                            .filter(score => Number.isFinite(score))
                        const maxScore = scoredValues.length
                            ? Math.max(...scoredValues)
                            : 0
                        const selectedOption = (responseType || []).find(
                            option => option.IsSelected && !otherSelected,
                        )
                        const selectedScore = Number(selectedOption?.Score)
                        if (
                            !selectedOption ||
                            selectedOption.IsScore === false ||
                            !Number.isFinite(selectedScore) ||
                            maxScore <= 0
                        ) {
                            return null
                        }
                        const formatScore = value => {
                            if (Number.isInteger(value)) return String(value)
                            return String(Math.round(value * 100) / 100)
                        }
                        return (
                            <div
                                style={{
                                    display: 'inline-flex',
                                    marginTop: 8,
                                    padding: '4px 8px',
                                    borderRadius: 6,
                                    background: '#ecfdf5',
                                    color: '#166534',
                                    fontSize: 13,
                                    fontWeight: 700,
                                }}
                            >
                                {formatScore(selectedScore)} / {formatScore(maxScore)}
                            </div>
                        )
                    })()}
                    {item.IsOtherOptionAvailable && (
                        <div
                            className="d-flex align-items-center response-option-item mt-3"
                            onClick={handleOtherSelect}
                        >
                            <Radio
                                checked={otherSelected || !!otherValue}
                                name={item.Id}
                                disabled={isReadOnly}
                                onClick={handleOtherSelect}
                            />
                            <Input
                                placeholder="Other"
                                value={otherValue}
                                disabled={isReadOnly}
                                onFocus={() => {
                                    if (isReadOnly) return
                                    if (!otherSelected) {
                                        handleOtherSelect()
                                    }
                                }}
                                onChange={e => {
                                    if (isReadOnly) return
                                    const { value } = e.target
                                    setOtherValue(value)
                                    const trimmed = value.trim()
                                    if (!trimmed) {
                                        setOtherSelected(false)
                                        onAnswer({
                                            IsOtherAnswerSelected: false,
                                            OtherAnswerResponse: null,
                                            MultipleResponse: responseType.map(
                                                ele => ({
                                                    ...ele,
                                                    IsSelected: false,
                                                }),
                                            ),
                                        })
                                    } else {
                                        setOtherSelected(true)
                                        onAnswer({
                                            OtherAnswerResponse: [
                                                {
                                                    OtherAnswer: trimmed,
                                                    QuestionId: item.Id,
                                                },
                                            ],
                                            IsOtherAnswerSelected: true,
                                            MultipleResponse: responseType.map(
                                                ele => ({
                                                    ...ele,
                                                    IsSelected: false,
                                                }),
                                            ),
                                        })
                                    }
                                }}
                                className="ms-3"
                            />
                        </div>
                    )}
                    {selectedManualResponse?.AllowManualScore && (
                        <div className="mt-2">
                            <label
                                style={{
                                    display: 'block',
                                    marginBottom: 4,
                                    fontSize: '0.85rem',
                                    color: '#666',
                                }}
                            >
                                Manual score for selected option (max{' '}
                                {selectedManualResponse.MaxManualScore || 0})
                            </label>
                            <NumericStepper
                                min={0}
                                max={
                                    Number(selectedManualResponse.MaxManualScore) ||
                                    undefined
                                }
                                step={1}
                                value={selectedManualResponse.Score || 0}
                                onChange={handleManualScoreChange}
                            />
                        </div>
                    )}
                </div>
            )}
            {showSingleChoices && (
                <div
                    className={
                        isShowHorizontal
                            ? 'inspection-response-options-horizontal'
                            : undefined
                    }
                >
                    {responseType?.map(ele => (
                        <div
                            key={ele.Id}
                            onClick={isReadOnly ? undefined : () => handleRadioClick(ele)}
                            className={`d-flex align-items-center response-option-item ${
                                isShowHorizontal ? '' : 'mb-3'
                            }`}
                            style={isReadOnly ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
                        >
                            <Radio
                                checked={ele.IsSelected && !otherSelected}
                                name={item.Id}
                                disabled={isReadOnly}
                            />
                            <span className="ms-3">{ele.DisplayText}</span>
                        </div>
                    ))}
                    {item.IsOtherOptionAvailable && (
                        <div
                            className={`d-flex align-items-center response-option-item ${
                                isShowHorizontal ? '' : 'mb-3'
                            }`}
                            onClick={handleOtherSelect}
                        >
                            <Radio
                                checked={otherSelected || !!otherValue}
                                name={item.Id}
                                disabled={isReadOnly}
                                // Use onClick to ensure the radio itself triggers selection,
                                // even if the outer div's onClick doesn't fire.
                                onClick={handleOtherSelect}
                            />
                            <Input
                                placeholder="Other"
                                value={otherValue}
                                disabled={isReadOnly}
                                onFocus={() => {
                                    // Focusing the Other textbox should also select the Other option
                                    if (isReadOnly) return
                                    if (!otherSelected) {
                                        handleOtherSelect()
                                    }
                                }}
                                onChange={e => {
                                    if (isReadOnly) return // Prevent changes if read-only
                                    const { value } = e.target
                                    setOtherValue(value)
                                    const trimmed = value.trim()
                                    if (!trimmed) {
                                        setOtherSelected(false)
                                        onAnswer({
                                            IsOtherAnswerSelected: false,
                                            OtherAnswerResponse: null,
                                            MultipleResponse: responseType.map(
                                                ele => ({
                                                    ...ele,
                                                    IsSelected: false,
                                                }),
                                            ),
                                        })
                                    } else {
                                        setOtherSelected(true)
                                        onAnswer({
                                            OtherAnswerResponse: [
                                                {
                                                    OtherAnswer: trimmed,
                                                    QuestionId: item.Id,
                                                },
                                            ],
                                            IsOtherAnswerSelected: true,
                                            MultipleResponse: responseType.map(
                                                ele => ({
                                                    ...ele,
                                                    IsSelected: false,
                                                }),
                                            ),
                                        })
                                    }
                                }}
                                className="ms-3"
                            />
                        </div>
                    )}

                    {selectedManualResponse?.AllowManualScore && (
                        <div className="mt-2">
                            <label
                                style={{
                                    display: 'block',
                                    marginBottom: 4,
                                    fontSize: '0.85rem',
                                    color: '#666',
                                }}
                            >
                                Manual score for selected option (max{' '}
                                {selectedManualResponse.MaxManualScore || 0})
                            </label>
                            <NumericStepper
                                min={0}
                                max={
                                    Number(selectedManualResponse.MaxManualScore) ||
                                    undefined
                                }
                                step={1}
                                value={selectedManualResponse.Score || 0}
                                onChange={handleManualScoreChange}
                            />
                        </div>
                    )}
                </div>
            )}
            {showDropdownChoices && (
                <>
                    <div
                        className={`d-flex align-items-center ${
                            showPressResetButton && isMobile
                                ? 'flex-nowrap'
                                : 'flex-wrap'
                        } ${portalFieldLayout || isMobile ? 'w-100' : ''}`}
                        style={{ gap: 10 }}
                    >
                        {showPressResetButton ? (
                            <PressResetDropdownWrap>
                                <Dropdown
                                    ref={dropdownRef}
                                    placeholder="Select"
                                    options={dropdownOptions}
                                    onChange={onAnswerSelect}
                                    value={dropdownValue}
                                    className="fluid"
                                    multiple
                                    selection
                                    search
                                    disabled={isReadOnly}
                                    allowAdditions={
                                        item.IsOtherOptionAvailable && !isReadOnly
                                    }
                                    onAddItem={
                                        item.IsOtherOptionAvailable && !isReadOnly
                                            ? handleDropdownAddition
                                            : undefined
                                    }
                                    menu={
                                        portalFieldLayout
                                            ? {
                                                  style: {
                                                      maxHeight: 320,
                                                      overflowY: 'auto',
                                                  },
                                              }
                                            : {
                                                  style: {
                                                      position: 'static',
                                                      maxHeight: 320,
                                                      overflowY: 'auto',
                                                      boxShadow: 'none',
                                                      marginTop: 6,
                                                  },
                                              }
                                    }
                                />
                            </PressResetDropdownWrap>
                        ) : (
                            <Dropdown
                                ref={dropdownRef}
                                placeholder="Select"
                                options={dropdownOptions}
                                onChange={onAnswerSelect}
                                value={dropdownValue}
                                className={
                                    portalFieldLayout || isMobile
                                        ? 'fluid flex-grow-1'
                                        : 'col-7'
                                }
                                multiple
                                selection
                                search
                                disabled={isReadOnly}
                                allowAdditions={
                                    item.IsOtherOptionAvailable && !isReadOnly
                                }
                                onAddItem={
                                    item.IsOtherOptionAvailable && !isReadOnly
                                        ? handleDropdownAddition
                                        : undefined
                                }
                                menu={
                                    portalFieldLayout
                                        ? {
                                              style: {
                                                  maxHeight: 320,
                                                  overflowY: 'auto',
                                              },
                                          }
                                        : {
                                              style: {
                                                  position: 'static',
                                                  maxHeight: 320,
                                                  overflowY: 'auto',
                                                  boxShadow: 'none',
                                                  marginTop: 6,
                                              },
                                          }
                                }
                            />
                        )}
                        {showPressResetButton &&
                            onPressReset &&
                            isMobile && (
                                <PressResetIconButton
                                    type="button"
                                    disabled={isReadOnly}
                                    onClick={onPressReset}
                                    title="Reset"
                                    aria-label="Reset inspection"
                                >
                                    <ArrowCounterClockwise size={20} />
                                </PressResetIconButton>
                            )}
                        {showPressResetButton &&
                            onPressReset &&
                            !isMobile && (
                                <AppSecondaryButton
                                    type="button"
                                    disabled={isReadOnly}
                                    onClick={onPressReset}
                                >
                                    Reset
                                </AppSecondaryButton>
                            )}
                        {showPressResetButton &&
                            onPressDown &&
                            hasPressSelected && (
                            <AppSecondaryButton
                                type="button"
                                disabled={isReadOnly}
                                onClick={onPressDown}
                            >
                                Down
                            </AppSecondaryButton>
                        )}
                    </div>
                    <Modal
                        open={showMaxPopup}
                        size="mini"
                        onClose={() => setShowMaxPopup(false)}
                    >
                        <Modal.Header>Selection Limit</Modal.Header>
                        <Modal.Content>
                            You can select only {item.MaxAnswer || 1}. If you
                            want to select this answer, you have to remove one
                            from selected first.
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                onClick={() => setShowMaxPopup(false)}
                                primary
                            >
                                OK
                            </Button>
                        </Modal.Actions>
                    </Modal>

                    {/* Hint Modal */}
                    <Modal
                        open={showHintModal}
                        size="small"
                        onClose={() => setShowHintModal(false)}
                        className="hint-modal"
                    >
                        <Modal.Header style={{ paddingBottom: 0 }}>
                            <FlexRowBetween>
                                <TitleText style={{ color: '#222', fontSize: 24 }}>
                                    Hint Information
                                </TitleText>
                                <X
                                    className="pointer"
                                    size={28}
                                    onClick={() => setShowHintModal(false)}
                                    style={{ cursor: 'pointer' }}
                                />
                            </FlexRowBetween>
                        </Modal.Header>
                        <Modal.Content style={{ paddingTop: 0 }}>
                            {selectedHint && selectedHint.length > 0 && (() => {
                                // Only show the latest (last) hint
                                const hint = selectedHint[selectedHint.length - 1]
                                return (
                                    <div className="mb-3">
                                        {hint.Heading && (
                                            <h3 style={{ color: '#222', fontWeight: 700, fontSize: 20, marginBottom: 8 }}>
                                                {hint.Heading}
                                            </h3>
                                        )}
                                        {hint.HintText && (
                                            <p style={{ marginBottom: 8 }}>{hint.HintText}</p>
                                        )}
                                        {hint.MediaPath && (
                                            <div style={{ marginTop: 8 }}>
                                                <HintImage
                                                    src={hint.MediaPath}
                                                    alt="Hint Media"
                                                />
                                            </div>
                                        )}
                                    </div>
                                )
                            })()}
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                onClick={() => setShowHintModal(false)}
                                primary
                            >
                                Close
                            </Button>
                        </Modal.Actions>
                    </Modal>
                </>
            )}
        </div>
    )
}
// const ParentChildResponseBox = ({ item, answers, onAnswer, error }) => {
//     const parentChildResponse = answers.ParentChildResponse

//     // Example usage of `item` (placeholder logic)
//     console.log('Question item:', item)

//     // Example usage of `error` (placeholder logic)
//     if (error) {
//         console.error('Error:', error)
//     }

//     const handleParentSelection = (parentId, isSelected) => {
//         const updatedResponse = parentChildResponse.map(parent => {
//             if (parent.ParentId === parentId) {
//                 return {
//                     ...parent,
//                     IsSelected: isSelected,
//                     Children: parent.Children.map(child => ({
//                         ...child,
//                         IsSelected: isSelected,
//                     })),
//                 }
//             }
//             return parent
//         })
//         onAnswer({ ...answers, ParentChildResponse: updatedResponse })
//     }

//     const handleChildSelection = (parentId, childId, isSelected) => {
//         const updatedResponse = parentChildResponse.map(parent => {
//             if (parent.ParentId === parentId) {
//                 return {
//                     ...parent,
//                     Children: parent.Children.map(child => {
//                         if (child.ChildId === childId) {
//                             return {
//                                 ...child,
//                                 IsSelected: isSelected,
//                             }
//                         }
//                         return child
//                     }),
//                 }
//             }
//             return parent
//         })
//         onAnswer({ ...answers, ParentChildResponse: updatedResponse })
//     }

//     return (
//         <div>
//             {parentChildResponse.map(parent => (
//                 <div key={parent.ParentId}>
//                     <label>
//                         <input
//                             type="checkbox"
//                             checked={parent.IsSelected}
//                             onChange={e =>
//                                 handleParentSelection(
//                                     parent.ParentId,
//                                     e.target.checked,
//                                 )
//                             }
//                         />
//                         {parent.ParentName}
//                     </label>
//                     {parent.Children.map(child => (
//                         <div key={child.ChildId} style={{ marginLeft: '20px' }}>
//                             <label>
//                                 <input
//                                     type="checkbox"
//                                     checked={child.IsSelected}
//                                     onChange={e =>
//                                         handleChildSelection(
//                                             parent.ParentId,
//                                             child.ChildId,
//                                             e.target.checked,
//                                         )
//                                     }
//                                 />
//                                 {child.ChildName}
//                             </label>
//                         </div>
//                     ))}
//                 </div>
//             ))}
//         </div>
//     )
// }

const CNCBox = ({ question, cnc, onAnswer, disabled }) => {
    if (!cnc || disabled) return null

    const questionId = question?.Id ?? question?.QuestionId
    const optionsSource = Array.isArray(cnc.QuestionData)
        ? cnc.QuestionData[0]?.Options || []
        : []

    if (!optionsSource.length) return null

    const currentSelectedId = (() => {
        const fromOption = optionsSource.find(opt => opt.IsSelected)?.Id
        if (fromOption) return fromOption

        const fromResponseId = cnc.ResponseData?.CNCResponseId
        if (fromResponseId) {
            const mapped = optionsSource.find(
                opt => opt.Id === fromResponseId,
            )?.Id
            if (mapped) return mapped
        }
        return 0
    })()

    const handleSelect = option => {
        if (!option || disabled) return

        const cncResponseId = option.Id

        let cncValue = 0
        if (typeof option.Score === 'number' && !Number.isNaN(option.Score)) {
            cncValue = option.Score
        } else {
            const label = (option.DisplayText || '').trim().toUpperCase()
            if (label === 'C') cncValue = 1
            else if (label === 'NC') cncValue = 2
        }

        const payload = {
            __ncReply: option.DisplayText || '',
            __cncResponse: {
                QuestionId: questionId,
                CNCResponseId: cncResponseId,
                CNCValue: cncValue,
                AdditionalAnswer:
                    cnc.ResponseData?.AdditionalAnswer != null
                        ? cnc.ResponseData.AdditionalAnswer
                        : '',
            },
        }

        onAnswer(payload)
    }

    return (
        <div className="mt-2">
            {optionsSource.map(opt => (
                <div
                    key={opt.Id}
                    className="d-flex align-items-center mb-1"
                    style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                    onClick={() => !disabled && handleSelect(opt)}
                >
                    <Radio
                        checked={currentSelectedId === opt.Id}
                        onChange={() => handleSelect(opt)}
                        disabled={disabled}
                    />
                    <span className="ms-2">{opt.DisplayText}</span>
                </div>
            ))}
        </div>
    )
}

const mapParentChildFields = (parent, children) => {
    const {
        IsOtherAnswerSelected: _isOther,
        OtherAnswer: _otherAnswer,
        OtherScore: _otherScore,
        ...cleanParent
    } = parent
    return {
        ...cleanParent,
        Children: children,
        ParentId: parent.ParentId,
        ParentName: parent.ParentName,
        ChildLabel: parent.ChildLabel || '',
        QuestionId: parent.QuestionId,
        TemplateId: parent.TemplateId,
        Id: parent.Id,
    }
}

const mapChildFields = child => ({
    ...child,
    ChildId: child.ChildId || 0,
    ParentId: child.ParentId,
    ParentChildId: child.ParentChildId || 0,
    ChildName: child.ChildName,
    ChildLabel: child.ChildLabel || '',
    Id: child.Id,
})

const ParentChildResponseBox = ({ item, answers, onAnswer }) => {
    const parentChildResponse = answers.ParentChildResponse || []
    const questionId = item?.Id ?? item?.QuestionId ?? 'unknown'

    const isReadOnly = item?.IsReadOnly || item?.IsImported

    // Derive selection from answers (source of truth) to avoid sync issues
    const selectedParent = parentChildResponse.find(
        parent =>
            parent.IsSelected ||
            (parent.Children && parent.Children.some(child => child.IsSelected)),
    )
    const selectedParentId = selectedParent?.ParentId ?? null
    const selectedChild = selectedParent?.Children?.find(child => child.IsSelected)
    const selectedChildId = selectedChild?.Id ?? null
    const isMultipleAllow = !!selectedParent?.IsMultipleAllow
    const parentChildOtherAnswers = Array.isArray(answers.OtherAnswerResponse)
        ? answers.OtherAnswerResponse
        : []

    const getParentOtherUniqueId = parent =>
        parent?.Id ?? parent?.ParentId ?? null

    const getParentById = parentId =>
        parentChildResponse.find(
            parent => String(parent?.ParentId) === String(parentId),
        )

    const getParentOtherAnswer = parentId => {
        const parent = getParentById(parentId)
        const uniqueId = getParentOtherUniqueId(parent)
        const match = parentChildOtherAnswers.find(
            other =>
                String(other?.UniqueId) === String(uniqueId) ||
                String(other?.ParentId) === String(parentId),
        )
        return match?.OtherAnswer || ''
    }

    const isParentOtherSelected = parentId =>
        !!answers.IsOtherAnswerSelected &&
        parentChildOtherAnswers.some(other => {
            const parent = getParentById(parentId)
            const uniqueId = getParentOtherUniqueId(parent)
            return (
                String(other?.UniqueId) === String(uniqueId) ||
                String(other?.ParentId) === String(parentId)
            )
        })

    const getParentOtherScoreValue = (parent, scoreOverride) => {
        if (!parent) return 0
        if (scoreOverride !== undefined && scoreOverride !== null) {
            if (scoreOverride === '') return 0
            const overrideScore = Number(scoreOverride)
            return Number.isNaN(overrideScore) ? 0 : overrideScore
        }

        const uniqueId = getParentOtherUniqueId(parent)
        const match = parentChildOtherAnswers.find(
            other =>
                String(other?.UniqueId) === String(uniqueId) ||
                String(other?.ParentId) === String(parent?.ParentId),
        )

        if (parent.AllowManualScore) {
            if (
                !match ||
                match.Score === '' ||
                match.Score === null ||
                match.Score === undefined
            ) {
                return 0
            }
            const score = Number(match.Score)
            return Number.isNaN(score) ? 0 : score
        }

        const score = Number(parent.Score ?? parent.OriginalScore ?? 0)
        return Number.isNaN(score) ? 0 : score
    }

    const getParentOtherScoreDisplay = parentId => {
        const parent = getParentById(parentId)
        if (!parent?.AllowManualScore) return ''
        const uniqueId = getParentOtherUniqueId(parent)
        const match = parentChildOtherAnswers.find(
            other =>
                String(other?.UniqueId) === String(uniqueId) ||
                String(other?.ParentId) === String(parentId),
        )
        if (
            !match ||
            match.Score === '' ||
            match.Score === null ||
            match.Score === undefined
        ) {
            return ''
        }
        const score = Number(match.Score)
        return Number.isNaN(score) ? '' : score
    }

    const buildParentOtherAnswer = (parent, otherAnswer, scoreOverride) => {
        const scoreValue = getParentOtherScoreValue(parent, scoreOverride)
        const isScoreEnabled = parent?.IsScore !== false

        return {
            UniqueId: getParentOtherUniqueId(parent),
            QuestionId: item.Id,
            OtherAnswer: otherAnswer,
            CreatedOn: new Date().toISOString(),
            IsScore: isScoreEnabled,
            Score: String(scoreValue),
        }
    }

    const commitParentChildResponse = (updatedResponse, answerOverrides = {}) => {
        const nextAnswers = {
            ...answers,
            ...answerOverrides,
            ParentChildResponse: applyParentChildResponseScores(updatedResponse),
        }
        const answered = hasParentChildAnswerSelection(
            nextAnswers.ParentChildResponse,
            nextAnswers,
        )
        onAnswer({
            ...nextAnswers,
            IsAnswered: answered,
        })
    }

    // Handle parent selection (radio button)
    const handleParentSelection = parentId => {
        if (isReadOnly) return
        const updatedResponse = parentChildResponse.map(parent => {
            const isSelected = parent.ParentId === parentId
            return mapParentChildFields(
                {
                    ...parent,
                    IsSelected: isSelected,
                },
                (parent.Children || []).map(child =>
                    mapChildFields({
                        ...child,
                        IsSelected: false,
                    }),
                ),
            )
        })

        commitParentChildResponse(updatedResponse, {
            IsOtherAnswerSelected: false,
            OtherAnswerResponse: null,
        })
    }

    // Handle child selection (radio with single-select behavior)
    const handleChildSelection = (parentId, childId, isSelected) => {
        if (isReadOnly) return
        if (!isSelected && childId === selectedChildId) {
            return
        }

        const updatedResponse = parentChildResponse.map(parent => {
            const isParentSelected = parent.ParentId === parentId
            return mapParentChildFields(
                {
                    ...parent,
                    IsSelected: isParentSelected,
                },
                (parent.Children || []).map(child => {
                    const isChildSelected =
                        isParentSelected && child.Id === childId
                    return mapChildFields({
                        ...child,
                        IsSelected: isChildSelected,
                    })
                }),
            )
        })

        commitParentChildResponse(updatedResponse, {
            IsOtherAnswerSelected: false,
            OtherAnswerResponse: null,
        })
    }

    const handleMultiChildSelection = (parentId, childId, isChecked) => {
        if (isReadOnly) return

        const updatedResponse = parentChildResponse.map(parent => {
            if (parent.ParentId !== parentId) {
                return mapParentChildFields(
                    {
                        ...parent,
                        IsSelected: false,
                    },
                    (parent.Children || []).map(child =>
                        mapChildFields({
                            ...child,
                            IsSelected: false,
                        }),
                    ),
                )
            }

            const nextChildren = (parent.Children || []).map(child => {
                if (child.Id !== childId) return mapChildFields(child)
                return mapChildFields({
                    ...child,
                    IsSelected: isChecked,
                })
            })
            const hasSelectedChild = nextChildren.some(child => child.IsSelected)

            return mapParentChildFields(
                {
                    ...parent,
                    IsSelected:
                        hasSelectedChild ||
                        isParentOtherSelected(parent.ParentId),
                },
                nextChildren,
            )
        })

        commitParentChildResponse(updatedResponse)
    }

    const handleParentOtherSelection = (parentId, isChecked = true) => {
        if (isReadOnly) return

        const existingOtherAnswer = getParentOtherAnswer(parentId)
        const updatedResponse = parentChildResponse.map(parent => {
            const isTargetParent = parent.ParentId === parentId
            if (!isTargetParent) {
                return mapParentChildFields(
                    {
                        ...parent,
                        IsSelected: false,
                    },
                    (parent.Children || []).map(child =>
                        mapChildFields({
                            ...child,
                            IsSelected: false,
                        }),
                    ),
                )
            }

            const nextChildren = (parent.Children || []).map(child =>
                mapChildFields({
                    ...child,
                    IsSelected: parent.IsMultipleAllow
                        ? child.IsSelected
                        : false,
                }),
            )

            return mapParentChildFields(
                {
                    ...parent,
                    IsSelected:
                        isChecked ||
                        nextChildren.some(child => child.IsSelected),
                },
                nextChildren,
            )
        })

        const updatedParent = updatedResponse.find(
            parent => parent.ParentId === parentId,
        )
        const otherAnswers = isChecked
            ? [buildParentOtherAnswer(updatedParent, existingOtherAnswer)]
            : null

        commitParentChildResponse(updatedResponse, {
            IsOtherAnswerSelected: !!isChecked,
            OtherAnswerResponse: otherAnswers,
        })
    }

    const handleParentOtherTextChange = (parentId, value) => {
        if (isReadOnly) return

        const updatedResponse = parentChildResponse.map(parent => {
            const isTargetParent = parent.ParentId === parentId
            if (!isTargetParent) return parent

            return mapParentChildFields(
                {
                    ...parent,
                    IsSelected: true,
                },
                (parent.Children || []).map(child =>
                    mapChildFields({
                        ...child,
                        IsSelected: parent.IsMultipleAllow
                            ? child.IsSelected
                            : false,
                    }),
                ),
            )
        })

        const updatedParent = updatedResponse.find(
            parent => parent.ParentId === parentId,
        )

        commitParentChildResponse(updatedResponse, {
            IsOtherAnswerSelected: true,
            OtherAnswerResponse: [
                buildParentOtherAnswer(updatedParent, value),
            ],
        })
    }

    const handleParentOtherManualScoreInput = (parentId, newScore) => {
        if (isReadOnly) return

        const selectedParentForOther = parentChildResponse.find(
            parent => parent.ParentId === parentId,
        )
        if (!selectedParentForOther) return

        const maxAllowed = getRemainingManualScore(
            selectedParentForOther,
            null,
            parentChildOtherAnswers,
            true,
        )
        const clamped = clampManualScoreValue(newScore, maxAllowed)
        const scoreValue = clamped === '' ? 0 : Number(clamped)

        const updatedResponse = parentChildResponse.map(parent => {
            if (parent.ParentId !== parentId) return parent

            return mapParentChildFields(
                {
                    ...parent,
                    IsSelected: true,
                },
                (parent.Children || []).map(child =>
                    mapChildFields({
                        ...child,
                        IsSelected: parent.IsMultipleAllow
                            ? child.IsSelected
                            : false,
                    }),
                ),
            )
        })

        const updatedParent = updatedResponse.find(
            parent => parent.ParentId === parentId,
        )

        commitParentChildResponse(updatedResponse, {
            IsOtherAnswerSelected: true,
            OtherAnswerResponse: [
                buildParentOtherAnswer(
                    updatedParent,
                    getParentOtherAnswer(parentId),
                    clamped === '' ? 0 : scoreValue,
                ),
            ],
        })
    }

    const handleParentManualScoreInput = newScore => {
        if (isReadOnly) return
        if (!selectedParent) return
        const parentId = selectedParent.ParentId
        if (!parentId) return

        const max = Number(selectedParent.MaxManualScore) || 0
        const clamped = clampManualScoreValue(newScore, max)

        const updatedResponse = parentChildResponse.map(parent =>
            parent.ParentId === parentId
                ? {
                    ...parent,
                    Score: clamped,
                    IsScore: true,
                }
                : parent,
        )

        commitParentChildResponse(updatedResponse)
    }

    const handleChildManualScoreInput = (parentId, childId, newScore) => {
        if (isReadOnly) return

        const updatedResponse = parentChildResponse.map(parent => {
            if (parent.ParentId !== parentId) return parent

            const maxAllowed = getRemainingManualScore(
                parent,
                childId,
                parentChildOtherAnswers,
            )
            const clamped = clampManualScoreValue(newScore, maxAllowed)

            const nextChildren = (parent.Children || []).map(child => {
                if (child.Id !== childId) return child
                const scoreValue =
                    clamped === '' ? 0 : Number(clamped)
                return {
                    ...child,
                    Score: clamped === '' ? '' : scoreValue,
                    IsScore: true,
                    IsSelected: true,
                }
            })

            return {
                ...parent,
                IsSelected: nextChildren.some(child => child.IsSelected),
                IsScore: true,
                Children: nextChildren,
            }
        })

        commitParentChildResponse(updatedResponse)
    }

    return (
        <div className="parent-child-container">
            <div className="parent-selection mb-3">
                {/* <h4 className="mb-2">Select one option:</h4> */}
                {parentChildResponse.map(parent => (
                    <div
                        key={`parent-${parent.ParentId || Math.random()}`}
                        className="parent-option mb-2"
                    >
                        <Radio
                            label={parent.ParentName}
                            name={`parentGroup-${questionId}`}
                            checked={selectedParentId === parent.ParentId}
                            onChange={() =>
                                handleParentSelection(parent.ParentId)
                            }
                            disabled={isReadOnly}
                        />
                    </div>
                ))}
            </div>

            {selectedParentId && (() => {
                const selectedParent = parentChildResponse.find(
                    p => p.ParentId === selectedParentId,
                )
                const hasChildren = selectedParent?.Children && Array.isArray(selectedParent.Children) && selectedParent.Children.length > 0
                const showManualScore = selectedParent?.AllowManualScore

                if (!hasChildren && !showManualScore) {
                    return null
                }

                return (
                    <>
                        {hasChildren && (
                            <div className="child-selection mt-3">
                                {selectedParent?.ChildLabel && (
                                    <h5 className="mb-2">
                                        {selectedParent.ChildLabel}
                                    </h5>
                                )}
                                <div className="child-options-container">
                                    {selectedParent.Children.map(child => {
                                        const isChildSelected = !!child.IsSelected
                                        const childManualMax = showManualScore
                                            ? getRemainingManualScore(
                                                selectedParent,
                                                child.Id,
                                                parentChildOtherAnswers,
                                            )
                                            : 0

                                        return (
                                            <div
                                                key={`child-${child.Id}`}
                                                className="child-option mb-2 ms-4"
                                            >
                                                <div className="d-flex align-items-center flex-wrap">
                                                    {isMultipleAllow ? (
                                                        <Checkbox
                                                            label={child.ChildName}
                                                            checked={isChildSelected}
                                                            onChange={(e, data) =>
                                                                handleMultiChildSelection(
                                                                    selectedParentId,
                                                                    child.Id,
                                                                    data.checked,
                                                                )
                                                            }
                                                            disabled={isReadOnly}
                                                        />
                                                    ) : (
                                                        <Radio
                                                            name={`childGroup-${questionId}-${selectedParentId}`}
                                                            label={child.ChildName}
                                                            checked={
                                                                selectedChildId === child.Id
                                                            }
                                                            onChange={(e, data) =>
                                                                handleChildSelection(
                                                                    selectedParentId,
                                                                    child.Id,
                                                                    data.checked,
                                                                )
                                                            }
                                                            disabled={isReadOnly}
                                                        />
                                                    )}
                                                    {showManualScore &&
                                                        isChildSelected && (
                                                            <div className="mt-2 ms-4 d-flex align-items-center">
                                                                <div style={{ minWidth: 140 }}>
                                                                    <label
                                                                        style={{
                                                                            display: 'block',
                                                                            marginBottom: 4,
                                                                            fontSize: '0.85rem',
                                                                            color: '#666',
                                                                        }}
                                                                    >
                                                                        Manual score (max{' '}
                                                                        {childManualMax})
                                                                    </label>
                                                                    <NumericStepper
                                                                        min={0}
                                                                        max={childManualMax}
                                                                        step={1}
                                                                        value={child.Score ?? ''}
                                                                        onChange={value =>
                                                                            handleChildManualScoreInput(
                                                                                selectedParentId,
                                                                                child.Id,
                                                                                value,
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        )
                                    })}
                                    {selectedParent.IsOtherOptionAvailable && (() => {
                                        const otherSelected = isParentOtherSelected(
                                            selectedParent.ParentId,
                                        )
                                        const otherValue = getParentOtherAnswer(
                                            selectedParent.ParentId,
                                        )
                                        const otherManualMax = showManualScore
                                            ? getRemainingManualScore(
                                                selectedParent,
                                                null,
                                                parentChildOtherAnswers,
                                                true,
                                            )
                                            : 0

                                        return (
                                            <div className="child-option mb-2 ms-4">
                                                <div className="d-flex align-items-center flex-wrap">
                                                    {isMultipleAllow ? (
                                                        <Checkbox
                                                            label="Other"
                                                            checked={otherSelected}
                                                            onChange={(e, data) =>
                                                                handleParentOtherSelection(
                                                                    selectedParentId,
                                                                    data.checked,
                                                                )
                                                            }
                                                            disabled={isReadOnly}
                                                        />
                                                    ) : (
                                                        <Radio
                                                            name={`childGroup-${questionId}-${selectedParentId}`}
                                                            label="Other"
                                                            checked={otherSelected}
                                                            onChange={() =>
                                                                handleParentOtherSelection(
                                                                    selectedParentId,
                                                                    true,
                                                                )
                                                            }
                                                            disabled={isReadOnly}
                                                        />
                                                    )}
                                                    <Input
                                                        className="ms-3"
                                                        placeholder="Other"
                                                        value={otherValue}
                                                        disabled={isReadOnly || !otherSelected}
                                                        onFocus={() =>
                                                            handleParentOtherSelection(
                                                                selectedParentId,
                                                                true,
                                                            )
                                                        }
                                                        onChange={e =>
                                                            handleParentOtherTextChange(
                                                                selectedParentId,
                                                                e.target.value,
                                                            )
                                                        }
                                                    />
                                                    {showManualScore &&
                                                        otherSelected && (
                                                            <div className="mt-2 ms-4 d-flex align-items-center">
                                                                <div style={{ minWidth: 140 }}>
                                                                    <label
                                                                        style={{
                                                                            display: 'block',
                                                                            marginBottom: 4,
                                                                            fontSize: '0.85rem',
                                                                            color: '#666',
                                                                        }}
                                                                    >
                                                                        Manual score (max{' '}
                                                                        {otherManualMax})
                                                                    </label>
                                                                    <NumericStepper
                                                                        min={0}
                                                                        max={otherManualMax}
                                                                        step={1}
                                                                        value={getParentOtherScoreDisplay(
                                                                            selectedParentId,
                                                                        )}
                                                                        onChange={value =>
                                                                            handleParentOtherManualScoreInput(
                                                                                selectedParentId,
                                                                                value,
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        )
                                    })()}
                                </div>
                            </div>
                        )}
                        {!hasChildren && showManualScore && (
                            <div className="mt-2 ms-4 d-flex align-items-center">
                                <div style={{ minWidth: 120 }}>
                                    <label
                                        style={{
                                            display: 'block',
                                            marginBottom: 4,
                                            fontSize: '0.85rem',
                                            color: '#666',
                                        }}
                                    >
                                        Manual score for "{selectedParent.ParentName}" (max{' '}
                                        {Number(selectedParent.MaxManualScore) || 0})
                                    </label>
                                    <NumericStepper
                                        min={0}
                                        max={
                                            Number(selectedParent.MaxManualScore) ||
                                            undefined
                                        }
                                        step={1}
                                        value={selectedParent.Score ?? ''}
                                        onChange={handleParentManualScoreInput}
                                    />
                                </div>
                            </div>
                        )}
                    </>
                )
            })()}
        </div>
    )
}

const QuestionScoreBadge = ({ score }) => {
    if (!score || score <= 0) {
        return null
    }

    return (
        <div className="mt-2">
            <Button className="score-button-container">Score: {score}</Button>
        </div>
    )
}

const ResponseBox = ({
    question,
    section,
    onAnswerChanged,
    error,
    addMedia,
    removeMedia,
    mediaType,
    disabled,
    selectedPressResponseIds,
    isPressDependencyEnabled,
    isShowHorizontal = false,
    portalFieldLayout = false,
    showPressResetButton = false,
    onPressReset,
    onPressDown,
    choiceButtonLayout = false,
}) => {
    const { SingleResponses, MultipleResponse } = useResponses()
    const isReadOnly =
        disabled || question?.IsReadOnly || question?.IsImported || section?.IsImported
    const onAnswer = data => {
        if (isReadOnly) return // Prevent changes if read-only
        console.log('ResponseBox - Before onAnswerChanged:', {
            sectionId: section.SectionId,
            question,
            data,
        })
        onAnswerChanged(section.SectionId, question, data)
    }

    const answers = question.Answers || {}
    const cnc = answers.CNCResponse || question.CNCResponse || null
    const displayScore = getQuestionDisplayScore(question)
    return (
        <div
            className={
                portalFieldLayout ? 'portal-response-wrap w-100' : 'mt-2'
            }
        >
            {TemplateResponseType.Single === question.TypeOfResponse &&
                isFormulaQuestion(question) && (
                    <FormulaResult question={question} />
                )}
            {TemplateResponseType.Single === question.TypeOfResponse &&
                !isFormulaQuestion(question) && (
                <SingleResponseBox
                    onAnswer={onAnswer}
                    responses={SingleResponses}
                    item={question}
                    error={error}
                    mediaType={mediaType}
                    addMedia={addMedia}
                    removeMedia={removeMedia}
                    disabled={isReadOnly}
                    portalFieldLayout={portalFieldLayout}
                />
            )}
            {TemplateResponseType.Multiple === question.TypeOfResponse && (
                <MultipleResponseBox
                    item={question}
                    responses={MultipleResponse}
                    answers={question.Answers}
                    error={error}
                    onAnswer={onAnswer}
                    disabled={isReadOnly}
                    selectedPressResponseIds={selectedPressResponseIds}
                    isPressDependencyEnabled={isPressDependencyEnabled}
                    isShowHorizontal={isShowHorizontal}
                    portalFieldLayout={portalFieldLayout}
                    showPressResetButton={showPressResetButton}
                    onPressReset={onPressReset}
                    onPressDown={onPressDown}
                    choiceButtonLayout={choiceButtonLayout}
                />
            )}
            {question.Answers.ParentChildResponse && (
                <ParentChildResponseBox
                    item={question}
                    answers={question.Answers}
                    error={error}
                    onAnswer={onAnswer}
                />
            )}
            {cnc && (
                <CNCBox
                    question={question}
                    cnc={cnc}
                    onAnswer={onAnswer}
                    disabled={isReadOnly}
                />
            )}
            {displayScore > 0 && !choiceButtonLayout && (
                <QuestionScoreBadge score={displayScore} />
            )}
        </div>
    )
}

const HorizontalMediaModalGlobalStyle = createGlobalStyle`
    .ui.modal.horizontal-media-modal .horizontal-media-preview-item {
        width: 110px;
        height: 110px;
        position: relative;
        flex-shrink: 0;
        overflow: visible;
    }
    .ui.modal.horizontal-media-modal .comment-text-area-popup > div {
        width: 110px;
        height: 110px;
        display: block;
    }
    .ui.modal.horizontal-media-modal .horizontal-media-preview-item .img.col-4,
    .ui.modal.horizontal-media-modal .horizontal-media-preview-item .horizontal-modal-preview-thumb {
        width: 110px !important;
        min-width: 110px !important;
        max-width: 110px !important;
        height: 110px !important;
        flex: 0 0 110px !important;
        padding: 0 !important;
        margin: 0 !important;
        display: block !important;
        box-sizing: border-box;
        position: relative !important;
        overflow: hidden;
    }
    .ui.modal.horizontal-media-modal .horizontal-media-preview-item .img > div:not(.delete-icon):not(.rotate-icon) {
        width: 100% !important;
        height: 110px !important;
        min-height: 110px !important;
    }
    .ui.modal.horizontal-media-modal .horizontal-media-preview-item .img img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover;
        border-radius: 6px;
    }
    .ui.modal.horizontal-media-modal .horizontal-media-preview-item .delete-icon,
    .ui.modal.horizontal-media-modal .horizontal-media-preview-item .rotate-icon {
        position: absolute !important;
        top: 5px !important;
        bottom: auto !important;
        width: 26px !important;
        height: 26px !important;
        min-width: 26px !important;
        min-height: 26px !important;
        max-width: 26px !important;
        max-height: 26px !important;
        padding: 4px !important;
        margin: 0 !important;
        flex: none !important;
        z-index: 5;
    }
    .ui.modal.horizontal-media-modal .horizontal-media-preview-item .delete-icon {
        right: 5px !important;
        left: auto !important;
    }
    .ui.modal.horizontal-media-modal .horizontal-media-preview-item .rotate-icon {
        left: 5px !important;
        right: auto !important;
    }
    .ui.modal.horizontal-media-modal .horizontal-media-preview-item .rotate-icon i.icon {
        font-size: 12px !important;
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
        line-height: 1 !important;
    }
`

const NotesMediaContainer = styled(Form).attrs({
    onSubmit: event => {
        event.preventDefault()
    },
})`
    .active {
        background-color: ${({ theme }) => theme.colors.primary} !important;
        label {
            color: ${({ theme }) => theme.colors.white};
        }
    }
    .preview-media {
        height: 100px !important;
        width: 100px !important;
        min-width: 100px !important;
        max-width: 100px !important;
        flex: 0 0 100px !important;
        overflow: hidden;

        img {
            width: 100% !important;
            height: 100% !important;
            object-fit: cover;
            object-position: center;
            display: block;
            border-radius: 8px;
        }
    }
    .horizontal-media-preview-grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(140px, 1fr));
        gap: 10px;
        max-height: 62vh;
        overflow: auto;
        align-items: start;
    }
    .horizontal-media-preview-item {
        position: relative;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        padding: 6px;
        background: #fff;
    }
    .horizontal-media-preview-item img {
        width: 100%;
        height: 92px;
        object-fit: contain;
        background: #f8fafc;
        border-radius: 6px;
        display: block;
    }
    .horizontal-media-modal-preview-thumb.media-item,
    .horizontal-media-modal-preview-thumb.preview-media {
        width: 110px !important;
        height: 110px !important;
        min-width: 110px !important;
        max-width: 110px !important;
        flex: 0 0 110px !important;
    }
    .horizontal-media-modal-preview-thumb.media-item img,
    .horizontal-media-modal-preview-thumb.preview-media img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover;
        border-radius: 6px;
    }
    .horizontal-media-modal .header {
        font-size: 28px;
        font-weight: 700;
        color: #1f2937;
    }
    .horizontal-media-modal .content {
        padding: 14px !important;
        background: #f8fafc;
    }
    .horizontal-media-modal .actions {
        background: #fff !important;
    }
    .horizontal-media-modal .horizontal-media-preview-item {
        width: 110px;
        height: 110px;
        position: relative;
        flex-shrink: 0;
        overflow: visible;
    }
    .horizontal-media-modal .comment-text-area-popup > div {
        width: 110px;
        height: 110px;
        display: block;
    }
    .horizontal-media-modal .horizontal-media-preview-item .img.col-4,
    .horizontal-media-modal .horizontal-media-preview-item .horizontal-modal-preview-thumb {
        width: 110px !important;
        min-width: 110px !important;
        max-width: 110px !important;
        height: 110px !important;
        flex: 0 0 110px !important;
        padding: 0 !important;
        margin: 0 !important;
        display: block !important;
        box-sizing: border-box;
    }
    @media (max-width: 992px) {
        .horizontal-media-preview-grid {
            grid-template-columns: repeat(2, minmax(120px, 1fr));
        }
    }
    @media (max-width: 768px) {
        .horizontal-media-preview-grid {
            grid-template-columns: repeat(1, minmax(120px, 1fr));
        }
    }
    .horizontal-media-icons {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;
    }
    .horizontal-media-action-picker .ui.buttons,
    .horizontal-media-action-picker .ui.buttons .button,
    .horizontal-media-action-picker .ui.button {
        margin: 0 !important;
    }
    .horizontal-media-action-picker .ui.mini.button {
        min-width: 28px !important;
        width: 28px !important;
        height: 28px !important;
        padding: 0 !important;
        border-radius: 8px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        box-shadow: none !important;
    }
    .horizontal-media-action-picker .ui.mini.button i.icon {
        margin: 0 !important;
        font-size: 12px !important;
    }
    .horizontal-media-view-btn.ui.button {
        min-width: 28px !important;
        width: 28px !important;
        height: 28px !important;
        padding: 0 !important;
        border-radius: 8px !important;
        background: #eef2f7 !important;
        color: #3f4d63 !important;
        border: 1px solid #d8e0ea !important;
        box-shadow: none !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
    }
    .horizontal-media-view-btn.ui.button:hover {
        background: #e1e9f2 !important;
    }
    @media (max-width: 1440px) {
        .inspection-horizontal-grid thead th,
        .inspection-horizontal-grid td {
            padding: 8px 6px !important;
        }
    }
    @media (max-width: 1280px) {
        .inspection-horizontal-grid .cell-content-inline {
            flex-direction: column;
            align-items: stretch;
            gap: 6px;
        }
        .inspection-horizontal-grid .cell-media-wrap {
            padding-top: 0;
        }
    }
`

const NoteMediaActions = ({
    item,
    addNotes,
    addMedia,
    removeMedia,
    hideMedia,
    isMediaRequired,
    section,
    isReadOnly: isReadOnlyProp,
    isShowHorizontal = false,
    portalFieldLayout = false,
}) => {
    // Check if question or section is imported (read-only)
    const isReadOnly =
        isReadOnlyProp ||
        item?.IsReadOnly ||
        item?.IsImported ||
        section?.IsImported ||
        section?.SectionName === 'Imported section' ||
        typeof addNotes !== 'function'
    const [note, setNote] = useState('')
    const [notesList, setNotesList] = useState([])
    const [commentsList, setCommentsList] = useState([])
    const location = useLocation()
    const isReopened = location.state?.isReopened // Check if page was reopened
    const [IsInternal, setIsInternal] = useState(false)
    const [IsComment, setIsComment] = useState(isReopened) // Default to Comments if reopened
    const [files, setFiles] = useState([])
    const [isHorizontalPreviewOpen, setIsHorizontalPreviewOpen] = useState(false)
    const [isMediaUploading, setIsMediaUploading] = useState(false)
    const reasonPreset = useReasonPresetInspection()
    const finalNote = useDebounce(note, 250)

    const mediaSyncKey = useMemo(() => {
        const list = getQuestionMediaList(item)
        return list
            .map(
                m =>
                    `${m.MediaId ?? ''}:${m.FileKey ?? ''}:${m.SignedURL ?? m.FileURL ?? m.url ?? ''}:${m.Caption ?? ''}:${m.Comment ?? ''}`,
            )
            .join('|')
    }, [item?.Files, item?.Answers?.MediaResponse, item?.MediaAnswers])

    // Initialize files state from all media sources on the question
    useEffect(() => {
        setFiles(prev =>
            mergeLocalMediaState(
                mapInspectionQuestionMediaFiles(item),
                prev,
            ),
        )
    }, [mediaSyncKey, item?.Id])

    // Update note and notesList based on type
    useEffect(() => {
        if (IsComment) {
            const latestComment = item?.Comments?.[item.Comments.length - 1]
            setNote(latestComment?.CommentContent || '')
        } else if (IsInternal) {
            // Show the last internal note
            const internalNotes =
                item?.Notes?.filter(ele => ele.IsInternal) || []
            const latestInternal = internalNotes[internalNotes.length - 1]
            setNote(latestInternal?.Notes || '')
        } else {
            // Show the last external note
            const externalNotes =
                item?.Notes?.filter(ele => !ele.IsInternal) || []
            const latestExternal = externalNotes[externalNotes.length - 1]
            setNote(latestExternal?.Notes || '')
        }
        setNotesList(item?.Notes)
        setCommentsList(item?.Comments || [])
    }, [item?.Notes, IsInternal, item?.Comments, IsComment])

    // Handle file upload
    const onFileUpload = async data => {
        if (isReadOnly) {
            return // Don't allow file upload for read-only questions
        }
        cacheMediaUploadFiles(data)
        setIsMediaUploading(true)
        try {
            const result = await addMedia(item.Id, data, item.SectionId)
            const uploaded = Array.isArray(result) ? result.filter(Boolean) : []
            if (uploaded.length) {
                linkUploadedMediaCache(data, uploaded)
                setFiles(prev => {
                    const next = [...prev]
                    uploaded.forEach(file => {
                        const mediaId = file?.MediaId ?? file?.id
                        const idx = next.findIndex(
                            f =>
                                (mediaId != null
                                    && String(f?.MediaId ?? f?.id ?? '')
                                        === String(mediaId))
                                || (file?.FileKey
                                    && f?.FileKey === file.FileKey),
                        )
                        const previewUrl =
                            file?.SignedURL
                            || file?.FileURL
                            || file?.ImagePathUrl
                            || file?.url
                            || ''
                        const merged = {
                            ...(idx >= 0 ? next[idx] : {}),
                            ...file,
                            local: false,
                            url: previewUrl || (idx >= 0 ? next[idx]?.url : ''),
                            id: mediaId || file?.FileKey || file?.id,
                            file:
                                (idx >= 0 ? next[idx]?.file : null) ||
                                (data || []).find(
                                    d =>
                                        String(d?.MediaId ?? d?.id ?? '')
                                            === String(mediaId ?? '')
                                        || (file?.FileKey
                                            && d?.FileKey === file.FileKey),
                                )?.file,
                        }
                        if (idx >= 0) {
                            next[idx] = merged
                        } else {
                            next.push(merged)
                        }
                    })
                    return mapInspectionQuestionMediaFiles({
                        ...item,
                        Files: next,
                    })
                })
            }
        } catch (error) {
            console.error('Error uploading media:', error)
        } finally {
            setIsMediaUploading(false)
        }
    }

    const saveComment = async (mediaItem, meta) => {
        if (isReadOnly) {
            return null
        }

        const hasChanged =
            (meta.Comment ?? '') !== (mediaItem.Comment ?? '') ||
            (meta.Caption ?? '') !== (mediaItem.Caption ?? '')
        if (!hasChanged) {
            return null
        }

        // Optimistic local update so UI reflects the edit immediately
        setFiles(prev =>
            prev.map(f => {
                const match =
                    (mediaItem.MediaId && f.MediaId === mediaItem.MediaId) ||
                    (mediaItem.id && f.id === mediaItem.id)
                return match ? { ...f, ...meta } : f
            }),
        )

        try {
            const result = await addMedia(
                item.Id,
                [{ ...mediaItem, ...meta, local: false }],
                item.SectionId,
            )

            const updated = result?.[0]
            if (updated) {
                setFiles(prev =>
                    prev.map(f => {
                        const match =
                            (updated.MediaId && f.MediaId === updated.MediaId) ||
                            (mediaItem.id && f.id === mediaItem.id)
                        return match
                            ? {
                                ...f,
                                ...updated,
                                Caption: String(updated?.Caption ?? '').trim()
                                    ? updated.Caption
                                    : meta?.Caption ?? f.Caption ?? '',
                                Comment: String(updated?.Comment ?? '').trim()
                                    ? updated.Comment
                                    : meta?.Comment ?? f.Comment ?? '',
                                id: updated.MediaId || f.id,
                                url:
                                    updated.FileURL
                                    || updated.SignedURL
                                    || f.url,
                                name: updated.FileKey || f.name,
                            }
                            : f
                    }),
                )
            }

            return result
        } catch (e) {
            console.error('Error saving media caption/comment:', e)
            return null
        }
    }

    const onRotateImage = async mediaItem => {
        if (isReadOnly) {
            return
        }
        try {
            const { updatedItem } = await buildRotatedMediaItem(mediaItem, 90)
            setFiles(prev =>
                replaceMediaItemInList(prev, mediaItem, updatedItem),
            )
        } catch (error) {
            console.error('Error rotating image:', error)
        }
    }

    // Handle file removal
    const onRemoveFile = async file => {
        if (isReadOnly) {
            return
        }
        if (file?.url?.startsWith('blob:')) {
            try {
                URL.revokeObjectURL(file.url)
            } catch (e) {
                // ignore revoke errors
            }
        }
        if (typeof removeMedia === 'function') {
            const updated = await removeMedia(item.Id, file, item.SectionId)
            setFiles(mapInspectionQuestionMediaFiles(updated || item))
            return
        }
        setFiles(prev =>
            prev.filter(
                ele =>
                    ele.id !== file.id &&
                    ele.MediaId !== file.MediaId,
            ),
        )
        if (file.MediaId || file.id) {
            try {
                const mediaId = file.MediaId || file.id
                await InspectionService.deleteMedia(mediaId)
            } catch (error) {
                console.error('Error deleting media:', error)
            }
        }
    }

    // Toggle between note types
    const toggleNote = type => {
        setIsInternal(type === 'internal')
        setIsComment(type === 'comment')
    }

    // Handle blur event for saving notes/comments
    const handleBlur = async () => {
        if (isReadOnly) {
            return // Don't allow saving notes for read-only questions
        }
        console.log('handleBlur triggered')

        const internalObj = notesList.find(ele => ele.IsInternal) || {}
        const externalObj =
            notesList.find(ele => !ele.IsInternal && !ele.IsComment) || {}

        let note
        let hasNoteChanged = false

        if (IsComment) {
            const latestComment = commentsList[commentsList.length - 1] || {}
            note = {
                FAQId: item.Id,
                IsComment: true,
                SeparateComment: finalNote,
            }
            hasNoteChanged =
                (finalNote || '') !== (latestComment.CommentContent || '')
        } else if (IsInternal) {
            note = {
                FAQId: item.Id,
                IsInternal: true,
                Notes: finalNote,
            }
            hasNoteChanged = (finalNote || '') !== (internalObj.Notes || '')
        } else {
            note = {
                FAQId: item.Id,
                IsInternal: false,
                Notes: finalNote,
            }
            hasNoteChanged = (finalNote || '') !== (externalObj.Notes || '')
        }

        console.log('Note object before API call:', note)
        console.log('Has note changed?', hasNoteChanged)
        console.log('finalNote:', finalNote)

        if (hasNoteChanged) {
            try {
                if (IsComment) {
                    console.log('Calling questionComment API:', note)
                    const response = await InspectionService.questionComment(
                        note,
                    )
                    console.log('API Response:', response)
                    setCommentsList(prev => [
                        ...prev,
                        {
                            CommentId: response.CommentId,
                            FAQId: item.Id,
                            CommentContent: finalNote,
                            CommentDate: new Date().toISOString(),
                        },
                    ])
                } else {
                    console.log('Calling addNotes API:', note)
                    addNotes(item, note)
                }
                setNote(finalNote) // Update the state to reflect the saved comment
            } catch (error) {
                console.error('Error submitting comment:', error)
            }
        } else {
            console.log('No changes detected. Skipping API call.')
        }
    }

    const isMediaAllowed = item?.QuestionDisplaySetting?.IsMediaAllowed !== false
    const isNoteAllowed = item?.QuestionDisplaySetting?.IsNoteAllowed !== false
    // In strict read-only cases (like template preview), treat media as view-only:
    // no upload/remove, just preview existing files.
    const canUploadMedia = !isReadOnly && typeof addMedia === 'function'
    const hasFiles = Array.isArray(files) && files.length > 0

    if (isShowHorizontal) {
        const previewGridStyle = {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 110px)',
            gap: '12px',
            maxHeight: '52vh',
            overflow: 'auto',
            alignItems: 'start',
            justifyContent: 'start',
        }
        const previewItemStyle = {
            position: 'relative',
            width: 110,
            height: 110,
        }
        return (
            <NotesMediaContainer>
                {!hideMedia && isMediaAllowed && (
                    <div className="horizontal-media-icons">
                        {canUploadMedia && (
                            <div className="horizontal-media-action-picker">
                                <FileUploadPicker
                                    maxFiles={5}
                                    label=""
                                    customeLabel
                                    maxFileSize={500}
                                    accept={AcceptFileType.all}
                                    addedNewFiles={onFileUpload}
                                    onRemove={onRemoveFile}
                                    files={files}
                                    isUploading={isMediaUploading}
                                    remove={false}
                                    noPreview
                                    dense
                                    miniActions
                                    mediaActionIcons
                                    uploadButtonText=""
                                    captureButtonText=""
                                    stackMediaButtons={false}
                                    disabled={false}
                                />
                            </div>
                        )}
                        {hasFiles && (
                            <Button
                                type="button"
                                size="mini"
                                icon
                                className="horizontal-media-view-btn"
                                title="View uploaded media"
                                onClick={() => setIsHorizontalPreviewOpen(true)}
                            >
                                <Eye size={14} weight="bold" />
                            </Button>
                        )}
                    </div>
                )}
                {isHorizontalPreviewOpen && <HorizontalMediaModalGlobalStyle />}
                <Modal
                    open={isHorizontalPreviewOpen}
                    onClose={() => setIsHorizontalPreviewOpen(false)}
                    className="horizontal-media-modal"
                    size="small"
                    style={{ maxWidth: 520 }}
                >
                    <Modal.Header>
                        <FlexRowBetween>
                            <span>Uploaded Media</span>
                            <X
                                className="pointer"
                                size={28}
                                onClick={() => setIsHorizontalPreviewOpen(false)}
                            />
                        </FlexRowBetween>
                    </Modal.Header>
                    <Modal.Content scrolling>
                        {hasFiles ? (
                            <div
                                className="horizontal-media-preview-grid"
                                style={previewGridStyle}
                            >
                                {files.map((file, index) => {
                                    const key = String(
                                        file?.id ||
                                            file?.MediaId ||
                                            file?.url ||
                                            file?.SignedURL ||
                                            file?.FileURL ||
                                            index,
                                    )
                                    return (
                                        <div
                                            className="horizontal-media-preview-item"
                                            key={key}
                                            style={{
                                                ...previewItemStyle,
                                                overflow: 'visible',
                                                flexShrink: 0,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: 110,
                                                    height: 110,
                                                    display: 'block',
                                                }}
                                            >
                                                <CustomePreview
                                                    item={file}
                                                    saveComment={
                                                        canUploadMedia
                                                            ? saveComment
                                                            : () => {}
                                                    }
                                                    onRotate={
                                                        canUploadMedia
                                                            ? onRotateImage
                                                            : undefined
                                                    }
                                                    remove={canUploadMedia}
                                                    onRemove={
                                                        canUploadMedia
                                                            ? onRemoveFile
                                                            : undefined
                                                    }
                                                    className="horizontal-modal-preview-thumb"
                                                />
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        ) : (
                            <div>No media uploaded yet.</div>
                        )}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            onClick={() => setIsHorizontalPreviewOpen(false)}
                        >
                            Close
                        </Button>
                    </Modal.Actions>
                </Modal>
            </NotesMediaContainer>
        )
    }

    const mediaUploadBlock = canUploadMedia ? (
        <FileUploadPicker
            maxFiles={5}
            label="Media"
            maxFileSize={500}
            accept={AcceptFileType.all}
            addedNewFiles={onFileUpload}
            onRemove={onRemoveFile}
            files={files}
            isUploading={isMediaUploading}
            minHeight="100px"
            previewItem={
                <CustomePreview
                    saveComment={saveComment}
                    onRotate={onRotateImage}
                />
            }
            previewItemClassName="preview-media"
            remove
            customePreview
            defaultError={isMediaRequired}
            disabled={false}
        />
    ) : (
        <FileUploadPicker
            maxFiles={5}
            label="Media"
            maxFileSize={500}
            accept={AcceptFileType.all}
            addedNewFiles={() => {}}
            onRemove={undefined}
            files={files}
            minHeight="100px"
            previewItem={<CustomePreview saveComment={() => {}} />}
            previewItemClassName="preview-media"
            remove={false}
            customePreview
            defaultError={isMediaRequired}
            disabled
        />
    )

    const selectedReasonOption = (item?.Answers?.MultipleResponse || []).find(
        option =>
            option?.IsSelected &&
            shouldOpenReasonPopup(
                reasonPreset?.setting,
                activeReasonPresets(option),
            ),
    )
    const noteTabBar = (
        <Label className="p-0 mb-2">
            <Label
                onClick={() => !isReadOnly && toggleNote('note')}
                className={`${!IsInternal && !IsComment && 'active'}`}
            >
                <label>Notes</label>
            </Label>
            <Label
                onClick={() => !isReadOnly && toggleNote('internal')}
                className={`${IsInternal && 'active'}`}
            >
                <label>Internal Notes</label>
            </Label>
            {isReopened && (
                <Label
                    onClick={() => !isReadOnly && toggleNote('comment')}
                    className={`${IsComment && 'active'}`}
                >
                    <label>Comments</label>
                </Label>
            )}
        </Label>
    )

    const reasonPanelProps = selectedReasonOption
        ? {
              key: `${item?.Id}-${responseOptionKey(selectedReasonOption)}`,
              question: item,
              presets: activeReasonPresets(selectedReasonOption),
              setting: reasonPreset?.setting,
              auditId: reasonPreset?.auditId,
              addNotes,
              disabled: isReadOnly,
              tabs: noteTabBar,
          }
        : null

    const notesEditorBlock = (
        <Form.Field className="mb-0 col-12">
            {!IsInternal && !IsComment && reasonPanelProps ? (
                <ReasonPresetNotesPanel {...reasonPanelProps} />
            ) : (
                <>
                    {noteTabBar}
                    <NotesTextArea
                        placeholder={`Enter ${
                            // eslint-disable-next-line no-nested-ternary
                            IsInternal
                                ? 'Internal Notes'
                                : IsComment
                                  ? 'Comment'
                                  : 'Notes'
                        }`}
                        onChange={(_, noteData) =>
                            !isReadOnly && setNote(noteData.value)
                        }
                        value={note}
                        minHeight="100px"
                        onBlur={handleBlur}
                        readOnly={isReadOnly}
                        disabled={isReadOnly}
                    />
                </>
            )}
        </Form.Field>
    )

    const notesMediaDesktopRow = portalFieldLayout ? (
        <div className="portal-media-notes-row">
            {!hideMedia && isMediaAllowed && (
                <div className="portal-media-slot d-flex justify-content-start align-items-start">
                    {mediaUploadBlock}
                </div>
            )}
            {isNoteAllowed && (
                <div className="portal-notes-slot d-flex justify-content-start align-items-start">
                    {notesEditorBlock}
                </div>
            )}
        </div>
    ) : (
        <FlexRow className="justify-content-end align-items-end">
            {!hideMedia && isMediaAllowed && (
                <div className="px-2 mb-1 col-6 d-flex justify-content-start align-items-start">
                    {mediaUploadBlock}
                </div>
            )}
            {isNoteAllowed && (
                <div className="px-2 mb-1 col-6 d-flex justify-content-end align-items-start">
                    {notesEditorBlock}
                </div>
            )}
        </FlexRow>
    )

    return (
        <NotesMediaContainer>
            {isShowHorizontal ? (
                notesMediaDesktopRow
            ) : (
                <>
            <DesktopMode>
                {notesMediaDesktopRow}
            </DesktopMode>

            <MobileMode>
                <FlexColumn className="justify-content-end align-items-end mt-2">
                    {!hideMedia && isMediaAllowed && (
                        <div className="mb-1 col-12 px-0 d-flex justify-content-start align-items-start">
                            {canUploadMedia ? (
                                <FileUploadPicker
                                    maxFiles={5}
                                    label="Media"
                                    maxFileSize={500}
                                    accept={AcceptFileType.all}
                                    addedNewFiles={onFileUpload}
                                    onRemove={onRemoveFile}
                                    files={files}
                                    isUploading={isMediaUploading}
                                    previewItem={
                                        <CustomePreview
                                            saveComment={saveComment}
                                            onRotate={onRotateImage}
                                        />
                                    }
                                    previewItemClassName="preview-media"
                                    remove
                                    customePreview
                                    defaultError={isMediaRequired}
                                    maxPreview={1}
                                    disabled={false}
                                />
                            ) : (
                                // Read-only preview: show existing media only, no buttons
                                <FileUploadPicker
                                    maxFiles={5}
                                    label="Media"
                                    maxFileSize={500}
                                    accept={AcceptFileType.all}
                                    addedNewFiles={() => { }}
                                    onRemove={undefined}
                                    files={files}
                                    previewItem={
                                        <CustomePreview
                                            saveComment={() => { }}
                                        />
                                    }
                                    previewItemClassName="preview-media"
                                    remove={false}
                                    customePreview
                                    defaultError={isMediaRequired}
                                    maxPreview={1}
                                    disabled
                                />
                            )}
                        </div>
                    )}
                    {isNoteAllowed && (
                        <div className="mb-1 col-12 px-0 d-flex justify-content-end align-items-start">
                            <Form.Field className="mb-3 col-12">
                                {!IsInternal && !IsComment && reasonPanelProps ? (
                                    <ReasonPresetNotesPanel {...reasonPanelProps} />
                                ) : (
                                    <>
                                        {noteTabBar}
                                        <TextArea
                                            placeholder={`Enter ${
                                                // eslint-disable-next-line no-nested-ternary
                                                IsInternal
                                                    ? 'Internal Notes'
                                                    : IsComment
                                                        ? 'Comment'
                                                        : 'Notes'
                                            }`}
                                            onChange={(_, noteData) =>
                                                !isReadOnly && setNote(noteData.value)
                                            }
                                            value={note}
                                            rows={2}
                                            onBlur={handleBlur}
                                            readOnly={isReadOnly}
                                            disabled={isReadOnly}
                                        />
                                    </>
                                )}
                            </Form.Field>
                        </div>
                    )}
                </FlexColumn>
            </MobileMode>
                </>
            )}
        </NotesMediaContainer>
    )
}

const InfoLink = ({ question }) => {
    const [modalOpen, setModalOpen] = useState(false)

    if (!question.IsShowFullAddtionalInfo || question.IsHint) {
        return null
    }

    const hasImage = !!question.AddtionalInfoImage
    const infoText = CommonUtility.strippedHtml(question.AdditionalInfo || '')

    const getLinkText = () => {
        const words = infoText.split(' ')
        if (words.length > 2) {
            return `(${words.slice(0, 2).join(' ')}...)`
        }
        return `(${infoText})`
    }

    return (
        <>
            <span
                className="info-link"
                style={{
                    color: 'blue',
                    cursor: 'pointer',
                    marginLeft: '8px',
                }}
                onClick={() => setModalOpen(true)}
            >
                {getLinkText()}
            </span>

            <Modal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                size="small"
            >
                <Modal.Header>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Additional Information</span>
                        <X
                            size={24}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setModalOpen(false)}
                        />
                    </div>
                </Modal.Header>
                <Modal.Content>
                    {infoText && <p style={{ marginBottom: hasImage ? 16 : 0 }}>{infoText}</p>}
                    {hasImage && (
                        <img
                            src={question.AddtionalInfoImage}
                            alt="Additional Info"
                            style={{ width: '100%' }}
                        />
                    )}
                </Modal.Content>
            </Modal>
        </>
    )
}

/**
 * API nests by a shared ParentId (template group id), not the parent's question Id.
 * The parent row is IsNestedQuestion === true; follow-ups share ParentId with
 * IsNestedQuestion === false. Do not use NestedOrder alone â€” the API sends 0 on the parent too.
 */
function nestGroupKey(value) {
    if (value == null || value === '') return ''
    return String(value)
}

function partitionNestedInspectionQuestions(questions) {
    const list = questions || []
    /** group ParentId -> the question row that owns follow-ups for that group */
    const parentRowByGroupId = new Map()
    list
        .filter(q => q.IsNestedQuestion && nestGroupKey(q.ParentId))
        .forEach(q => {
            const pid = nestGroupKey(q.ParentId)
            const prev = parentRowByGroupId.get(pid)
            if (
                !prev ||
                (q.NestedOrder || 0) < (prev.NestedOrder || 0)
            ) {
                parentRowByGroupId.set(pid, q)
            }
        })

    const nestedByParent = new Map()
    list.forEach(q => {
        const pid = nestGroupKey(q.ParentId)
        if (pid) {
            const parentRow = parentRowByGroupId.get(pid)
            if (parentRow && q.Id !== parentRow.Id) {
                if (!nestedByParent.has(pid)) nestedByParent.set(pid, [])
                nestedByParent.get(pid).push(q)
            }
        }
    })
    nestedByParent.forEach(arr =>
        arr.sort(
            (a, b) => (a.NestedOrder || 0) - (b.NestedOrder || 0),
        ),
    )

    const rootQuestions = list.filter(q => {
        const pid = nestGroupKey(q.ParentId)
        if (!pid) return true
        const parentRow = parentRowByGroupId.get(pid)
        if (!parentRow) return true
        return q.Id === parentRow.Id
    })

    return { nestedByParent, rootQuestions }
}

/** Nested block rendered inside the parent question Card (below main row) */
const NestedTreePanelInsideCard = styled.div`
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e5e7eb;
    background: #f8fafc;
    border-radius: 0 0 6px 6px;
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    margin-bottom: -0.5rem;
    padding-left: 0.85rem;
    padding-right: 0.85rem;
    padding-bottom: 0.65rem;

    @media (max-width: 768px) {
        margin-left: -0.35rem;
        margin-right: -0.35rem;
        padding-left: 0.55rem;
        padding-right: 0.55rem;
    }
`

const NestedChoiceButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
`

const getInspectionRowClassName = (useHorizontalLayout, isMobile) => {
    if (useHorizontalLayout) return 'inspection-horizontal-row'
    if (isMobile) return 'flex-column'
    return ''
}

const getInspectionQuestionColClassName = (useHorizontalLayout, isMobile) => {
    if (useHorizontalLayout) return 'inspection-horizontal-question'
    if (isMobile) return 'col-12'
    return 'col-5'
}

const getInspectionActionsColClassName = (useHorizontalLayout, isMobile) => {
    if (useHorizontalLayout) return 'inspection-horizontal-actions'
    if (isMobile) return 'col-12'
    return 'col-7'
}

const QuetionBox = ({
    section,
    item,
    addNotes,
    addMedia,
    removeMedia,
    onAnswerChanged,
    error,
    /** Full section errors map (needed for nested child ids) */
    errors = {},
    showValidation,
    questionNumber,
    triggerSelections,
    selectedPressResponseIds,
    isPressDependencyEnabled,
    isReadOnly,
    isNestedInspectionChild = false,
    nestedInspectionItems,
    isShowHorizontal = false,
    showPressResetButton = false,
    onPressReset,
    onPressDown,
}) => {
    console.log('QuetionBox - Rendering with:', {
        section,
        item,
        error,
        questionNumber,
    })
    const isMobile = useTabletAndBelowMediaQuery()
    const useHorizontalLayout = isShowHorizontal
    const location = useLocation()
    const isActionPlan = location.state?.isActionPlan
    const [showTicketModal, setShowTicketModal] = useState(false)
    const [showMaintenanceModal, setShowMaintenanceModal] = useState(false)
    // review threads (question comments); without a provider nothing changes
    const questionThreads = useQuestionThreads()
    const navigate = useNavigate()
    const mediaType = useMemo(
        () => item.QuestionResponseId === ControlType.Media,
        [item],
    )
    const IsMediaRequired = useMemo(
        () =>
            error?.media ||
            (item?.Answers?.MultipleResponse?.some(
                ele => ele.IsSelected && ele.IsMediaRequired,
            ) &&
                item.Files &&
                !item.Files.length),
        [error, item],
    )
    const isInlineCheckboxQuestion =
        item?.TypeOfResponse === TemplateResponseType.Single &&
        Number(item?.QuestionResponseId) === Number(ControlType.Checkbox)
    const isDisplayOnlyHeaderQuestion =
        item?.TypeOfResponse === TemplateResponseType.Single &&
        Number(item?.QuestionResponseId) === Number(ControlType.Header)
    const isDisplayOnlyLabelQuestion =
        item?.TypeOfResponse === TemplateResponseType.Single &&
        Number(item?.QuestionResponseId) === Number(ControlType.Label)
    const isDisplayOnlyAutoNumberQuestion =
        item?.TypeOfResponse === TemplateResponseType.Single &&
        Number(item?.QuestionResponseId) === Number(ControlType.AutoNumber)
    const isDisplayOnlyQuestion =
        isDisplayOnlyHeaderQuestion ||
        isDisplayOnlyLabelQuestion ||
        isDisplayOnlyAutoNumberQuestion
    const hasHintContent = item.IsHint && (item.AdditionalInfo || item.AddtionalInfoImage)
    const nestedRequiredMark =
        isNestedInspectionChild && item.IsRequired ? (
            <span style={{ color: '#dc2626', marginLeft: 4, fontWeight: 800 }}>*</span>
        ) : null
    const questionDisplayScore = useMemo(
        () => getQuestionDisplayScore(item),
        [item],
    )

    const handleTicketModalClose = success => {
        setShowTicketModal(false)
        if (success) {
            console.log('Ticket created successfully')
        }
    }

    // "Show only questions with comments"
    if (questionThreads.isHidden(item, nestedInspectionItems)) return null

    if (isDisplayOnlyAutoNumberQuestion) {
        return (
            <div className={isNestedInspectionChild ? 'mb-2' : 'mb-3'}>
                <QuestionBox>
                    <AutoNumberInspectionDisplay item={item} />
                </QuestionBox>
            </div>
        )
    }

    if (isDisplayOnlyLabelQuestion) {
        return (
            <div className={isNestedInspectionChild ? 'mb-2' : 'mb-1'}>
                <QuestionBox>
                    <div
                        className="display-only-label"
                        dangerouslySetInnerHTML={{
                            __html: item.FAQ,
                        }}
                    />
                </QuestionBox>
            </div>
        )
    }

    let questionCardSpacingClass = 'mb-4'
    if (isNestedInspectionChild) {
        questionCardSpacingClass = 'mb-2'
    } else if (isShowHorizontal) {
        questionCardSpacingClass = 'mb-0'
    }

    if (isDisplayOnlyHeaderQuestion) {
        return (
            <Card
                className={`w-100 ${questionCardSpacingClass} p-3 ${isShowHorizontal ? 'inspection-table-row-card' : ''}`}
                style={
                    isNestedInspectionChild
                        ? {
                            borderLeft: '3px solid #86efac',
                            boxShadow: '0 1px 2px rgba(15,23,42,0.06)',
                        }
                        : undefined
                }
            >
                <QuestionBox>
                    <div
                        className="display-only-header"
                        dangerouslySetInnerHTML={{
                            __html: item.FAQ,
                        }}
                    />
                </QuestionBox>
            </Card>
        )
    }

    return (
        <>
            <Card
                className={`w-100 ${isNestedInspectionChild ? 'mb-2' : 'mb-4'} p-3`}
                style={
                    isNestedInspectionChild
                        ? {
                            borderLeft: '3px solid #86efac',
                            boxShadow: '0 1px 2px rgba(15,23,42,0.06)',
                        }
                        : undefined
                }
            >
                <QuestionBox>
                    <FlexRow
                        className={
                            isNestedInspectionChild
                                ? 'flex-column'
                                : getInspectionRowClassName(
                                    useHorizontalLayout,
                                    isMobile,
                                )
                        }
                    >
                        <FlexColumn
                            className={
                                isNestedInspectionChild
                                    ? 'col-12'
                                    : getInspectionQuestionColClassName(
                                        useHorizontalLayout,
                                        isMobile,
                                    )
                            }
                        >
                            {(() => {
                                if (isInlineCheckboxQuestion) {
                                    const isInlineQuestionReadOnly =
                                        isReadOnly ||
                                        item.IsReadOnly ||
                                        item.IsImported ||
                                        section.IsImported
                                    const inlineCheckboxChecked =
                                        item?.Answers?.SingleResponse?.Response === 'true' ||
                                        item?.Answers?.SingleResponse?.IsSelected === true

                                    return (
                                        <div className="d-flex align-items-start">
                                            <Checkbox
                                                className="flex-shrink-0 align-self-start"
                                                checked={inlineCheckboxChecked}
                                                disabled={isInlineQuestionReadOnly}
                                                onChange={(e, data) => {
                                                    if (isInlineQuestionReadOnly) return
                                                    const newValue = data.checked ? 'true' : 'false'
                                                    onAnswerChanged(section.SectionId, item, {
                                                        Response: newValue,
                                                        IsSelected: data.checked,
                                                    })
                                                }}
                                            />
                                            <div className="d-flex align-items-start ms-2 flex-grow-1">
                                                {typeof questionNumber === 'number' && (
                                                    <strong className="me-2">{questionNumber}.</strong>
                                                )}
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.FAQ,
                                                    }}
                                                />
                                                {nestedRequiredMark}
                                                <InfoLink question={item} />
                                            </div>
                                        </div>
                                    )
                                }

                                if (hasHintContent) {
                                    return (
                                        <Popup
                                            trigger={
                                                <div className="question-tooltip-container">
                                                    <div className="d-flex align-items-start">
                                                        {typeof questionNumber === 'number' && (
                                                            <strong className="me-2">{questionNumber}.</strong>
                                                        )}
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: item.FAQ,
                                                            }}
                                                        />
                                                        {nestedRequiredMark}
                                                    </div>
                                                </div>
                                            }
                                            content={
                                                <div>
                                                    {item.AdditionalInfo && (
                                                        <div>{item.AdditionalInfo}</div>
                                                    )}
                                                    {item.AddtionalInfoImage && (
                                                        <div className="mt-2">
                                                            <img
                                                                src={
                                                                    item.AddtionalInfoImage
                                                                }
                                                                alt="Additional Info"
                                                                className="additional-info-image"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                            position="bottom center"
                                            size="small"
                                            hoverable
                                            mouseEnterDelay={200}
                                            on="hover"
                                            basic={false}
                                            style={{
                                                opacity: 1,
                                                background: 'white',
                                                padding: '10px',
                                            }}
                                        />
                                    )
                                }

                                return (
                                    <div className="d-flex align-items-start">
                                        {typeof questionNumber === 'number' && (
                                            <strong className="me-2">{questionNumber}.</strong>
                                        )}
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: item.FAQ,
                                            }}
                                        />
                                        {nestedRequiredMark}
                                        <InfoLink question={item} />
                                    </div>
                                )
                            })()}
                            {!isInlineCheckboxQuestion && !isDisplayOnlyQuestion && (
                                <ResponseBox
                                    onAnswerChanged={onAnswerChanged}
                                    section={section}
                                    question={item}
                                    error={error}
                                    addMedia={addMedia}
                                    removeMedia={removeMedia}
                                    mediaType={mediaType}
                                    disabled={isReadOnly || item.IsReadOnly || item.IsImported || section.IsImported}
                                    selectedPressResponseIds={
                                        selectedPressResponseIds
                                    }
                                    isPressDependencyEnabled={isPressDependencyEnabled}
                                    isShowHorizontal={isShowHorizontal}
                                    showPressResetButton={showPressResetButton}
                                    onPressReset={onPressReset}
                                    onPressDown={onPressDown}
                                    choiceButtonLayout={
                                        isNestedInspectionChild &&
                                        item?.TypeOfResponse ===
                                            TemplateResponseType.Multiple
                                    }
                                />
                            )}
                            {isInlineCheckboxQuestion && (
                                <QuestionScoreBadge score={questionDisplayScore} />
                            )}
                            <QuestionSpecificationReference
                                question={item}
                                triggerSelections={triggerSelections}
                            />
                            <span className="error">
                                {(error?.message && error.message) ||
                                    (item.IsRequired &&
                                        item.RequiredMessage &&
                                        showValidation &&
                                        error &&
                                        !error.message && (
                                            <>{item.RequiredMessage}</>
                                        )) ||
                                    (IsMediaRequired && 'Media required')}
                            </span>
                            {isActionPlan && (
                                <div className="mt-3">
                                    <AppPrimaryButton
                                        type="button"
                                        className="ui primary button"
                                        onClick={() => setShowTicketModal(true)}
                                    >
                                        Raise Ticket
                                    </AppPrimaryButton>
                                    <AppSecondaryButton
                                        type="button"
                                        onClick={() => setShowMaintenanceModal(true)}
                                    >
                                        Create Maintenance Task
                                    </AppSecondaryButton>
                                    {item.ActionPlans &&
                                        item.ActionPlans.length > 0 && (
                                            <AppSecondaryButton
                                                type="button"
                                                onClick={() =>
                                                    navigate(
                                                        `/app/action-plan/view/${item.Id}`,
                                                    )
                                                }
                                            >
                                                View Action Plan
                                            </AppSecondaryButton>
                                        )}
                                </div>
                            )}
                        </FlexColumn>
                        <div
                            className={
                                isNestedInspectionChild
                                    ? 'col-12 mt-2'
                                    : getInspectionActionsColClassName(
                                        useHorizontalLayout,
                                        isMobile,
                                    )
                            }
                        >
                            <NoteMediaActions
                                item={item}
                                addMedia={addMedia}
                                removeMedia={removeMedia}
                                addNotes={addNotes}
                                hideMedia={mediaType}
                                isMediaRequired={IsMediaRequired}
                                error={error}
                                section={section}
                                isReadOnly={isReadOnly}
                                isShowHorizontal={isShowHorizontal}
                            />
                        </div>
                    </FlexRow>
                </QuestionBox>
                <QuestionThreadSlot item={item} />
                {nestedInspectionItems &&
                    nestedInspectionItems.length > 0 && (
                        <NestedQuestionGroup
                            parentQuestion={item}
                            nestedItems={nestedInspectionItems}
                            section={section}
                            addNotes={addNotes}
                            addMedia={addMedia}
                            removeMedia={removeMedia}
                            onAnswerChanged={onAnswerChanged}
                            errors={errors}
                            showValidation={showValidation}
                            triggerSelections={triggerSelections}
                            selectedPressResponseIds={
                                selectedPressResponseIds
                            }
                            isPressDependencyEnabled={
                                isPressDependencyEnabled
                            }
                            isReadOnly={isReadOnly}
                            isShowHorizontal={isShowHorizontal}
                        />
                    )}
            </Card>
            {showMaintenanceModal && (
                <CreateMaintenanceFromFinding
                    auditId={item.AuditUniqueId}
                    questionId={item.Id}
                    answerId={
                        (item.Answers?.MultipleResponse || []).find(
                            r => r.IsSelected,
                        )?.Id
                    }
                    onClose={() => setShowMaintenanceModal(false)}
                />
            )}
            <RaiseTicketModal
                open={showTicketModal}
                onClose={handleTicketModalClose}
                question={item}
                answer={item.Answers}
                templateId={section.TemplateId}
                auditId={item.AuditUniqueId}
            />
        </>
    )
}

function NestedQuestionGroup({
    nestedItems,
    section,
    addNotes,
    addMedia,
    removeMedia,
    onAnswerChanged,
    errors,
    showValidation,
    triggerSelections,
    selectedPressResponseIds,
    isPressDependencyEnabled,
    isReadOnly,
    isShowHorizontal = false,
}) {
    if (!nestedItems.length) return null

    return (
        <NestedTreePanelInsideCard>
            <div className="nested-inspection-children">
                {nestedItems.map((child, index) => (
                    <div key={child.Id} className="mb-2">
                        <QuetionBox
                            section={section}
                            item={child}
                            onAnswerChanged={onAnswerChanged}
                            error={errors[child.Id]}
                            errors={errors}
                            addMedia={addMedia}
                            removeMedia={removeMedia}
                            addNotes={addNotes}
                            showValidation={showValidation}
                            questionNumber={index + 1}
                            triggerSelections={triggerSelections}
                            selectedPressResponseIds={
                                selectedPressResponseIds
                            }
                            isPressDependencyEnabled={
                                isPressDependencyEnabled
                            }
                            isReadOnly={isReadOnly}
                            isNestedInspectionChild
                            isShowHorizontal={isShowHorizontal}
                        />
                    </div>
                ))}
            </div>
        </NestedTreePanelInsideCard>
    )
}

const InspectionTableHeader = () => (
    <div className="inspection-table-header">
        <div className="inspection-table-header-question">Question</div>
        <div className="inspection-table-header-actions">
            <div className="inspection-table-header-media">Media</div>
            <div className="inspection-table-header-notes">Notes</div>
        </div>
    </div>
)

const buildHorizontalQuestionKey = question => {
    const faqText = CommonUtility.strippedHtml(question?.FAQ || '').trim()
    if (faqText) {
        return faqText.toLowerCase()
    }
    return String(
        question?.QuestionOriginalId ||
            question?.QuestionId ||
            question?.Id ||
            question?.UId ||
            question?.Uid ||
            '',
    ).trim()
}

const getHorizontalQuestionLabel = question => {
    const faqText = CommonUtility.htmlToPlainText(question?.FAQ || '')
    if (faqText) return faqText
    return 'Question'
}

const HorizontalTableSectionTitle = styled.div`
    margin: 0 0 0.5rem;
    padding: 0;
    font-weight: 700;
    font-size: 1rem;
    color: #1f2937;
    background: none;
    border: none;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
`

const HorizontalTableWrap = styled.div`
    margin-bottom: 1rem;
`

const HorizontalInspectionTable = ({
    sections,
    onAnswerChanged,
    errors,
    addMedia,
    removeMedia,
    addNotes,
    selectedPressResponseIds,
    isPressDependencyEnabled,
    showValidation,
    isReadOnly,
    horizontalTableMode = 'default',
    triggerSelections = {},
}) => {
    const { user } = useAuth()
    const usePlatenLikeTable = horizontalTableMode === 'platen_like'
    const columns = useMemo(() => {
        const seen = new Set()
        const collected = []
        sections.forEach(section => {
            const { rootQuestions } = partitionNestedInspectionQuestions(section?.Questions || [])
            rootQuestions.forEach(question => {
                if (
                    usePlatenLikeTable &&
                    Number(question?.QuestionResponseId) === Number(ControlType.Media)
                ) {
                    return
                }
                const key = buildHorizontalQuestionKey(question)
                if (
                    usePlatenLikeTable &&
                    (key === 'deck#' || key === 'platen #')
                ) {
                    return
                }
                if (!key || seen.has(key)) return
                seen.add(key)
                collected.push({
                    key,
                    label: getHorizontalQuestionLabel(question),
                    isTextArea:
                        Number(question?.QuestionResponseId) ===
                        Number(ControlType.TextArea),
                })
            })
        })
        return collected
    }, [sections, usePlatenLikeTable])

    const rows = useMemo(
        () => {
            const mapped = sections.map((section, sectionIndex) => {
                const { rootQuestions } = partitionNestedInspectionQuestions(section?.Questions || [])
                const questionByKey = {}
                let mediaQuestion = null
                rootQuestions.forEach(question => {
                    if (
                        Number(question?.QuestionResponseId) === Number(ControlType.Media) &&
                        !mediaQuestion
                    ) {
                        mediaQuestion = question
                    }
                    const key = buildHorizontalQuestionKey(question)
                    if (key) {
                        questionByKey[key] = question
                    }
                })
                return {
                    section,
                    sectionIndex,
                    questionByKey,
                    mediaQuestion,
                }
            })
            return usePlatenLikeTable ? [...mapped].reverse() : mapped
        },
        [sections, usePlatenLikeTable],
    )

    const showUniformAnswerColumn = useMemo(
        () =>
            user?.CompanyId !== HIDE_SECTION_UNIFORM_ANSWERS_COMPANY_ID &&
            rows.some(row => getSectionUniformRadio(row.section)),
        [rows, user?.CompanyId],
    )

    const applyRowUniformAnswer = (section, displayText) => {
        const sample = getSectionUniformRadio(section)?.questions?.[0]
        if (
            !sample ||
            isReadOnly ||
            isSectionNASelected(section) ||
            typeof onAnswerChanged !== 'function'
        ) {
            return
        }
        onAnswerChanged(section.SectionId, sample, {
            [UNIFORM_RADIO_ANSWER_FIELD]: displayText,
        })
    }

    const firstSection = useMemo(
        () => (sections || []).find(section => section?.SectionName) || null,
        [sections],
    )

    const sectionDisplayName = useMemo(() => {
        if (!firstSection?.SectionName) {
            return ''
        }
        return CommonUtility.htmlToPlainText(firstSection.SectionName)
    }, [firstSection])

    if (!columns.length || !rows.length) {
        return null
    }

    return (
        <HorizontalTableWrap>
            {sectionDisplayName ? (
                <HorizontalTableSectionTitle>
                    <span>{sectionDisplayName}</span>
                    <SectionUrlLink
                        url={getSectionUrlFromSection(firstSection)}
                        triggerSelections={triggerSelections}
                    />
                </HorizontalTableSectionTitle>
            ) : null}
            <div className="inspection-horizontal-scroll">
            <Table
                celled
                compact="very"
                unstackable
                className="inspection-horizontal-grid"
            >
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell style={{ width: 48 }}>
                            {usePlatenLikeTable ? 'Deck #' : '#'}
                        </Table.HeaderCell>
                        {showUniformAnswerColumn && (
                            <Table.HeaderCell style={{ minWidth: 180 }}>
                                All
                            </Table.HeaderCell>
                        )}
                        {columns.map(column => (
                            <Table.HeaderCell
                                key={column.key}
                                style={{
                                    minWidth: column.isTextArea ? 440 : 240,
                                }}
                            >
                                {column.label}
                            </Table.HeaderCell>
                        ))}
                        {usePlatenLikeTable && (
                            <Table.HeaderCell style={{ minWidth: 180 }}>
                                MEDIA
                            </Table.HeaderCell>
                        )}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {rows.map((row, rowIndex) => (
                        <Table.Row key={row.section.SectionId}>
                            <Table.Cell className="row-label-cell">
                                {usePlatenLikeTable
                                    ? rows.length - rowIndex
                                    : row.sectionIndex + 1}
                            </Table.Cell>
                            {showUniformAnswerColumn && (
                                <Table.Cell>
                                    <SectionUniformAnswers
                                        section={row.section}
                                        disabled={
                                            isReadOnly ||
                                            isSectionNASelected(row.section)
                                        }
                                        tone="light"
                                        onApply={displayText =>
                                            applyRowUniformAnswer(
                                                row.section,
                                                displayText,
                                            )
                                        }
                                    />
                                </Table.Cell>
                            )}
                            {columns.map(column => {
                            const question = row.questionByKey[column.key]
                            if (!question) {
                                return <Table.Cell key={`${row.section.SectionId}-${column.key}`} />
                            }
                            const error = errors?.[question.Id]
                            const mediaType =
                                question.QuestionResponseId === ControlType.Media
                            const disabled =
                                isReadOnly ||
                                question.IsReadOnly ||
                                question.IsImported ||
                                row.section.IsImported
                            const isMediaRequired =
                                error?.media ||
                                (question?.Answers?.MultipleResponse?.some(
                                    ele => ele.IsSelected && ele.IsMediaRequired,
                                ) &&
                                    question.Files &&
                                    !question.Files.length)
                            const isMediaAllowed =
                                question?.QuestionDisplaySetting?.IsMediaAllowed !== false
                            const mediaOnlyQuestion = {
                                ...question,
                                QuestionDisplaySetting: {
                                    ...(question?.QuestionDisplaySetting || {}),
                                    IsNoteAllowed: false,
                                },
                            }
                                return (
                                    <Table.Cell
                                        key={`${row.section.SectionId}-${column.key}`}
                                        className="cell-question"
                                        style={{
                                            minWidth: column.isTextArea ? 440 : 240,
                                        }}
                                    >
                                        {mediaType ? (
                                            <div className="cell-media-wrap">
                                                <NoteMediaActions
                                                    item={mediaOnlyQuestion}
                                                    addMedia={addMedia}
                                                    removeMedia={removeMedia}
                                                    addNotes={addNotes}
                                                    hideMedia={false}
                                                    isMediaRequired={isMediaRequired}
                                                    error={error}
                                                    section={row.section}
                                                    isReadOnly={isReadOnly}
                                                    isShowHorizontal
                                                />
                                            </div>
                                        ) : (
                                            <div className="cell-content-inline">
                                                <div className="cell-answer-wrap">
                                                    <ResponseBox
                                                        onAnswerChanged={onAnswerChanged}
                                                        section={row.section}
                                                        question={question}
                                                        error={error}
                                                        addMedia={addMedia}
                                                        removeMedia={removeMedia}
                                                        mediaType={mediaType}
                                                        disabled={disabled}
                                                        selectedPressResponseIds={selectedPressResponseIds}
                                                        isPressDependencyEnabled={isPressDependencyEnabled}
                                                        isShowHorizontal
                                                    />
                                                </div>
                                                {!usePlatenLikeTable && isMediaAllowed && (
                                                    <div className="cell-media-wrap">
                                                        <NoteMediaActions
                                                            item={mediaOnlyQuestion}
                                                            addMedia={addMedia}
                                                            removeMedia={removeMedia}
                                                            addNotes={addNotes}
                                                            hideMedia={false}
                                                            isMediaRequired={isMediaRequired}
                                                            error={error}
                                                            section={row.section}
                                                            isReadOnly={isReadOnly}
                                                            isShowHorizontal
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <span className="error">
                                            {(error?.message && error.message) ||
                                                (question.IsRequired &&
                                                    question.RequiredMessage &&
                                                    showValidation &&
                                                    error &&
                                                    !error.message && (
                                                        <>{question.RequiredMessage}</>
                                                    ))}
                                        </span>
                                    </Table.Cell>
                                )
                            })}
                            {usePlatenLikeTable && (
                                <Table.Cell key={`${row.section.SectionId}-media`}>
                                    {row.mediaQuestion ? (
                                        <div className="cell-media-wrap">
                                            <NoteMediaActions
                                                item={{
                                                    ...row.mediaQuestion,
                                                    QuestionDisplaySetting: {
                                                        ...(row.mediaQuestion
                                                            ?.QuestionDisplaySetting || {}),
                                                        IsNoteAllowed: false,
                                                    },
                                                }}
                                                addMedia={addMedia}
                                                removeMedia={removeMedia}
                                                addNotes={addNotes}
                                                hideMedia={false}
                                                isMediaRequired={
                                                    errors?.[row.mediaQuestion.Id]?.media
                                                }
                                                error={errors?.[row.mediaQuestion.Id]}
                                                section={row.section}
                                                isReadOnly={isReadOnly}
                                                isShowHorizontal
                                            />
                                        </div>
                                    ) : null}
                                </Table.Cell>
                            )}
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
            </div>
        </HorizontalTableWrap>
    )
}

/** Claim-portal field: label + full-width response, media/notes on row below (no question Card). */
const PortalQuestionField = ({
    section,
    item,
    addNotes,
    addMedia,
    removeMedia,
    onAnswerChanged,
    error,
    showValidation,
    questionNumber,
    triggerSelections,
    selectedPressResponseIds,
    isPressDependencyEnabled,
    isReadOnly,
    nestedInspectionItems,
    errors = {},
    showPressResetButton = false,
    onPressReset,
    onPressDown,
    isNestedChild = false,
}) => {
    const mediaType = item.QuestionResponseId === ControlType.Media
    const IsMediaRequired = useMemo(
        () =>
            error?.media ||
            (item?.Answers?.MultipleResponse?.some(
                ele => ele.IsSelected && ele.IsMediaRequired,
            ) &&
                item.Files &&
                !item.Files.length),
        [error, item],
    )
    const isInlineCheckboxQuestion =
        item?.TypeOfResponse === TemplateResponseType.Single &&
        Number(item?.QuestionResponseId) === Number(ControlType.Checkbox)
    const isDisplayOnlyHeaderQuestion =
        item?.TypeOfResponse === TemplateResponseType.Single &&
        Number(item?.QuestionResponseId) === Number(ControlType.Header)
    const isDisplayOnlyLabelQuestion =
        item?.TypeOfResponse === TemplateResponseType.Single &&
        Number(item?.QuestionResponseId) === Number(ControlType.Label)
    const isDisplayOnlyAutoNumberQuestion =
        item?.TypeOfResponse === TemplateResponseType.Single &&
        Number(item?.QuestionResponseId) === Number(ControlType.AutoNumber)
    const isDisplayOnlyQuestion =
        isDisplayOnlyHeaderQuestion ||
        isDisplayOnlyLabelQuestion ||
        isDisplayOnlyAutoNumberQuestion

    const isMediaAllowed = item?.QuestionDisplaySetting?.IsMediaAllowed !== false
    const isNoteAllowed = item?.QuestionDisplaySetting?.IsNoteAllowed !== false
    const showMediaNotesRow =
        (isMediaAllowed && !mediaType) || isNoteAllowed
    const questionDisplayScore = useMemo(
        () => getQuestionDisplayScore(item),
        [item],
    )

    const labelHtml = item?.FAQ || ''

    if (isDisplayOnlyAutoNumberQuestion) {
        return (
            <PortalSectionFieldCell>
                <AutoNumberInspectionDisplay item={item} />
            </PortalSectionFieldCell>
        )
    }

    if (isDisplayOnlyLabelQuestion) {
        return (
            <PortalSectionFieldCell>
                <div
                    className="display-only-label"
                    dangerouslySetInnerHTML={{ __html: labelHtml }}
                />
            </PortalSectionFieldCell>
        )
    }

    if (isDisplayOnlyHeaderQuestion) {
        return (
            <PortalSectionFieldCell style={{ gridColumn: '1 / -1' }}>
                <div
                    className="display-only-header"
                    dangerouslySetInnerHTML={{ __html: labelHtml }}
                />
            </PortalSectionFieldCell>
        )
    }

    return (
        <PortalSectionFieldCell>
            <PortalInspectionForm>
                <PortalQuestionLabel>
                    {typeof questionNumber === 'number' && (
                        <span className="portal-question-number">
                            {questionNumber}.
                        </span>
                    )}
                    <span
                        className="portal-question-text"
                        dangerouslySetInnerHTML={{
                            __html: labelHtml || 'Question',
                        }}
                    />
                    <InfoLink question={item} />
                </PortalQuestionLabel>
                <PortalQuestionResponseRow>
                    {!isInlineCheckboxQuestion && !isDisplayOnlyQuestion && (
                        <ResponseBox
                            onAnswerChanged={onAnswerChanged}
                            section={section}
                            question={item}
                            error={error}
                            addMedia={addMedia}
                            removeMedia={removeMedia}
                            mediaType={mediaType}
                            disabled={
                                isReadOnly ||
                                item.IsReadOnly ||
                                item.IsImported ||
                                section.IsImported
                            }
                            selectedPressResponseIds={selectedPressResponseIds}
                            isPressDependencyEnabled={isPressDependencyEnabled}
                            isShowHorizontal={false}
                            portalFieldLayout
                            choiceButtonLayout={
                                isNestedChild &&
                                item?.TypeOfResponse ===
                                    TemplateResponseType.Multiple
                            }
                            showPressResetButton={showPressResetButton}
                            onPressReset={onPressReset}
                            onPressDown={onPressDown}
                        />
                    )}
                    {isInlineCheckboxQuestion && (
                        <Checkbox
                            checked={
                                item?.Answers?.SingleResponse?.Response ===
                                    'true' ||
                                item?.Answers?.SingleResponse?.IsSelected ===
                                    true
                            }
                            disabled={
                                isReadOnly ||
                                item.IsReadOnly ||
                                item.IsImported ||
                                section.IsImported
                            }
                            onChange={(e, data) => {
                                if (isReadOnly) return
                                const newValue = data.checked ? 'true' : 'false'
                                onAnswerChanged(section.SectionId, item, {
                                    Response: newValue,
                                    IsSelected: data.checked,
                                })
                            }}
                        />
                    )}
                    {isInlineCheckboxQuestion && (
                        <QuestionScoreBadge score={questionDisplayScore} />
                    )}
                    <QuestionSpecificationReference
                        question={item}
                        triggerSelections={triggerSelections}
                    />
                    <span className="error">
                        {(error?.message && error.message) ||
                            (item.IsRequired &&
                                item.RequiredMessage &&
                                showValidation &&
                                error &&
                                !error.message && (
                                    <>{item.RequiredMessage}</>
                                )) ||
                            (IsMediaRequired && 'Media required')}
                    </span>
                </PortalQuestionResponseRow>
                {showMediaNotesRow && (
                    <PortalQuestionMediaNotesRow>
                        <NoteMediaActions
                            item={item}
                            addMedia={addMedia}
                            removeMedia={removeMedia}
                            addNotes={addNotes}
                            hideMedia={mediaType}
                            isMediaRequired={IsMediaRequired}
                            error={error}
                            section={section}
                            isReadOnly={isReadOnly}
                            portalFieldLayout
                        />
                    </PortalQuestionMediaNotesRow>
                )}
            </PortalInspectionForm>
            {nestedInspectionItems && nestedInspectionItems.length > 0 && (
                <div
                    className="mt-3"
                    style={{
                        borderLeft: '3px solid #86efac',
                        paddingLeft: 12,
                    }}
                >
                    {nestedInspectionItems.map(child => (
                        <PortalQuestionField
                            key={child.Id}
                            section={section}
                            item={child}
                            onAnswerChanged={onAnswerChanged}
                            error={errors[child.Id]}
                            errors={errors}
                            addMedia={addMedia}
                            removeMedia={removeMedia}
                            addNotes={addNotes}
                            showValidation={showValidation}
                            triggerSelections={triggerSelections}
                            selectedPressResponseIds={selectedPressResponseIds}
                            isPressDependencyEnabled={isPressDependencyEnabled}
                            isReadOnly={isReadOnly}
                            isNestedChild
                        />
                    ))}
                </div>
            )}
        </PortalSectionFieldCell>
    )
}

const SectionBox = ({
    item,
    addNotes,
    addMedia,
    removeMedia,
    onAnswerChanged,
    errors,
    copySection,
    removeSection,
    showValidation,
    printByTemplate,
    resetBySection,
    isOpen,
    onToggle,
    triggerSelections,
    showNumbering,
    selectedPressResponseIds,
    isPressDependencyEnabled,
    activePressSpecificationReference,
    isReadOnly,
    isShowHorizontal = false,
    portalCardSectionIds = [],
    portalCardSectionNames = [],
    pressResetQuestionId = null,
    onPressReset,
    onPressDown,
    onSectionNAChange,
    copyButtonLabel = 'Copy',
    getCopyButtonLabel,
}) => {
    const { user } = useAuth()
    const open = isOpen !== undefined ? isOpen : true
    const handleToggle = onToggle || (() => { })
    const isMobile = useTabletAndBelowMediaQuery()
    const isImportedSection = item.IsImported || item.SectionName === 'Imported section'
    const isPressSection = CommonUtility.strippedHtml(item?.SectionName || '')
        .trim()
        .toLowerCase()
        .includes('press selection')
    const sectionIsNA = isSectionNASelected(item)
    const sectionReadOnly = isReadOnly || sectionIsNA
    const showSectionNA = canShowSectionNA(item)
    const copyDisabled = isReadOnly
    const sectionCopyButtonLabel =
        typeof getCopyButtonLabel === 'function'
            ? getCopyButtonLabel(item)
            : copyButtonLabel
    const applySectionUniformAnswer = displayText => {
        const sample = getSectionUniformRadio(item)?.questions?.[0]
        if (!sample || sectionReadOnly || typeof onAnswerChanged !== 'function') {
            return
        }
        onAnswerChanged(item.SectionId, sample, {
            [UNIFORM_RADIO_ANSWER_FIELD]: displayText,
        })
    }

    const { nestedByParent, rootQuestions } = useMemo(
        () => partitionNestedInspectionQuestions(item.Questions),
        [item.Questions],
    )

    const usePortalCardLayout =
        !isShowHorizontal &&
        isPortalCardSection(
            item,
            portalCardSectionIds,
            portalCardSectionNames,
        )

    const isPressResetQuestion = question =>
        (!!onPressReset || !!onPressDown) &&
        pressResetQuestionId != null &&
        String(question?.Id) === String(pressResetQuestionId)

    const renderPortalQuestionFields = () =>
        rootQuestions.map((ele, idx) => {
            const nestedKids =
                ele.IsNestedQuestion &&
                ele.ParentId != null &&
                ele.ParentId !== ''
                    ? nestedByParent.get(nestGroupKey(ele.ParentId)) || []
                    : []
            return (
                <PortalQuestionField
                    key={ele.Id}
                    section={item}
                    item={ele}
                    onAnswerChanged={onAnswerChanged}
                    error={errors[ele.Id]}
                    errors={errors}
                    addMedia={addMedia}
                    removeMedia={removeMedia}
                    addNotes={addNotes}
                    showValidation={showValidation}
                    questionNumber={(() => {
                        if (user.CompanyId === 34930) {
                            return showNumbering ? idx + 1 : undefined
                        }
                        if (!printByTemplate) return undefined
                        if (resetBySection) return idx + 1
                        const offset = item.__questionOffset || 0
                        return offset + idx + 1
                    })()}
                    triggerSelections={triggerSelections}
                    selectedPressResponseIds={selectedPressResponseIds}
                    isPressDependencyEnabled={isPressDependencyEnabled}
                    isReadOnly={sectionReadOnly}
                    showPressResetButton={isPressResetQuestion(ele)}
                    onPressReset={onPressReset}
                    onPressDown={onPressDown}
                    nestedInspectionItems={
                        nestedKids.length > 0 && ele.IsNestedQuestion
                            ? nestedKids
                            : undefined
                    }
                />
            )
        })

    const renderQuestionFields = (showHorizontalFlag, wrapperClassName) =>
        rootQuestions.map((ele, idx) => {
            const nestedKids =
                ele.IsNestedQuestion &&
                ele.ParentId != null &&
                ele.ParentId !== ''
                    ? nestedByParent.get(nestGroupKey(ele.ParentId)) || []
                    : []
            const questionNode = (
                <QuetionBox
                    section={item}
                    item={ele}
                    onAnswerChanged={onAnswerChanged}
                    error={errors[ele.Id]}
                    errors={errors}
                    addMedia={addMedia}
                    removeMedia={removeMedia}
                    addNotes={addNotes}
                    showValidation={showValidation}
                    triggerSelections={triggerSelections}
                    selectedPressResponseIds={selectedPressResponseIds}
                    isPressDependencyEnabled={isPressDependencyEnabled}
                    isReadOnly={sectionReadOnly}
                    showPressResetButton={isPressResetQuestion(ele)}
                    onPressReset={onPressReset}
                    onPressDown={onPressDown}
                    questionNumber={(() => {
                        if (user.CompanyId === 34930) {
                            return showNumbering ? idx + 1 : undefined
                        }
                        if (!printByTemplate) return undefined
                        if (resetBySection) return idx + 1
                        const offset = item.__questionOffset || 0
                        return offset + idx + 1
                    })()}
                    nestedInspectionItems={
                        nestedKids.length > 0 && ele.IsNestedQuestion
                            ? nestedKids
                            : undefined
                    }
                    isShowHorizontal={showHorizontalFlag}
                />
            )
            if (wrapperClassName) {
                return (
                    <PortalSectionFieldCell key={ele.Id} className={wrapperClassName}>
                        {questionNode}
                    </PortalSectionFieldCell>
                )
            }
            return (
                <div key={ele.Id} className={`${isMobile && 'px-0'} col-12`}>
                    {questionNode}
                </div>
            )
        })

    if (usePortalCardLayout) {
        return (
            <PortalSectionCard className="mt-4">
                <PortalSectionCardHeader>
                    <span
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            flexWrap: 'wrap',
                        }}
                    >
                        <span>{item.SectionName}</span>
                        <SectionUrlLink
                            url={getSectionUrlFromSection(item)}
                            triggerSelections={triggerSelections}
                        />
                    </span>
                    <span
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            flexWrap: 'wrap',
                        }}
                    >
                        <SectionUniformAnswers
                            section={item}
                            disabled={sectionReadOnly}
                            onApply={applySectionUniformAnswer}
                        />
                        {showSectionNA && (
                            <SectionNACheckbox
                                section={item}
                                disabled={isReadOnly}
                                onSectionNAChange={onSectionNAChange}
                            />
                        )}
                        {typeof copySection === 'function' &&
                        item?.CanDelete &&
                        sectionCopyButtonLabel ? (
                        <PortalSectionCopyButton
                            type="button"
                            disabled={copyDisabled}
                            onClick={event => {
                                event.preventDefault()
                                event.stopPropagation()
                                copySection()
                            }}
                        >
                            {sectionCopyButtonLabel === 'Add New' ? (
                                <Plus size={16} weight="bold" />
                            ) : (
                                <Copy size={16} weight="bold" />
                            )}
                            {sectionCopyButtonLabel}
                        </PortalSectionCopyButton>
                    ) : null}
                    </span>
                </PortalSectionCardHeader>
                <PortalSectionCardBody
                    style={
                        sectionIsNA
                            ? { opacity: 0.55, pointerEvents: 'none' }
                            : undefined
                    }
                >
                    <PortalSectionFieldGrid>
                        {renderPortalQuestionFields()}
                    </PortalSectionFieldGrid>
                </PortalSectionCardBody>
            </PortalSectionCard>
        )
    }

    return (
        <Accordion fluid styled className="mt-4">
            <AccordionTitle
                active={open}
                index={item.SectionId}
                className={isImportedSection ? 'section-name-imported' : 'section-name'}
                style={isImportedSection ? {
                    backgroundColor: '#808080 !important',
                    color: '#FFFFFF !important',
                } : {}}
            >
                <FlexRowBetween>
                    <div
                        className="d-flex"
                        style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            flexWrap: isMobile ? 'wrap' : 'nowrap',
                            columnGap: 12,
                        }}
                    >
                        <span>{item.SectionName}</span>
                        {!isPressSection && (
                            <SectionPressSpecificationLink
                                reference={activePressSpecificationReference}
                            />
                        )}
                        <SectionUrlLink
                            url={getSectionUrlFromSection(item)}
                            triggerSelections={triggerSelections}
                        />
                    </div>
                    <FlexRow className="gap-2" style={{ alignItems: 'center', flexWrap: 'wrap' }}>
                        <SectionUniformAnswers
                            section={item}
                            disabled={sectionReadOnly}
                            onApply={applySectionUniformAnswer}
                        />
                        {showSectionNA && (
                            <SectionNACheckbox
                                section={item}
                                disabled={isReadOnly}
                                onSectionNAChange={onSectionNAChange}
                            />
                        )}
                        <MenuBox
                            copy={copySection}
                            remove={removeSection}
                            open={open}
                            item={item}
                            onToggle={() => handleToggle(item.SectionId)}
                            copyDisabled={copyDisabled}
                            copyButtonLabel={sectionCopyButtonLabel}
                        />
                    </FlexRow>
                </FlexRowBetween>
            </AccordionTitle>
            <AccordionContent className="outer-box" active={open}>
                <Divider className="my-0 mb-3" />
                <CardContent
                    className={`${isMobile && !isShowHorizontal && 'px-0'} row`}
                    style={
                        sectionIsNA
                            ? { opacity: 0.55, pointerEvents: 'none' }
                            : undefined
                    }
                >
                    {isShowHorizontal && <InspectionTableHeader />}
                    {renderQuestionFields(isShowHorizontal)}
                </CardContent>
            </AccordionContent>
        </Accordion>
    )
}

const TemplateListContainer = styled.div`
    .list {
        height: 24vh;
        overflow-y: auto;
    }
`

const TemplateList = ({ list, onTemplateAdd, loading }) => {
    const [templateId, setTemplateid] = useState('')
    const templates = list || []
    return (
        <TemplateListContainer>
            <h3>Select Template</h3>
            <Divider />
            <div className="list mb-3">
                {templates.length > 0 ? (
                    templates.map(ele => (
                        <p key={ele.Id}>
                            <Radio
                                name="GROUP"
                                className="me-2"
                                checked={templateId === ele.Id}
                                onClick={() => setTemplateid(ele.Id)}
                            />
                            {ele.TemplateName}
                        </p>
                    ))
                ) : (
                    <div style={{ padding: '1rem', color: '#888' }}>
                        No templates available
                    </div>
                )}
            </div>
            <AppPrimaryButton
                fluid
                loading={loading}
                onClick={() => onTemplateAdd(templateId)}
                disabled={templates.length === 0}
            >
                Submit
            </AppPrimaryButton>
        </TemplateListContainer>
    )
}

// Add styled-component for responsive hint image
const HintImage = styled.img`
    max-width: 220px;
    max-height: 120px;
    width: 100%;
    height: auto;
    border-radius: 8px;
    display: block;
    margin: 12px 0;
    @media (max-width: 600px) {
        max-width: 100%;
        max-height: 80px;
    }
`

const SpecificationReferenceCard = styled.div`
    padding: 12px 14px;
    background: #e8f4fc;
    border-radius: 8px;
    border: 1px solid #b8daf2;
`

/** Maps trigger question GUID â†’ displayed answer text for all multiple-choice questions (radio or combo). */
function buildTriggerSelectionsByQuestionOriginalId(sections) {
    const map = {}
    if (!Array.isArray(sections)) return map

    sections.forEach(section => {
        const qs = section.Questions || []
        qs.forEach(q => {
            if (q.TypeOfResponse !== TemplateResponseType.Multiple) return
            const mr = q.Answers?.MultipleResponse
            if (!Array.isArray(mr)) return
            const selected = mr.filter(r => r.IsSelected)
            if (!selected.length) return
            const selectedText =
                selected.length === 1
                    ? selected[0].DisplayText
                    : selected
                        .map(r => r.DisplayText)
                        .filter(Boolean)
                        .join(', ')
            const candidateIds = [
                q.QuestionOriginalId,
                q.QuestionId,
                q.Id,
                q.UId,
                q.Uid,
            ]
                .filter(value => value != null && String(value).trim())
                .map(value => String(value).trim())
            if (!candidateIds.length) return
            candidateIds.forEach(id => {
                map[id] = selectedText
                map[id.toLowerCase()] = selectedText
            })
        })
    })
    return map
}

function buildSelectedPressResponseIds(sections) {
    if (!Array.isArray(sections)) return []
    let selectedPressResponseIds = []

    sections.forEach(section => {
        const questions = section?.Questions || []
        questions.forEach(question => {
            const questionText = CommonUtility.strippedHtml(question?.FAQ || '')
                .trim()
                .toLowerCase()
            const isPressQuestion =
                questionText === 'press' || questionText.includes('press')
            if (!isPressQuestion) return

            const responses = question?.Answers?.MultipleResponse
            if (!Array.isArray(responses)) return

            const currentSelectedIds = responses
                .filter(response => response?.IsSelected)
                .map(
                    response =>
                        response?.ResponseId ??
                        response?.responseId ??
                        response?.ResponseUId ??
                        response?.ResponseUid ??
                        response?.UId ??
                        response?.Uid ??
                        response?.Id,
                )
                .filter(value => value != null)
                .map(value => String(value))
            selectedPressResponseIds = [
                ...selectedPressResponseIds,
                ...currentSelectedIds,
            ]
        })
    })

    return [...new Set(selectedPressResponseIds)]
}

function buildSpecificationReferencesByTriggerQuestionId(sections) {
    const referencesByTriggerQuestionId = {}
    if (!Array.isArray(sections)) return referencesByTriggerQuestionId

    sections.forEach(section => {
        const questions = section?.Questions || []
        questions.forEach(question => {
            const references = question?.QuestionReferences
            if (!Array.isArray(references) || references.length === 0) return

            references.forEach(reference => {
                if (!reference || reference.IsActive === false) return
                const triggerQuestionId = String(reference.TriggerQuestionId || '').trim()
                if (!triggerQuestionId) return

                const hasUsableUrl =
                    !!normalizeReferenceUrl(reference.ImageUrl) ||
                    !!normalizeReferenceUrl(reference.HtmlUrl)
                if (!hasUsableUrl) return

                const keyVariants = [triggerQuestionId, triggerQuestionId.toLowerCase()]
                keyVariants.forEach(key => {
                    if (!referencesByTriggerQuestionId[key]) {
                        referencesByTriggerQuestionId[key] = []
                    }
                    referencesByTriggerQuestionId[key].push(reference)
                })
            })
        })
    })

    return referencesByTriggerQuestionId
}

function normalizeReferenceUrl(url) {
    if (!url || typeof url !== 'string') return ''
    const t = url.trim()
    return t
}

function findActiveSpecificationReference(refs, triggerSelections) {
    if (!Array.isArray(refs) || refs.length === 0) return null
    return (
        refs.find(ref => {
            if (ref.IsActive === false) return false
            const triggerKey = String(ref.TriggerQuestionId || '').trim()
            const current =
                triggerSelections?.[triggerKey] ||
                triggerSelections?.[triggerKey.toLowerCase()]
            if (!current || ref.TriggerValue == null) return false
            return (
                String(ref.TriggerValue).trim().toLowerCase() ===
                String(current).trim().toLowerCase()
            )
        }) || null
    )
}

function isPressQuestionFaq(faq) {
    const normalizedQuestionText = CommonUtility.strippedHtml(faq || '')
        .trim()
        .toLowerCase()
    return (
        normalizedQuestionText === 'press' ||
        normalizedQuestionText.includes('press')
    )
}

function buildQuestionKeyCandidates(question) {
    return [
        question?.QuestionOriginalId,
        question?.QuestionId,
        question?.Id,
        question?.UId,
        question?.Uid,
    ]
        .filter(value => value != null && String(value).trim())
        .map(value => String(value).trim())
}

function getSectionUrlCandidateFromObject(obj) {
    if (!obj || typeof obj !== 'object') return ''
    const candidates = [
        obj.SectionURL,
        obj.SectionUrl,
        obj.sectionURL,
        obj.sectionUrl,
        obj.URL,
        obj.Url,
        obj.url,
        obj.FileURL,
        obj.FileUrl,
        obj.fileUrl,
        obj.HtmlUrl,
        obj.ImageUrl,
        obj.Link,
        obj.link,
    ]
    const matched = candidates.find(value => normalizeReferenceUrl(value))
    return normalizeReferenceUrl(matched)
}

function getSectionUrlFromSection(section) {
    if (!section) return ''
    return (
        section?.SectionURL ||
        section?.SectionUrl ||
        section?.sectionURL ||
        section?.sectionUrl ||
        section?.Questions?.[0]?.SectionURL ||
        section?.Questions?.[0]?.SectionUrl ||
        ''
    )
}

function doesJsonSectionUrlMatchSelection(item, triggerSelections, normalizedSelections) {
    if (!item || typeof item !== 'object') return false
    const triggerQuestionId = String(
        item?.TriggerQuestionId ||
            item?.triggerQuestionId ||
            item?.TriggerId ||
            item?.triggerId ||
            '',
    ).trim()
    const triggerValue = String(
        item?.TriggerValue ||
            item?.triggerValue ||
            item?.Value ||
            item?.value ||
            '',
    )
        .trim()
        .toLowerCase()

    if (!triggerValue) return false

    if (triggerQuestionId) {
        const current =
            triggerSelections?.[triggerQuestionId] ||
            triggerSelections?.[triggerQuestionId.toLowerCase()]
        if (!current) return false
        return String(current).trim().toLowerCase() === triggerValue
    }

    return normalizedSelections.includes(triggerValue)
}

function resolveSectionUrlFromJson(value, triggerSelections) {
    const normalizedSelections = Object.values(triggerSelections || {})
        .flatMap(v =>
            String(v || '')
                .split(',')
                .map(part => part.trim().toLowerCase())
                .filter(Boolean),
        )

    if (Array.isArray(value)) {
        const matched = value.find(item =>
            doesJsonSectionUrlMatchSelection(
                item,
                triggerSelections,
                normalizedSelections,
            ),
        )
        if (matched) {
            return getSectionUrlCandidateFromObject(matched)
        }

        const firstDirect = value
            .map(item =>
                typeof item === 'string'
                    ? normalizeReferenceUrl(item)
                    : getSectionUrlCandidateFromObject(item),
            )
            .find(Boolean)
        return firstDirect || ''
    }

    if (!value || typeof value !== 'object') return ''

    // Explicit support for key-value JSON maps like:
    // { "Press 5": "https://...", "Press 6": "https://..." }
    const mapBySelection = Object.entries(value).find(([key, val]) => {
        const normalizedKey = String(key || '').trim().toLowerCase()
        if (!normalizedSelections.includes(normalizedKey)) return false
        return !!normalizeReferenceUrl(val)
    })
    if (mapBySelection) {
        return normalizeReferenceUrl(mapBySelection[1])
    }

    const direct = getSectionUrlCandidateFromObject(value)
    if (direct) return direct

    const collectionKeys = ['Items', 'items', 'Urls', 'urls', 'Mappings', 'mappings']
    const nestedCollection = collectionKeys
        .map(key => value?.[key])
        .find(entry => Array.isArray(entry))
    if (nestedCollection) {
        return resolveSectionUrlFromJson(nestedCollection, triggerSelections)
    }

    const mappedBySelection = Object.entries(value).find(([key, val]) => {
        const normalizedKey = String(key || '').trim().toLowerCase()
        if (!normalizedSelections.includes(normalizedKey)) return false
        const mapped =
            typeof val === 'string'
                ? normalizeReferenceUrl(val)
                : getSectionUrlCandidateFromObject(val)
        return !!mapped
    })
    if (mappedBySelection) {
        const val = mappedBySelection[1]
        return typeof val === 'string'
            ? normalizeReferenceUrl(val)
            : getSectionUrlCandidateFromObject(val)
    }

    return ''
}

function resolveSectionUrlValue(rawValue, triggerSelections) {
    if (rawValue == null) return ''

    if (typeof rawValue === 'object') {
        return resolveSectionUrlFromJson(rawValue, triggerSelections)
    }

    const normalized = normalizeReferenceUrl(rawValue)
    if (!normalized) return ''

    const looksLikeJson =
        (normalized.startsWith('{') && normalized.endsWith('}')) ||
        (normalized.startsWith('[') && normalized.endsWith(']'))

    if (!looksLikeJson) return normalized

    try {
        const parsed = JSON.parse(normalized)
        const resolved = resolveSectionUrlFromJson(parsed, triggerSelections)
        return resolved || ''
    } catch {
        return normalized
    }
}

const SectionPressSpecificationLink = ({ reference }) => {
    const imageUrl = normalizeReferenceUrl(reference?.ImageUrl)
    const htmlUrl = normalizeReferenceUrl(reference?.HtmlUrl)
    const [specModalOpen, setSpecModalOpen] = useState(false)
    const [isFullscreen, setIsFullscreen] = useState(false)
    const modalContentHeight = isFullscreen ? '86vh' : '70vh'

    if (!reference || (!imageUrl && !htmlUrl)) return null

    return (
        <>
            <span
                role="button"
                tabIndex={0}
                onClick={e => {
                    e.preventDefault()
                    e.stopPropagation()
                    setSpecModalOpen(true)
                }}
                onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        e.stopPropagation()
                        setSpecModalOpen(true)
                    }
                }}
                style={{
                    color: '#1f4fb8',
                    marginLeft: 0,
                    marginTop: 0,
                    textDecoration: 'underline',
                    fontWeight: 700,
                    cursor: 'pointer',
                    fontSize: 13,
                    whiteSpace: 'nowrap',
                    padding: '3px 10px',
                    borderRadius: 999,
                    background: '#ffffff',
                    border: '1px solid #d9e5ff',
                    lineHeight: 1.25,
                    letterSpacing: '0.01em',
                }}
            >
                {reference.DisplayLabel || 'View specification'}
            </span>
            <Modal
                open={specModalOpen}
                onClose={() => {
                    setSpecModalOpen(false)
                    setIsFullscreen(false)
                }}
                style={
                    isFullscreen
                        ? { width: '96vw', maxWidth: '96vw' }
                        : undefined
                }
            >
                <Modal.Header>
                    <FlexRowBetween>
                        <TitleText>
                            {reference?.DisplayLabel || 'Press Specification'}
                        </TitleText>
                        <div className="d-flex align-items-center" style={{ gap: 10 }}>
                            <span
                                role="button"
                                tabIndex={0}
                                className="pointer"
                                onClick={() => setIsFullscreen(prev => !prev)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault()
                                        setIsFullscreen(prev => !prev)
                                    }
                                }}
                                title={isFullscreen ? 'Minimize' : 'Maximize'}
                            >
                                {isFullscreen ? (
                                    <ArrowsIn size={24} />
                                ) : (
                                    <ArrowsOut size={24} />
                                )}
                            </span>
                            <X
                                className="pointer"
                                size={32}
                                onClick={() => {
                                    setSpecModalOpen(false)
                                    setIsFullscreen(false)
                                }}
                            />
                        </div>
                    </FlexRowBetween>
                </Modal.Header>
                <Modal.Content
                    style={{
                        padding: 0,
                        overflow: 'auto',
                        borderTop: '1px solid rgba(34,36,38,.15)',
                    }}
                >
                    {reference?.ImageUrl ? (
                        <div style={{ padding: 16 }}>
                            <img
                                src={reference.ImageUrl}
                                alt="Specification"
                                style={{
                                    width: '100%',
                                    maxHeight: modalContentHeight,
                                    objectFit: 'contain',
                                    display: 'block',
                                    margin: '0 auto',
                                }}
                            />
                        </div>
                    ) : (
                        <iframe
                            title="Press Specification"
                            src={reference?.HtmlUrl || ''}
                            style={{
                                width: '100%',
                                height: modalContentHeight,
                                border: 0,
                                display: 'block',
                            }}
                        />
                    )}
                </Modal.Content>
                <Modal.Actions style={{ borderTop: '1px solid rgba(34,36,38,.15)' }}>
                    <Button type="button" onClick={() => setSpecModalOpen(false)}>
                        Close
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    )
}

const SectionUrlLink = ({ url, triggerSelections }) => {
    const normalizedUrl = resolveSectionUrlValue(url, triggerSelections)
    const [fileModalOpen, setFileModalOpen] = useState(false)
    const [isFullscreen, setIsFullscreen] = useState(false)
    const modalContentHeight = isFullscreen ? '86vh' : '70vh'
    if (!normalizedUrl) return null

    return (
        <>
            <span
                role="button"
                tabIndex={0}
                onClick={event => {
                    event.stopPropagation()
                    event.preventDefault()
                    setFileModalOpen(true)
                }}
                onKeyDown={event => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.stopPropagation()
                        event.preventDefault()
                        setFileModalOpen(true)
                    }
                }}
                style={{
                    color: '#0b3ea9',
                    marginLeft: 0,
                    marginTop: 0,
                    textDecoration: 'none',
                    fontWeight: 700,
                    cursor: 'pointer',
                    fontSize: 13,
                    whiteSpace: 'nowrap',
                    padding: '4px 10px',
                    borderRadius: 8,
                    background: '#eaf2ff',
                    border: '1px solid #bcd2ff',
                    lineHeight: 1.25,
                    letterSpacing: '0.01em',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                }}
            >
                <Eye size={14} weight="bold" />
                <span>View File</span>
            </span>
            <Modal
                open={fileModalOpen}
                onClose={() => {
                    setFileModalOpen(false)
                    setIsFullscreen(false)
                }}
                style={
                    isFullscreen
                        ? { width: '96vw', maxWidth: '96vw' }
                        : undefined
                }
            >
                <Modal.Header>
                    <FlexRowBetween>
                        <TitleText>View File</TitleText>
                        <div className="d-flex align-items-center" style={{ gap: 10 }}>
                            <span
                                role="button"
                                tabIndex={0}
                                className="pointer"
                                onClick={() => setIsFullscreen(prev => !prev)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault()
                                        setIsFullscreen(prev => !prev)
                                    }
                                }}
                                title={isFullscreen ? 'Minimize' : 'Maximize'}
                            >
                                {isFullscreen ? (
                                    <ArrowsIn size={24} />
                                ) : (
                                    <ArrowsOut size={24} />
                                )}
                            </span>
                            <X
                                className="pointer"
                                size={32}
                                onClick={() => {
                                    setFileModalOpen(false)
                                    setIsFullscreen(false)
                                }}
                            />
                        </div>
                    </FlexRowBetween>
                </Modal.Header>
                <Modal.Content
                    style={{
                        padding: 0,
                        overflow: 'auto',
                        borderTop: '1px solid rgba(34,36,38,.15)',
                    }}
                >
                    <iframe
                        title="Section File"
                        src={normalizedUrl}
                        style={{
                            width: '100%',
                            height: modalContentHeight,
                            border: 0,
                            display: 'block',
                        }}
                    />
                </Modal.Content>
                <Modal.Actions style={{ borderTop: '1px solid rgba(34,36,38,.15)' }}>
                    <Button type="button" onClick={() => setFileModalOpen(false)}>
                        Close
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    )
}

const QuestionSpecificationReference = ({ question, triggerSelections }) => {
    const refs = question?.QuestionReferences
    if (!Array.isArray(refs) || refs.length === 0) return null

    const active = findActiveSpecificationReference(refs, triggerSelections)

    const imageUrl = active ? normalizeReferenceUrl(active.ImageUrl) : ''
    const htmlUrl = active ? normalizeReferenceUrl(active.HtmlUrl) : ''

    const [specModalOpen, setSpecModalOpen] = useState(false)
    const [specModalRef, setSpecModalRef] = useState(null)
    const [isFullscreen, setIsFullscreen] = useState(false)
    const modalContentHeight = isFullscreen ? '86vh' : '70vh'

    const openSpecModal = () => {
        if (!active || (!imageUrl && !htmlUrl)) return
        setSpecModalRef(active)
        setSpecModalOpen(true)
    }

    if (!active || (!imageUrl && !htmlUrl)) return null

    return (
        <>
            <div className="mt-3">
                <div
                    style={{
                        fontSize: 11,
                        letterSpacing: '0.06em',
                        color: '#888',
                        fontWeight: 600,
                        marginBottom: 8,
                    }}
                >
                    SPECIFICATION REFERENCE
                </div>
                <SpecificationReferenceCard>
                    <div
                        role="button"
                        tabIndex={0}
                        onClick={openSpecModal}
                        onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                openSpecModal()
                            }
                        }}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            fontWeight: 600,
                            color: '#2185d0',
                            cursor: 'pointer',
                        }}
                    >
                        {imageUrl ? (
                            <img
                                src={imageUrl}
                                alt=""
                                width={22}
                                height={22}
                                style={{
                                    objectFit: 'cover',
                                    borderRadius: 4,
                                }}
                            />
                        ) : (
                            <span style={{ width: 22, display: 'inline-block' }} />
                        )}
                        {active.DisplayLabel || 'View specification'}
                    </div>
                    <div
                        style={{
                            fontSize: 12,
                            color: '#666',
                            marginTop: 8,
                        }}
                    >
                        {(htmlUrl || imageUrl)
                            .replace(/^.*\//, '')
                            .split('?')[0]}
                        <span className="ms-2" style={{ color: '#2185d0' }}>
                            Opens in modal
                        </span>
                    </div>
                </SpecificationReferenceCard>
            </div>

            <Modal
                open={specModalOpen}
                onClose={() => {
                    setSpecModalOpen(false)
                    setIsFullscreen(false)
                }}
                style={
                    isFullscreen
                        ? { width: '96vw', maxWidth: '96vw' }
                        : undefined
                }
            >
                <Modal.Header>
                    <FlexRowBetween>
                        <TitleText>
                            {specModalRef?.DisplayLabel ||
                                'Press Specification'}
                        </TitleText>
                        <div className="d-flex align-items-center" style={{ gap: 10 }}>
                            <span
                                role="button"
                                tabIndex={0}
                                className="pointer"
                                onClick={() => setIsFullscreen(prev => !prev)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault()
                                        setIsFullscreen(prev => !prev)
                                    }
                                }}
                                title={isFullscreen ? 'Minimize' : 'Maximize'}
                            >
                                {isFullscreen ? (
                                    <ArrowsIn size={24} />
                                ) : (
                                    <ArrowsOut size={24} />
                                )}
                            </span>
                            <X
                                className="pointer"
                                size={32}
                                onClick={() => {
                                    setSpecModalOpen(false)
                                    setIsFullscreen(false)
                                }}
                            />
                        </div>
                    </FlexRowBetween>
                </Modal.Header>
                <Modal.Content
                    style={{
                        padding: 0,
                        overflow: 'auto',
                        borderTop: '1px solid rgba(34,36,38,.15)',
                    }}
                >
                    {specModalRef?.ImageUrl ? (
                        <div style={{ padding: 16 }}>
                            <img
                                src={specModalRef.ImageUrl}
                                alt="Specification"
                                style={{
                                    width: '100%',
                                    maxHeight: modalContentHeight,
                                    objectFit: 'contain',
                                    display: 'block',
                                    margin: '0 auto',
                                }}
                            />
                        </div>
                    ) : (
                        <iframe
                            title="Press Specification"
                            src={specModalRef?.HtmlUrl || ''}
                            style={{
                                width: '100%',
                                height: modalContentHeight,
                                border: 0,
                                display: 'block',
                            }}
                        />
                    )}
                </Modal.Content>
                <Modal.Actions style={{ borderTop: '1px solid rgba(34,36,38,.15)' }}>
                    <Button
                        type="button"
                        onClick={() => setSpecModalOpen(false)}
                    >
                        Close
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    )
}

export const InspectionSectionList = ({
    list,
    loading,
    submit,
    onReview,
    addMedia,
    removeMedia,
    addNotes,
    onAnswerChanged,
    errors,
    submitError,
    // onBack,
    copySection,
    directCopySection,
    removeSection,
    templateList,
    onTemplateAdd,
    templateId,
    inspectionTemplateId,
    publicScreen,
    showActionButtons,
    showValidation,
    printByTemplate = false,
    resetBySection = false,
    showSectionDropdown = false,
    isShowHorizontal = false,
    setSaving,
    isReadOnly = false,
    hideSectionToolbar = false,
    hideFooterActions = false,
    hideHorizontalAddNew = false,
    horizontalTableMode = 'default',
    portalCardSectionIds = [],
    portalCardSectionNames = [],
    onPressReset,
    onPressDown,
    onSectionNAChange,
    copyButtonLabel = 'Copy',
    getCopyButtonLabel,
    originalTemplateId = null,
    totalScore: totalScoreOverride,
    totalQuestions: totalQuestionsOverride,
    validateForComplete,
    reasonPresetSetting = null,
}) => {
    const { user } = useAuth()
    const isPressDependencyEnabled = user?.CompanyId === 34930
    const isPressResetEnabled = isPressSelectionResetEnabled(user)
    const { control, watch } = useForm({
        defaultValues: {
            showNumbering: true,
        },
    })
    const showNumbering = watch('showNumbering')

    const computedTotalScore = useMemo(() => {
        let total = 0

        if (!Array.isArray(list)) {
            return 0
        }

        list.forEach(section => {
            if (!Array.isArray(section.Questions)) return

            section.Questions.forEach(question => {
                total += getQuestionDisplayScore(question)
            })
        })

        return total
    }, [list])

    const computedTotalQuestions = useMemo(() => {
        let total = 0

        if (!Array.isArray(list)) {
            return 0
        }
        list.forEach(section => {
            if (!Array.isArray(section.Questions)) return

            total += section.Questions.length

        })

        return total
    }, [list])

    const totalScore =
        typeof totalScoreOverride === 'number'
            ? totalScoreOverride
            : computedTotalScore
    const totalQuestions =
        typeof totalQuestionsOverride === 'number'
            ? totalQuestionsOverride
            : computedTotalQuestions

    const isMobile = useTabletAndBelowMediaQuery()
    const shouldUseHorizontalTable = isShowHorizontal && !isMobile
    const location = useLocation()
    const isReopened = location.state?.isReopened

    const [comment, setComment] = useState('')
    const [isCommentSubmitted, setIsCommentSubmitted] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)

    const processedSections = useMemo(() => {
        if (!Array.isArray(list)) {
            return []
        }

        // Sort sections to put Imported section first
        const sortedList = [...list].sort((a, b) => {
            const aIsImported = a.SectionName === 'Imported section' || a.IsImported
            const bIsImported = b.SectionName === 'Imported section' || b.IsImported
            if (aIsImported && !bIsImported) return -1
            if (!aIsImported && bIsImported) return 1
            const aOrder = Number(a?.Order ?? a?.SectionOrder ?? 0)
            const bOrder = Number(b?.Order ?? b?.SectionOrder ?? 0)
            return aOrder - bOrder
        })

        if (!printByTemplate || resetBySection) {
            return sortedList
        }

        let runningOffset = 0
        return sortedList.map(section => {
            const questionCount = Array.isArray(section?.Questions)
                ? section.Questions.length
                : 0
            const withOffset = { ...section, __questionOffset: runningOffset }
            runningOffset += questionCount
            return withOffset
        })
    }, [list, printByTemplate, resetBySection])

    const [selectedSectionIds, setSelectedSectionIds] = useState([])
    const dropdownRootRef = useRef(null)
    const [showCompletionPrompt, setShowCompletionPrompt] = useState(false)
    const [isDropdownOpened, setIsDropdownOpened] = useState(false)
    const [sectionSearchTerm, setSectionSearchTerm] = useState('')
    const [completionPopupPosition, setCompletionPopupPosition] = useState(
        'bottom center',
    )
    const completeButtonRef = useRef(null)
    const dragIndexRef = useRef(null)
    const [expandedSections, setExpandedSections] = useState(new Set())

    useEffect(() => {
        if (!showSectionDropdown) {
            setSelectedSectionIds([])
            return
        }

        if (!Array.isArray(list) || list.length === 0) {
            setSelectedSectionIds([])
            return
        }

        setSelectedSectionIds(prev => {
            const current = Array.isArray(prev) ? prev : []
            const validIds = current.filter(id =>
                list.some(section => section.SectionId === id),
            )

            const isSameLength = validIds.length === current.length
            const isSameOrder =
                isSameLength && validIds.every((id, index) => id === current[index])

            if (!isSameOrder) {
                return validIds
            }

            return current
        })
    }, [showSectionDropdown, list])

    const shouldPromptForAdditionalSections = useMemo(() => {
        if (!showSectionDropdown) {
            return false
        }

        if (!Array.isArray(processedSections) || processedSections.length === 0) {
            return false
        }

        return (
            selectedSectionIds.length > 0 &&
            selectedSectionIds.length < processedSections.length
        )
    }, [showSectionDropdown, processedSections, selectedSectionIds])

    useEffect(() => {
        if (!shouldPromptForAdditionalSections) {
            setShowCompletionPrompt(false)
        }
    }, [shouldPromptForAdditionalSections])

    const handleSectionToggle = useCallback(sectionId => {
        setSelectedSectionIds(prev => {
            const current = Array.isArray(prev) ? [...prev] : []
            if (current.includes(sectionId)) {
                return current.filter(id => id !== sectionId)
            }
            return [...current, sectionId]
        })
    }, [])

    const sectionOptions = useMemo(() => {
        if (!Array.isArray(list)) {
            return []
        }

        // Exclude imported sections from dropdown options - they should be displayed directly
        return list
            .filter(section => !section.IsImported && section.SectionName !== 'Imported section')
            .map(section => {
                const isSelected = selectedSectionIds.includes(section.SectionId)
                return {
                    key: section.SectionId,
                    text: section.SectionName || 'Section',
                    value: section.SectionId,
                    content: (
                        <div className="section-option-item">
                            <Checkbox
                                checked={isSelected}
                                onChange={event => {
                                    event.stopPropagation()
                                    event.preventDefault()
                                    handleSectionToggle(section.SectionId)
                                }}
                                onClick={event => {
                                    event.stopPropagation()
                                    event.preventDefault()
                                }}
                            />
                            <div className="section-option-details">
                                <span className="section-option-title">
                                    {section.SectionName || 'Section'}
                                </span>
                            </div>
                        </div>
                    ),
                }
            })
    }, [list, selectedSectionIds, handleSectionToggle])

    const filteredSectionOptions = useMemo(() => {
        if (!sectionSearchTerm) {
            return sectionOptions
        }
        const lowered = sectionSearchTerm.trim().toLowerCase()
        return sectionOptions.filter(option =>
            (option.text || '').toLowerCase().includes(lowered),
        )
    }, [sectionOptions, sectionSearchTerm])

    const renderSelectedLabel = useCallback(
        label => (
            <div className="section-dropdown-label">
                <span className="label-text">{label.text}</span>
            </div>
        ),
        [],
    )

    const sectionsToRender = useMemo(() => {
        let sections
        if (!showSectionDropdown) {
            sections = processedSections
        } else if (
            !Array.isArray(processedSections) ||
            processedSections.length === 0
        ) {
            sections = []
        } else if (
            !Array.isArray(selectedSectionIds) ||
            selectedSectionIds.length === 0
        ) {
            sections = []
        } else {
            const sectionMap = new Map(
                processedSections.map(section => [section.SectionId, section]),
            )
            sections = selectedSectionIds
                .map(id => sectionMap.get(id))
                .filter(Boolean)
        }

        if (
            isShowHorizontal &&
            Array.isArray(sections) &&
            (portalCardSectionIds?.length > 0 ||
                portalCardSectionNames?.length > 0)
        ) {
            return sections.filter(
                section =>
                    !isPortalCardSection(
                        section,
                        portalCardSectionIds,
                        portalCardSectionNames,
                    ),
            )
        }

        return sections
    }, [
        showSectionDropdown,
        processedSections,
        selectedSectionIds,
        isShowHorizontal,
        portalCardSectionIds,
        portalCardSectionNames,
    ])

    const triggerSelectionsByOriginalId = useMemo(
        () => buildTriggerSelectionsByQuestionOriginalId(processedSections),
        [processedSections],
    )
    const selectedPressResponseIds = useMemo(
        () => buildSelectedPressResponseIds(processedSections),
        [processedSections],
    )
    const pressResetTarget = useMemo(
        () =>
            isPressResetEnabled
                ? getPressResetTarget(processedSections)
                : null,
        [processedSections, isPressResetEnabled],
    )
    const pressResetHandler = isPressResetEnabled ? onPressReset : undefined
    const pressDownHandler =
        isPressResetEnabled &&
        onPressDown &&
        pressResetTarget &&
        isPressDownEligible(
            { SectionId: pressResetTarget.sectionId },
            originalTemplateId,
        )
            ? onPressDown
            : undefined
    const specificationReferencesByTriggerQuestionId = useMemo(
        () =>
            buildSpecificationReferencesByTriggerQuestionId(processedSections),
        [processedSections],
    )
    const activePressSpecificationReference = useMemo(() => {
        if (!Array.isArray(processedSections) || processedSections.length === 0) {
            return null
        }

        const pressTriggerQuestionIds = new Set()
        processedSections.forEach(section => {
            const questions = section?.Questions || []
            questions.forEach(question => {
                if (!isPressQuestionFaq(question?.FAQ)) return
                buildQuestionKeyCandidates(question).forEach(key => {
                    pressTriggerQuestionIds.add(key)
                    pressTriggerQuestionIds.add(key.toLowerCase())
                })
            })
        })

        const activeByTrigger = [...pressTriggerQuestionIds]
            .map(triggerQuestionId => {
                const refs =
                    specificationReferencesByTriggerQuestionId?.[
                        triggerQuestionId
                    ] || []
                return findActiveSpecificationReference(
                    refs,
                    triggerSelectionsByOriginalId,
                )
            })
            .find(Boolean)

        return activeByTrigger || null
    }, [
        processedSections,
        specificationReferencesByTriggerQuestionId,
        triggerSelectionsByOriginalId,
    ])

    const previousSectionIdsRef = useRef([])
    const hasInitializedSelectionRef = useRef(false)

    useEffect(() => {
        if (!showSectionDropdown) {
            previousSectionIdsRef.current = []
            hasInitializedSelectionRef.current = false
            return
        }

        if (!Array.isArray(processedSections) || processedSections.length === 0) {
            previousSectionIdsRef.current = []
            return
        }

        const currentSectionIds = processedSections.map(section => section.SectionId)
        const previousSectionIds = previousSectionIdsRef.current

        const newlyAddedIds = currentSectionIds.filter(
            id => !previousSectionIds.includes(id),
        )

        // Answering a question updates section data but not the section list.
        // Re-running selection here would drop sections the user checked manually
        // and keep only IsAdded sections.
        const sectionIdsUnchanged =
            hasInitializedSelectionRef.current &&
            previousSectionIds.length === currentSectionIds.length &&
            currentSectionIds.every((id, index) => id === previousSectionIds[index])
        if (sectionIdsUnchanged) {
            return
        }

        // Get sections with IsAdded: true from the inspection API response
        const sectionsWithIsAdded = processedSections.filter(section => section?.IsAdded === true)
        const addedSectionIds = sectionsWithIsAdded.map(section => section.SectionId)

        // Reset initialization if we have sections with IsAdded: true that aren't currently selected
        if (hasInitializedSelectionRef.current && addedSectionIds.length > 0) {
            setSelectedSectionIds(prev => {
                const currentSelection = Array.isArray(prev) ? prev : []
                const importedSectionIds = processedSections
                    .filter(section => section?.IsImported === true || section?.SectionName === 'Imported section')
                    .map(section => section.SectionId)
                const combinedIds = [...new Set([...importedSectionIds, ...addedSectionIds])]
                // Only update if there's a difference
                if (combinedIds.length !== currentSelection.length || !combinedIds.every(id => currentSelection.includes(id))) {
                    return combinedIds
                }
                return currentSelection
            })
        }

        // Initialize with no sections selected by default, except imported sections and sections with IsAdded: true
        if (!hasInitializedSelectionRef.current) {
            const importedSectionIds = processedSections
                .filter(section => section?.IsImported === true || section?.SectionName === 'Imported section')
                .map(section => section.SectionId)

            // Get sections with IsAdded: true from the inspection API response
            const addedSectionIdsFromList = processedSections
                .filter(section => section?.IsAdded === true)
                .map(section => section.SectionId)

            // Combine imported sections and sections with IsAdded: true
            const initialSelectedIds = [...new Set([...importedSectionIds, ...addedSectionIdsFromList])]
            setSelectedSectionIds(initialSelectedIds)
            hasInitializedSelectionRef.current = true
            previousSectionIdsRef.current = currentSectionIds
            return
        }

        // For newly added sections, auto-select if they have IsShowAlways=true or IsImported=true
        if (hasInitializedSelectionRef.current && newlyAddedIds.length > 0) {
            setSelectedSectionIds(prev => {
                const currentSelection = Array.isArray(prev) ? [...prev] : []
                const updatedSelection = [...currentSelection]

                newlyAddedIds.forEach(id => {
                    const section = processedSections.find(s => s.SectionId === id)
                    // Auto-select if IsShowAlways is true OR if it's an imported section
                    if ((section?.IsShowAlways === true || section?.IsImported === true || section?.SectionName === 'Imported section') && !updatedSelection.includes(id)) {
                        updatedSelection.push(id)
                    }
                })

                return updatedSelection
            })
        }

        if (!hasInitializedSelectionRef.current) {
            hasInitializedSelectionRef.current = true
        }

        previousSectionIdsRef.current = currentSectionIds
    }, [processedSections, showSectionDropdown])

    const handleAnswerChanged = (sectionId, question, answer) => {
        onAnswerChanged(sectionId, question, answer)
    }

    const handleAddHorizontalRow = useCallback(async () => {
        const baseSection = sectionsToRender?.[0]
        const baseSectionId = baseSection?.SectionId
        const baseSectionName = String(baseSection?.SectionName || '').trim()
        if (!baseSectionId) return

        // Prefer direct copy flow (no popup) for horizontal table mode.
        if (typeof directCopySection === 'function') {
            await directCopySection(baseSectionId, baseSectionName)
            return
        }

        // Fallback to existing behavior if direct handler is not provided.
        if (typeof copySection === 'function') {
            copySection(baseSectionId)
        }
    }, [sectionsToRender, directCopySection, copySection])

    const handleCompleteClick = () => {
        if (completeButtonRef.current) {
            const rect = completeButtonRef.current.getBoundingClientRect()
            const viewportSpaceBelow = window.innerHeight - rect.bottom
            const preferredPosition =
                viewportSpaceBelow < 240 ? 'top center' : 'bottom center'
            setCompletionPopupPosition(preferredPosition)
        } else {
            setCompletionPopupPosition('bottom center')
        }

        // Require selected-section answers before "add more sections?" or Complete
        if (
            typeof validateForComplete === 'function' &&
            !validateForComplete(selectedSectionIds)
        ) {
            return
        }

        if (shouldPromptForAdditionalSections) {
            setShowCompletionPrompt(true)
            return
        }
        submit(5, { selectedSectionIds })
    }

    const handleAddMoreSections = () => {
        setShowCompletionPrompt(false)
        if (dropdownRootRef.current) {
            dropdownRootRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            })
        }
        setIsDropdownOpened(true)
        setTimeout(() => {
            const dropdownElement =
                dropdownRootRef.current?.querySelector('.selection.dropdown')
            const searchInput =
                dropdownRootRef.current?.querySelector(
                    '.selection.dropdown input.search',
                ) ||
                dropdownRootRef.current?.querySelector(
                    '.selection.dropdown .search',
                )
            if (dropdownElement) {
                dropdownElement.classList.add('active', 'visible')
            }
            if (searchInput) {
                searchInput.focus()
            }
        }, 300)
    }

    const handleCompleteConfirm = async () => {
        setShowCompletionPrompt(false)

        // Re-check required answers before DeleteSection / Complete
        if (
            typeof validateForComplete === 'function' &&
            !validateForComplete(selectedSectionIds)
        ) {
            return
        }

        // If IsSectionVisibleInDropdown is true and there are unselected sections, delete them first
        if (showSectionDropdown && inspectionTemplateId && Array.isArray(processedSections) && Array.isArray(selectedSectionIds)) {
            const unselectedSections = processedSections.filter(
                section => !selectedSectionIds.includes(section.SectionId),
            )

            if (unselectedSections.length > 0) {
                // Show loader before delete API call
                if (setSaving) {
                    setSaving(true)
                    // Allow the loader to render before network work starts
                    await new Promise(resolve => setTimeout(resolve, 0))
                }
                try {
                    // Delete all unselected sections in a single API call with semicolon-separated SectionIds
                    const sectionIds = unselectedSections.map(section => section.SectionId).join(';')
                    await InspectionService.removeSection({
                        TemplateId: inspectionTemplateId,
                        SectionId: sectionIds,
                        LoginSource: 1,
                    })
                } catch (error) {
                    console.error('Error deleting unselected sections:', error)
                    // Continue with completion even if deletion fails
                }
            }
        }

        submit(5, { selectedSectionIds })
    }

    const renderCompleteButton = ({
        fluid = false,
        className,
    } = {}) => (
        <Popup
            on="click"
            open={showCompletionPrompt && shouldPromptForAdditionalSections}
            onClose={() => setShowCompletionPrompt(false)}
            closeOnTriggerClick={false}
            closeOnDocumentClick
            closeOnEscape
            position={completionPopupPosition}
            offsets={{
                'bottom center': [0, 12],
                'top center': [0, -12],
            }}
            className="completion-confirm-popup customer-popup"
            pinned
            keepInViewPort
            wide="very"
            trigger={
                <span className="d-inline-block" ref={completeButtonRef}>
                    <AppPrimaryButton
                        fluid={fluid}
                        className={className}
                        onClick={handleCompleteClick}
                        type="button"
                    >
                        Complete
                    </AppPrimaryButton>
                </span>
            }
        >
            <div
                style={{
                    maxWidth: isMobile ? 240 : 320,
                    minWidth: isMobile ? 240 : 320,
                }}
            >
                <h4 style={{ marginBottom: '12px' }}>Want add more Section?</h4>
                <div className="d-flex flex-column flex-md-row gap-2">
                    <AppPrimaryButton
                        type="button"
                        fluid={isMobile}
                        onClick={handleAddMoreSections}
                        style={{ whiteSpace: 'nowrap' }}
                    >
                        Yes, Add More
                    </AppPrimaryButton>
                    <AppSecondaryButton
                        type="button"
                        fluid={isMobile}
                        onClick={handleCompleteConfirm}
                        style={{ whiteSpace: 'nowrap' }}
                    >
                        No! Go for Complete
                    </AppSecondaryButton>
                </div>
            </div>
        </Popup>
    )

    const handleDragStart = (event, index) => {
        dragIndexRef.current = index
        event.dataTransfer.effectAllowed = 'move'
    }

    const handleDragOver = event => {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move'
    }

    const handleDrop = (index, event) => {
        event.preventDefault()
        const sourceIndex = dragIndexRef.current
        if (
            sourceIndex === null ||
            sourceIndex === undefined ||
            sourceIndex === index
        ) {
            return
        }

        setSelectedSectionIds(prev => {
            if (!Array.isArray(prev)) {
                return prev
            }
            const updated = [...prev]
            const [moved] = updated.splice(sourceIndex, 1)
            updated.splice(index, 0, moved)
            return updated
        })
        dragIndexRef.current = null
    }

    const handleDragEnd = () => {
        dragIndexRef.current = null
    }

    const handleContainerDrop = event => {
        event.preventDefault()
        const sourceIndex = dragIndexRef.current
        if (
            sourceIndex === null ||
            sourceIndex === undefined ||
            sourceIndex === selectedSectionIds.length - 1
        ) {
            dragIndexRef.current = null
            return
        }
        setSelectedSectionIds(prev => {
            if (!Array.isArray(prev)) return prev
            const updated = [...prev]
            const [moved] = updated.splice(sourceIndex, 1)
            updated.push(moved)
            return updated
        })
        dragIndexRef.current = null
    }

    useEffect(() => {
        if (isReopened) {
            // Find the comment section from the list
            const commentSection = list.find(section => section.SectionComment)
            if (commentSection) {
                setComment(commentSection.SectionComment)
                setIsCommentSubmitted(true)
            }
        }
    }, [list, isReopened])

    // Initialize all sections as expanded by default
    // Only update when section IDs actually change (not when question data changes)
    const sectionIdsRef = useRef(new Set())
    useEffect(() => {
        // Use processedSections as the source of truth for all available sections
        const sectionsToInitialize = Array.isArray(processedSections) && processedSections.length > 0
            ? processedSections
            : sectionsToRender

        if (Array.isArray(sectionsToInitialize) && sectionsToInitialize.length > 0) {
            const allSectionIds = new Set(sectionsToInitialize.map(s => s.SectionId))

            // Compare with previous section IDs to detect actual changes
            const prevSectionIds = sectionIdsRef.current
            const currentIdsArray = Array.from(allSectionIds).sort()
            const prevIdsArray = Array.from(prevSectionIds).sort()
            const sectionIdsChanged = currentIdsArray.length !== prevIdsArray.length ||
                currentIdsArray.some((id, index) => id !== prevIdsArray[index])

            // Only update expanded sections if section IDs actually changed
            if (sectionIdsChanged) {
                sectionIdsRef.current = allSectionIds
                setExpandedSections(prev => {
                    // If this is the first time or all sections are new, expand all
                    if (prev.size === 0) {
                        return allSectionIds
                    }
                    const updated = new Set(prev)
                    // Add new sections as expanded
                    allSectionIds.forEach(id => {
                        if (!updated.has(id)) {
                            updated.add(id)
                        }
                    })
                    // Remove sections that no longer exist
                    Array.from(updated).forEach(id => {
                        if (!allSectionIds.has(id)) {
                            updated.delete(id)
                        }
                    })
                    return updated
                })
            }
        }
    }, [processedSections, sectionsToRender])

    const handleSectionAccordionToggle = useCallback((sectionId) => {
        setExpandedSections(prev => {
            const updated = new Set(prev)
            if (updated.has(sectionId)) {
                updated.delete(sectionId)
            } else {
                updated.add(sectionId)
            }
            return updated
        })
    }, [])

    const handleExpandAll = useCallback(() => {
        if (Array.isArray(sectionsToRender) && sectionsToRender.length > 0) {
            const allSectionIds = new Set(sectionsToRender.map(s => s.SectionId))
            setExpandedSections(allSectionIds)
        }
    }, [sectionsToRender])

    const handleCollapseAll = useCallback(() => {
        setExpandedSections(new Set())
    }, [])

    const isAllExpanded = useMemo(() => {
        if (!Array.isArray(sectionsToRender) || sectionsToRender.length === 0) {
            return false
        }
        const allSectionIds = new Set(sectionsToRender.map(s => s.SectionId))
        return allSectionIds.size > 0 &&
            Array.from(allSectionIds).every(id => expandedSections.has(id))
    }, [sectionsToRender, expandedSections])

    const handleToggleExpandCollapse = useCallback(() => {
        if (isAllExpanded) {
            handleCollapseAll()
        } else {
            handleExpandAll()
        }
    }, [isAllExpanded, handleExpandAll, handleCollapseAll])

    const handleOpenModal = () => {
        setIsModalOpen(true)
    }

    const handleCloseModal = () => {
        setIsModalOpen(false)
    }

    const handleSubmitComment = async () => {
        if (comment.trim()) {
            console.log('Submitting comment with Template ID:', templateId)
            const commentData = {
                SectionComment: comment,
                IsComment: true,
                TemplateId: templateId, // Ensure this value is not undefined
            }
            try {
                const response = await InspectionService.sectionComment(
                    commentData,
                )
                console.log('API Response:', response)
                setIsCommentSubmitted(true)
                // If you want to update your component state or perform other actions with the response, you can do that here
            } catch (error) {
                console.error('Error submitting comment:', error)
            }
        }
        handleCloseModal()
    }

    const reasonPresetValue = useMemo(
        () => ({
            setting: reasonPresetSetting || null,
            auditId: inspectionTemplateId || null,
            addNotes,
        }),
        [reasonPresetSetting, inspectionTemplateId, addNotes],
    )

    return (
        <ReasonPresetInspectionContext.Provider value={reasonPresetValue}>
        <InspectionListContainer className="row mb-5">
            {loading && <LoaderBar />}
            {showSectionDropdown && sectionOptions.length > 0 && (
                <div className="col-12 mb-3">
                    <div ref={dropdownRootRef}>
                        <Dropdown
                            selection
                            multiple
                            closeOnChange={false}
                            fluid
                            options={[]}
                            value={selectedSectionIds}
                            placeholder="Select sections"
                            open={isDropdownOpened}
                            onOpen={() => setIsDropdownOpened(true)}
                            onClose={() => setIsDropdownOpened(false)}
                            search
                            searchQuery={sectionSearchTerm}
                            onSearchChange={(_, data) =>
                                setSectionSearchTerm(data.searchQuery || '')
                            }
                            renderLabel={renderSelectedLabel}
                        >
                            <Dropdown.Menu>
                                {filteredSectionOptions.length === 0 ? (
                                    <Dropdown.Item disabled>
                                        No sections found
                                    </Dropdown.Item>
                                ) : (
                                    filteredSectionOptions.map(option => (
                                        <Dropdown.Item
                                            key={option.key}
                                            active={selectedSectionIds.includes(
                                                option.value,
                                            )}
                                            onClick={event => {
                                                event.preventDefault()
                                                event.stopPropagation()
                                                handleSectionToggle(option.value)
                                            }}
                                        >
                                            {option.content}
                                        </Dropdown.Item>
                                    ))
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div
                        className="d-flex flex-wrap gap-2 mt-3"
                        onDragOver={handleDragOver}
                        onDrop={handleContainerDrop}
                        role="list"
                    >
                        {(() => {
                            // Filter out imported sections from the tags display
                            const nonImportedSelectedIds = selectedSectionIds.filter(sectionId => {
                                const section = processedSections.find(
                                    item => item.SectionId === sectionId,
                                )
                                return section && !section.IsImported && section.SectionName !== 'Imported section'
                            })

                            // Create a map from filtered index to actual index in selectedSectionIds
                            const indexMap = nonImportedSelectedIds.map(sectionId =>
                                selectedSectionIds.indexOf(sectionId),
                            )

                            if (nonImportedSelectedIds.length === 0) {
                                return (
                                    <span style={{ color: '#888' }}>
                                        No sections selected
                                    </span>
                                )
                            }

                            return nonImportedSelectedIds.map((sectionId, filteredIndex) => {
                                const actualIndex = indexMap[filteredIndex]
                                const section =
                                    processedSections.find(
                                        item => item.SectionId === sectionId,
                                    ) || {}
                                return (
                                    <div
                                        key={sectionId}
                                        role="listitem"
                                        className="d-flex align-items-center px-3 py-2"
                                        style={{
                                            border: '1px solid #d9d9d9',
                                            borderRadius: '20px',
                                            background: '#f4f6fb',
                                            cursor: 'move',
                                            userSelect: 'none',
                                            gap: '8px',
                                        }}
                                        draggable
                                        onDragStart={event =>
                                            handleDragStart(event, actualIndex)
                                        }
                                        onDragOver={handleDragOver}
                                        onDrop={event => handleDrop(actualIndex, event)}
                                        onDragEnd={handleDragEnd}
                                    >
                                        <span>{section.SectionName || 'Section'}</span>
                                        {showNumbering && (
                                            <span className="ms-2 text-muted fw-semibold">
                                                #{filteredIndex + 1}
                                            </span>
                                        )}
                                    </div>
                                )
                            })
                        })()}
                    </div>
                </div>
            )}
            {!hideSectionToolbar &&
                (sectionsToRender.length > 0 || user.CompanyId === 34930) && (
                <div className="col-12 mb-3">
                    <FlexRow className="justify-content-end align-items-center gap-4">
                        {user.CompanyId === 34930 && (
                            <div className="d-flex align-items-center me-3">
                                <span className="me-2">Show numbering</span>
                                <Controller
                                    control={control}
                                    name="showNumbering"
                                    render={({ field }) => (
                                        <Checkbox
                                            toggle
                                            checked={field.value}
                                            onChange={(_, { checked }) =>
                                                field.onChange(!!checked)
                                            }
                                        />
                                    )}
                                />
                            </div>
                        )}
                        {sectionsToRender.length > 0 && (
                            <AppPrimaryButton
                                type="button"
                                onClick={handleToggleExpandCollapse}
                            >
                                {isAllExpanded ? 'Collapse All' : 'Expand All'}
                            </AppPrimaryButton>
                        )}
                    </FlexRow>
                </div>
                )}
            {shouldUseHorizontalTable ? (
                <div className="col-12">
                    <HorizontalInspectionTable
                        sections={sectionsToRender}
                        onAnswerChanged={handleAnswerChanged}
                        errors={errors}
                        addMedia={addMedia}
                        removeMedia={removeMedia}
                        addNotes={addNotes}
                        selectedPressResponseIds={selectedPressResponseIds}
                        isPressDependencyEnabled={isPressDependencyEnabled}
                        showValidation={showValidation}
                        isReadOnly={isReadOnly}
                        horizontalTableMode={horizontalTableMode}
                        triggerSelections={triggerSelectionsByOriginalId}
                    />
                    {!hideHorizontalAddNew && (
                        <div className="d-flex justify-content-end mt-2">
                            <AppPrimaryButton
                                type="button"
                                onClick={handleAddHorizontalRow}
                            >
                                Add New
                            </AppPrimaryButton>
                        </div>
                    )}
                </div>
            ) : (
                sectionsToRender.map(ele => (
                    <div key={ele.SectionId} className="col-12">
                        <SectionBox
                            item={ele}
                            addMedia={addMedia}
                            removeMedia={removeMedia}
                            addNotes={addNotes}
                            onAnswerChanged={handleAnswerChanged}
                            errors={errors}
                            copySection={() => {
                                copySection(ele.SectionId)
                            }}
                            removeSection={() => {
                                removeSection(ele.SectionId)
                            }}
                            showValidation={showValidation}
                            printByTemplate={printByTemplate}
                            resetBySection={resetBySection}
                            isOpen={expandedSections.has(ele.SectionId)}
                            onToggle={handleSectionAccordionToggle}
                            triggerSelections={triggerSelectionsByOriginalId}
                            showNumbering={showNumbering}
                            selectedPressResponseIds={selectedPressResponseIds}
                            isPressDependencyEnabled={isPressDependencyEnabled}
                            activePressSpecificationReference={
                                activePressSpecificationReference
                            }
                            isReadOnly={isReadOnly}
                            isShowHorizontal={shouldUseHorizontalTable}
                            portalCardSectionIds={portalCardSectionIds}
                            portalCardSectionNames={portalCardSectionNames}
                            pressResetQuestionId={pressResetTarget?.questionId}
                            onPressReset={pressResetHandler}
                            onPressDown={pressDownHandler}
                            onSectionNAChange={onSectionNAChange}
                            copyButtonLabel={copyButtonLabel}
                            getCopyButtonLabel={getCopyButtonLabel}
                        />
                    </div>
                ))
            )}
            {submitError && <span>{submitError}</span>}

            {!hideFooterActions && (
            <DesktopMode>
                <FlexRowBetween
                    className={`mt-3 bottom-action-bar inspection-footer-actions ${isMobile && 'flex-column'}`}
                >
                    <div className={`d-flex ${isMobile && 'flex-column'}`}>
                        {showActionButtons && (
                            <>
                                <AppSecondaryButton
                                    fluid={isMobile}
                                    onClick={() => submit(2)}
                                >
                                    Save & Close
                                </AppSecondaryButton>
                                <AppPrimaryButton
                                    fluid={isMobile}
                                    className="ms-2"
                                    onClick={() => onReview?.()}
                                >
                                    Review
                                </AppPrimaryButton>
                                {renderCompleteButton({
                                    fluid: isMobile,
                                    className: 'ms-2',
                                })}
                            </>
                        )}

                        {isReopened && (
                            <AppPrimaryButton
                                className="ms-2"
                                onClick={handleOpenModal}
                            >
                                {isCommentSubmitted
                                    ? 'Edit Comment'
                                    : 'Add Comment'}
                            </AppPrimaryButton>
                        )}
                    </div>
                    {/* Temporarily hidden - Add Sections button for desktop */}
                    {false && !publicScreen && (
                        <div className={`${isMobile && 'col-12'}`}>
                            <AppButtonPopup
                                fluid={isMobile}
                                buttonText="Add Sections"
                                closeOnPortalMouseLeave
                                pinned
                                position="top right"
                            >
                                <TemplateList
                                    list={templateList}
                                    loading={loading}
                                    onTemplateAdd={onTemplateAdd}
                                />
                            </AppButtonPopup>
                        </div>
                    )}
                    <div className="d-flex gap-2 ms-auto">
                        {Boolean(totalQuestions) && user?.CompanyId !== 34930 && (
                            <Button className="score-button-container">Total Question: {totalQuestions}</Button>
                        )}
                        {Boolean(totalScore) && (
                            <Button className="score-button-container">Score: {totalScore}</Button>
                        )}
                    </div>
                </FlexRowBetween>
            </DesktopMode>
            )}
            <Modal open={isModalOpen} onClose={handleCloseModal} size="tiny">
                <Modal.Header>
                    {isCommentSubmitted ? 'Edit Comment' : 'Add Comment'}
                </Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Field>
                            <Label>Comment</Label>
                            <TextArea
                                placeholder="Enter your comment"
                                rows={3}
                                value={comment}
                                onChange={e => setComment(e.target.value)}
                            />
                        </Form.Field>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={handleCloseModal}>Cancel</Button>
                    <Button primary onClick={handleSubmitComment}>
                        Submit
                    </Button>
                </Modal.Actions>
            </Modal>

            {!hideFooterActions && (
            <MobileMode>
                <div className="mt-2 bottom-action-bar">
                    <FlexRowBetween>
                        {/* Temporarily hidden - Add Sections button for mobile */}
                        {false && !publicScreen && (
                            <AppButtonPopup
                                fluid={isMobile}
                                buttonText="Add Sections"
                                closeOnPortalMouseLeave
                                pinned
                                position="top left"
                            >
                                <TemplateList
                                    list={templateList}
                                    loading={loading}
                                    onTemplateAdd={onTemplateAdd}
                                />
                            </AppButtonPopup>
                        )}
                        <div className="d-flex gap-2">
                            {user?.CompanyId !== 34930 && (
                                <span className="score-button-container">
                                    <Button>Total Question: {totalQuestions}</Button>
                                </span>
                            )}
                            <span className="score-button-container">
                                <Button>Score: {totalScore}</Button>
                            </span>
                        </div>
                    </FlexRowBetween>
                    <div className="gap-y-28">
                        <div
                            className={`mt-3 d-flex ${isMobile && 'flex-column'
                                }`}
                        >
                            {showActionButtons && (
                                <>
                                    <AppSecondaryButton
                                        fluid={isMobile}
                                        onClick={() => submit(2)}
                                    >
                                        Save & Close
                                    </AppSecondaryButton>
                                    <AppPrimaryButton
                                        fluid={isMobile}
                                        className="my-3"
                                        onClick={() => onReview?.()}
                                    >
                                        Review
                                    </AppPrimaryButton>
                                    {renderCompleteButton({
                                        fluid: isMobile,
                                        className: 'my-3',
                                        popupPosition: 'bottom center',
                                    })}
                                </>
                            )}

                            {isReopened && (
                                <AppPrimaryButton
                                    fluid={isMobile}
                                    className=""
                                    onClick={handleOpenModal}
                                >
                                    {isCommentSubmitted
                                        ? 'Edit Comment'
                                        : 'Add Comment'}
                                </AppPrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </MobileMode>
            )}
        </InspectionListContainer>
        </ReasonPresetInspectionContext.Provider>
    )
}
